export var Glyphs;
(function(Glyphs) {
  Glyphs["null"] = "\0";
  Glyphs["fourStringTabClef"] = "\uE06E";
  Glyphs["sixStringTabClef"] = "\uE06D";
  Glyphs["accSagittal11LargeDiesisDown"] = "\uE30D";
  Glyphs["accSagittal11LargeDiesisUp"] = "\uE30C";
  Glyphs["accSagittal11MediumDiesisDown"] = "\uE30B";
  Glyphs["accSagittal11MediumDiesisUp"] = "\uE30A";
  Glyphs["accSagittal11v19LargeDiesisDown"] = "\uE3AB";
  Glyphs["accSagittal11v19LargeDiesisUp"] = "\uE3AA";
  Glyphs["accSagittal11v19MediumDiesisDown"] = "\uE3A3";
  Glyphs["accSagittal11v19MediumDiesisUp"] = "\uE3A2";
  Glyphs["accSagittal11v49CommaDown"] = "\uE397";
  Glyphs["accSagittal11v49CommaUp"] = "\uE396";
  Glyphs["accSagittal143CommaDown"] = "\uE395";
  Glyphs["accSagittal143CommaUp"] = "\uE394";
  Glyphs["accSagittal17CommaDown"] = "\uE343";
  Glyphs["accSagittal17CommaUp"] = "\uE342";
  Glyphs["accSagittal17KleismaDown"] = "\uE393";
  Glyphs["accSagittal17KleismaUp"] = "\uE392";
  Glyphs["accSagittal19CommaDown"] = "\uE399";
  Glyphs["accSagittal19CommaUp"] = "\uE398";
  Glyphs["accSagittal19SchismaDown"] = "\uE391";
  Glyphs["accSagittal19SchismaUp"] = "\uE390";
  Glyphs["accSagittal1MinaDown"] = "\uE3F5";
  Glyphs["accSagittal1MinaUp"] = "\uE3F4";
  Glyphs["accSagittal1TinaDown"] = "\uE3F9";
  Glyphs["accSagittal1TinaUp"] = "\uE3F8";
  Glyphs["accSagittal23CommaDown"] = "\uE371";
  Glyphs["accSagittal23CommaUp"] = "\uE370";
  Glyphs["accSagittal23SmallDiesisDown"] = "\uE39F";
  Glyphs["accSagittal23SmallDiesisUp"] = "\uE39E";
  Glyphs["accSagittal25SmallDiesisDown"] = "\uE307";
  Glyphs["accSagittal25SmallDiesisUp"] = "\uE306";
  Glyphs["accSagittal2MinasDown"] = "\uE3F7";
  Glyphs["accSagittal2MinasUp"] = "\uE3F6";
  Glyphs["accSagittal2TinasDown"] = "\uE3FB";
  Glyphs["accSagittal2TinasUp"] = "\uE3FA";
  Glyphs["accSagittal35LargeDiesisDown"] = "\uE30F";
  Glyphs["accSagittal35LargeDiesisUp"] = "\uE30E";
  Glyphs["accSagittal35MediumDiesisDown"] = "\uE309";
  Glyphs["accSagittal35MediumDiesisUp"] = "\uE308";
  Glyphs["accSagittal3TinasDown"] = "\uE3FD";
  Glyphs["accSagittal3TinasUp"] = "\uE3FC";
  Glyphs["accSagittal49LargeDiesisDown"] = "\uE3A9";
  Glyphs["accSagittal49LargeDiesisUp"] = "\uE3A8";
  Glyphs["accSagittal49MediumDiesisDown"] = "\uE3A5";
  Glyphs["accSagittal49MediumDiesisUp"] = "\uE3A4";
  Glyphs["accSagittal49SmallDiesisDown"] = "\uE39D";
  Glyphs["accSagittal49SmallDiesisUp"] = "\uE39C";
  Glyphs["accSagittal4TinasDown"] = "\uE3FF";
  Glyphs["accSagittal4TinasUp"] = "\uE3FE";
  Glyphs["accSagittal55CommaDown"] = "\uE345";
  Glyphs["accSagittal55CommaUp"] = "\uE344";
  Glyphs["accSagittal5CommaDown"] = "\uE303";
  Glyphs["accSagittal5CommaUp"] = "\uE302";
  Glyphs["accSagittal5TinasDown"] = "\uE401";
  Glyphs["accSagittal5TinasUp"] = "\uE400";
  Glyphs["accSagittal5v11SmallDiesisDown"] = "\uE349";
  Glyphs["accSagittal5v11SmallDiesisUp"] = "\uE348";
  Glyphs["accSagittal5v13LargeDiesisDown"] = "\uE3AD";
  Glyphs["accSagittal5v13LargeDiesisUp"] = "\uE3AC";
  Glyphs["accSagittal5v13MediumDiesisDown"] = "\uE3A1";
  Glyphs["accSagittal5v13MediumDiesisUp"] = "\uE3A0";
  Glyphs["accSagittal5v19CommaDown"] = "\uE373";
  Glyphs["accSagittal5v19CommaUp"] = "\uE372";
  Glyphs["accSagittal5v23SmallDiesisDown"] = "\uE375";
  Glyphs["accSagittal5v23SmallDiesisUp"] = "\uE374";
  Glyphs["accSagittal5v49MediumDiesisDown"] = "\uE3A7";
  Glyphs["accSagittal5v49MediumDiesisUp"] = "\uE3A6";
  Glyphs["accSagittal5v7KleismaDown"] = "\uE301";
  Glyphs["accSagittal5v7KleismaUp"] = "\uE300";
  Glyphs["accSagittal6TinasDown"] = "\uE403";
  Glyphs["accSagittal6TinasUp"] = "\uE402";
  Glyphs["accSagittal7CommaDown"] = "\uE305";
  Glyphs["accSagittal7CommaUp"] = "\uE304";
  Glyphs["accSagittal7TinasDown"] = "\uE405";
  Glyphs["accSagittal7TinasUp"] = "\uE404";
  Glyphs["accSagittal7v11CommaDown"] = "\uE347";
  Glyphs["accSagittal7v11CommaUp"] = "\uE346";
  Glyphs["accSagittal7v11KleismaDown"] = "\uE341";
  Glyphs["accSagittal7v11KleismaUp"] = "\uE340";
  Glyphs["accSagittal7v19CommaDown"] = "\uE39B";
  Glyphs["accSagittal7v19CommaUp"] = "\uE39A";
  Glyphs["accSagittal8TinasDown"] = "\uE407";
  Glyphs["accSagittal8TinasUp"] = "\uE406";
  Glyphs["accSagittal9TinasDown"] = "\uE409";
  Glyphs["accSagittal9TinasUp"] = "\uE408";
  Glyphs["accSagittalAcute"] = "\uE3F2";
  Glyphs["accSagittalDoubleFlat"] = "\uE335";
  Glyphs["accSagittalDoubleFlat11v49CUp"] = "\uE3E9";
  Glyphs["accSagittalDoubleFlat143CUp"] = "\uE3EB";
  Glyphs["accSagittalDoubleFlat17CUp"] = "\uE365";
  Glyphs["accSagittalDoubleFlat17kUp"] = "\uE3ED";
  Glyphs["accSagittalDoubleFlat19CUp"] = "\uE3E7";
  Glyphs["accSagittalDoubleFlat19sUp"] = "\uE3EF";
  Glyphs["accSagittalDoubleFlat23CUp"] = "\uE387";
  Glyphs["accSagittalDoubleFlat23SUp"] = "\uE3E1";
  Glyphs["accSagittalDoubleFlat25SUp"] = "\uE32D";
  Glyphs["accSagittalDoubleFlat49SUp"] = "\uE3E3";
  Glyphs["accSagittalDoubleFlat55CUp"] = "\uE363";
  Glyphs["accSagittalDoubleFlat5CUp"] = "\uE331";
  Glyphs["accSagittalDoubleFlat5v11SUp"] = "\uE35F";
  Glyphs["accSagittalDoubleFlat5v19CUp"] = "\uE385";
  Glyphs["accSagittalDoubleFlat5v23SUp"] = "\uE383";
  Glyphs["accSagittalDoubleFlat5v7kUp"] = "\uE333";
  Glyphs["accSagittalDoubleFlat7CUp"] = "\uE32F";
  Glyphs["accSagittalDoubleFlat7v11CUp"] = "\uE361";
  Glyphs["accSagittalDoubleFlat7v11kUp"] = "\uE367";
  Glyphs["accSagittalDoubleFlat7v19CUp"] = "\uE3E5";
  Glyphs["accSagittalDoubleSharp"] = "\uE334";
  Glyphs["accSagittalDoubleSharp11v49CDown"] = "\uE3E8";
  Glyphs["accSagittalDoubleSharp143CDown"] = "\uE3EA";
  Glyphs["accSagittalDoubleSharp17CDown"] = "\uE364";
  Glyphs["accSagittalDoubleSharp17kDown"] = "\uE3EC";
  Glyphs["accSagittalDoubleSharp19CDown"] = "\uE3E6";
  Glyphs["accSagittalDoubleSharp19sDown"] = "\uE3EE";
  Glyphs["accSagittalDoubleSharp23CDown"] = "\uE386";
  Glyphs["accSagittalDoubleSharp23SDown"] = "\uE3E0";
  Glyphs["accSagittalDoubleSharp25SDown"] = "\uE32C";
  Glyphs["accSagittalDoubleSharp49SDown"] = "\uE3E2";
  Glyphs["accSagittalDoubleSharp55CDown"] = "\uE362";
  Glyphs["accSagittalDoubleSharp5CDown"] = "\uE330";
  Glyphs["accSagittalDoubleSharp5v11SDown"] = "\uE35E";
  Glyphs["accSagittalDoubleSharp5v19CDown"] = "\uE384";
  Glyphs["accSagittalDoubleSharp5v23SDown"] = "\uE382";
  Glyphs["accSagittalDoubleSharp5v7kDown"] = "\uE332";
  Glyphs["accSagittalDoubleSharp7CDown"] = "\uE32E";
  Glyphs["accSagittalDoubleSharp7v11CDown"] = "\uE360";
  Glyphs["accSagittalDoubleSharp7v11kDown"] = "\uE366";
  Glyphs["accSagittalDoubleSharp7v19CDown"] = "\uE3E4";
  Glyphs["accSagittalFlat"] = "\uE319";
  Glyphs["accSagittalFlat11LDown"] = "\uE329";
  Glyphs["accSagittalFlat11MDown"] = "\uE327";
  Glyphs["accSagittalFlat11v19LDown"] = "\uE3DB";
  Glyphs["accSagittalFlat11v19MDown"] = "\uE3D3";
  Glyphs["accSagittalFlat11v49CDown"] = "\uE3C7";
  Glyphs["accSagittalFlat11v49CUp"] = "\uE3B9";
  Glyphs["accSagittalFlat143CDown"] = "\uE3C5";
  Glyphs["accSagittalFlat143CUp"] = "\uE3BB";
  Glyphs["accSagittalFlat17CDown"] = "\uE357";
  Glyphs["accSagittalFlat17CUp"] = "\uE351";
  Glyphs["accSagittalFlat17kDown"] = "\uE3C3";
  Glyphs["accSagittalFlat17kUp"] = "\uE3BD";
  Glyphs["accSagittalFlat19CDown"] = "\uE3C9";
  Glyphs["accSagittalFlat19CUp"] = "\uE3B7";
  Glyphs["accSagittalFlat19sDown"] = "\uE3C1";
  Glyphs["accSagittalFlat19sUp"] = "\uE3BF";
  Glyphs["accSagittalFlat23CDown"] = "\uE37D";
  Glyphs["accSagittalFlat23CUp"] = "\uE37B";
  Glyphs["accSagittalFlat23SDown"] = "\uE3CF";
  Glyphs["accSagittalFlat23SUp"] = "\uE3B1";
  Glyphs["accSagittalFlat25SDown"] = "\uE323";
  Glyphs["accSagittalFlat25SUp"] = "\uE311";
  Glyphs["accSagittalFlat35LDown"] = "\uE32B";
  Glyphs["accSagittalFlat35MDown"] = "\uE325";
  Glyphs["accSagittalFlat49LDown"] = "\uE3D9";
  Glyphs["accSagittalFlat49MDown"] = "\uE3D5";
  Glyphs["accSagittalFlat49SDown"] = "\uE3CD";
  Glyphs["accSagittalFlat49SUp"] = "\uE3B3";
  Glyphs["accSagittalFlat55CDown"] = "\uE359";
  Glyphs["accSagittalFlat55CUp"] = "\uE34F";
  Glyphs["accSagittalFlat5CDown"] = "\uE31F";
  Glyphs["accSagittalFlat5CUp"] = "\uE315";
  Glyphs["accSagittalFlat5v11SDown"] = "\uE35D";
  Glyphs["accSagittalFlat5v11SUp"] = "\uE34B";
  Glyphs["accSagittalFlat5v13LDown"] = "\uE3DD";
  Glyphs["accSagittalFlat5v13MDown"] = "\uE3D1";
  Glyphs["accSagittalFlat5v19CDown"] = "\uE37F";
  Glyphs["accSagittalFlat5v19CUp"] = "\uE379";
  Glyphs["accSagittalFlat5v23SDown"] = "\uE381";
  Glyphs["accSagittalFlat5v23SUp"] = "\uE377";
  Glyphs["accSagittalFlat5v49MDown"] = "\uE3D7";
  Glyphs["accSagittalFlat5v7kDown"] = "\uE31D";
  Glyphs["accSagittalFlat5v7kUp"] = "\uE317";
  Glyphs["accSagittalFlat7CDown"] = "\uE321";
  Glyphs["accSagittalFlat7CUp"] = "\uE313";
  Glyphs["accSagittalFlat7v11CDown"] = "\uE35B";
  Glyphs["accSagittalFlat7v11CUp"] = "\uE34D";
  Glyphs["accSagittalFlat7v11kDown"] = "\uE355";
  Glyphs["accSagittalFlat7v11kUp"] = "\uE353";
  Glyphs["accSagittalFlat7v19CDown"] = "\uE3CB";
  Glyphs["accSagittalFlat7v19CUp"] = "\uE3B5";
  Glyphs["accSagittalFractionalTinaDown"] = "\uE40B";
  Glyphs["accSagittalFractionalTinaUp"] = "\uE40A";
  Glyphs["accSagittalGrave"] = "\uE3F3";
  Glyphs["accSagittalShaftDown"] = "\uE3F1";
  Glyphs["accSagittalShaftUp"] = "\uE3F0";
  Glyphs["accSagittalSharp"] = "\uE318";
  Glyphs["accSagittalSharp11LUp"] = "\uE328";
  Glyphs["accSagittalSharp11MUp"] = "\uE326";
  Glyphs["accSagittalSharp11v19LUp"] = "\uE3DA";
  Glyphs["accSagittalSharp11v19MUp"] = "\uE3D2";
  Glyphs["accSagittalSharp11v49CDown"] = "\uE3B8";
  Glyphs["accSagittalSharp11v49CUp"] = "\uE3C6";
  Glyphs["accSagittalSharp143CDown"] = "\uE3BA";
  Glyphs["accSagittalSharp143CUp"] = "\uE3C4";
  Glyphs["accSagittalSharp17CDown"] = "\uE350";
  Glyphs["accSagittalSharp17CUp"] = "\uE356";
  Glyphs["accSagittalSharp17kDown"] = "\uE3BC";
  Glyphs["accSagittalSharp17kUp"] = "\uE3C2";
  Glyphs["accSagittalSharp19CDown"] = "\uE3B6";
  Glyphs["accSagittalSharp19CUp"] = "\uE3C8";
  Glyphs["accSagittalSharp19sDown"] = "\uE3BE";
  Glyphs["accSagittalSharp19sUp"] = "\uE3C0";
  Glyphs["accSagittalSharp23CDown"] = "\uE37A";
  Glyphs["accSagittalSharp23CUp"] = "\uE37C";
  Glyphs["accSagittalSharp23SDown"] = "\uE3B0";
  Glyphs["accSagittalSharp23SUp"] = "\uE3CE";
  Glyphs["accSagittalSharp25SDown"] = "\uE310";
  Glyphs["accSagittalSharp25SUp"] = "\uE322";
  Glyphs["accSagittalSharp35LUp"] = "\uE32A";
  Glyphs["accSagittalSharp35MUp"] = "\uE324";
  Glyphs["accSagittalSharp49LUp"] = "\uE3D8";
  Glyphs["accSagittalSharp49MUp"] = "\uE3D4";
  Glyphs["accSagittalSharp49SDown"] = "\uE3B2";
  Glyphs["accSagittalSharp49SUp"] = "\uE3CC";
  Glyphs["accSagittalSharp55CDown"] = "\uE34E";
  Glyphs["accSagittalSharp55CUp"] = "\uE358";
  Glyphs["accSagittalSharp5CDown"] = "\uE314";
  Glyphs["accSagittalSharp5CUp"] = "\uE31E";
  Glyphs["accSagittalSharp5v11SDown"] = "\uE34A";
  Glyphs["accSagittalSharp5v11SUp"] = "\uE35C";
  Glyphs["accSagittalSharp5v13LUp"] = "\uE3DC";
  Glyphs["accSagittalSharp5v13MUp"] = "\uE3D0";
  Glyphs["accSagittalSharp5v19CDown"] = "\uE378";
  Glyphs["accSagittalSharp5v19CUp"] = "\uE37E";
  Glyphs["accSagittalSharp5v23SDown"] = "\uE376";
  Glyphs["accSagittalSharp5v23SUp"] = "\uE380";
  Glyphs["accSagittalSharp5v49MUp"] = "\uE3D6";
  Glyphs["accSagittalSharp5v7kDown"] = "\uE316";
  Glyphs["accSagittalSharp5v7kUp"] = "\uE31C";
  Glyphs["accSagittalSharp7CDown"] = "\uE312";
  Glyphs["accSagittalSharp7CUp"] = "\uE320";
  Glyphs["accSagittalSharp7v11CDown"] = "\uE34C";
  Glyphs["accSagittalSharp7v11CUp"] = "\uE35A";
  Glyphs["accSagittalSharp7v11kDown"] = "\uE352";
  Glyphs["accSagittalSharp7v11kUp"] = "\uE354";
  Glyphs["accSagittalSharp7v19CDown"] = "\uE3B4";
  Glyphs["accSagittalSharp7v19CUp"] = "\uE3CA";
  Glyphs["accSagittalUnused1"] = "\uE31A";
  Glyphs["accSagittalUnused2"] = "\uE31B";
  Glyphs["accSagittalUnused3"] = "\uE3DE";
  Glyphs["accSagittalUnused4"] = "\uE3DF";
  Glyphs["accdnCombDot"] = "\uE8CA";
  Glyphs["accdnCombLH2RanksEmpty"] = "\uE8C8";
  Glyphs["accdnCombLH3RanksEmptySquare"] = "\uE8C9";
  Glyphs["accdnCombRH3RanksEmpty"] = "\uE8C6";
  Glyphs["accdnCombRH4RanksEmpty"] = "\uE8C7";
  Glyphs["accdnDiatonicClef"] = "\uE079";
  Glyphs["accdnLH2Ranks16Round"] = "\uE8BC";
  Glyphs["accdnLH2Ranks8Plus16Round"] = "\uE8BD";
  Glyphs["accdnLH2Ranks8Round"] = "\uE8BB";
  Glyphs["accdnLH2RanksFullMasterRound"] = "\uE8C0";
  Glyphs["accdnLH2RanksMasterPlus16Round"] = "\uE8BF";
  Glyphs["accdnLH2RanksMasterRound"] = "\uE8BE";
  Glyphs["accdnLH3Ranks2Plus8Square"] = "\uE8C4";
  Glyphs["accdnLH3Ranks2Square"] = "\uE8C2";
  Glyphs["accdnLH3Ranks8Square"] = "\uE8C1";
  Glyphs["accdnLH3RanksDouble8Square"] = "\uE8C3";
  Glyphs["accdnLH3RanksTuttiSquare"] = "\uE8C5";
  Glyphs["accdnPull"] = "\uE8CC";
  Glyphs["accdnPush"] = "\uE8CB";
  Glyphs["accdnRH3RanksAccordion"] = "\uE8AC";
  Glyphs["accdnRH3RanksAuthenticMusette"] = "\uE8A8";
  Glyphs["accdnRH3RanksBandoneon"] = "\uE8AB";
  Glyphs["accdnRH3RanksBassoon"] = "\uE8A4";
  Glyphs["accdnRH3RanksClarinet"] = "\uE8A1";
  Glyphs["accdnRH3RanksDoubleTremoloLower8ve"] = "\uE8B1";
  Glyphs["accdnRH3RanksDoubleTremoloUpper8ve"] = "\uE8B2";
  Glyphs["accdnRH3RanksFullFactory"] = "\uE8B3";
  Glyphs["accdnRH3RanksHarmonium"] = "\uE8AA";
  Glyphs["accdnRH3RanksImitationMusette"] = "\uE8A7";
  Glyphs["accdnRH3RanksLowerTremolo8"] = "\uE8A3";
  Glyphs["accdnRH3RanksMaster"] = "\uE8AD";
  Glyphs["accdnRH3RanksOboe"] = "\uE8A5";
  Glyphs["accdnRH3RanksOrgan"] = "\uE8A9";
  Glyphs["accdnRH3RanksPiccolo"] = "\uE8A0";
  Glyphs["accdnRH3RanksTremoloLower8ve"] = "\uE8AF";
  Glyphs["accdnRH3RanksTremoloUpper8ve"] = "\uE8B0";
  Glyphs["accdnRH3RanksTwoChoirs"] = "\uE8AE";
  Glyphs["accdnRH3RanksUpperTremolo8"] = "\uE8A2";
  Glyphs["accdnRH3RanksViolin"] = "\uE8A6";
  Glyphs["accdnRH4RanksAlto"] = "\uE8B5";
  Glyphs["accdnRH4RanksBassAlto"] = "\uE8BA";
  Glyphs["accdnRH4RanksMaster"] = "\uE8B7";
  Glyphs["accdnRH4RanksSoftBass"] = "\uE8B8";
  Glyphs["accdnRH4RanksSoftTenor"] = "\uE8B9";
  Glyphs["accdnRH4RanksSoprano"] = "\uE8B4";
  Glyphs["accdnRH4RanksTenor"] = "\uE8B6";
  Glyphs["accdnRicochet2"] = "\uE8CD";
  Glyphs["accdnRicochet3"] = "\uE8CE";
  Glyphs["accdnRicochet4"] = "\uE8CF";
  Glyphs["accdnRicochet5"] = "\uE8D0";
  Glyphs["accdnRicochet6"] = "\uE8D1";
  Glyphs["accdnRicochetStem2"] = "\uE8D2";
  Glyphs["accdnRicochetStem3"] = "\uE8D3";
  Glyphs["accdnRicochetStem4"] = "\uE8D4";
  Glyphs["accdnRicochetStem5"] = "\uE8D5";
  Glyphs["accdnRicochetStem6"] = "\uE8D6";
  Glyphs["accidental1CommaFlat"] = "\uE454";
  Glyphs["accidental1CommaSharp"] = "\uE450";
  Glyphs["accidental2CommaFlat"] = "\uE455";
  Glyphs["accidental2CommaSharp"] = "\uE451";
  Glyphs["accidental3CommaFlat"] = "\uE456";
  Glyphs["accidental3CommaSharp"] = "\uE452";
  Glyphs["accidental4CommaFlat"] = "\uE457";
  Glyphs["accidental5CommaSharp"] = "\uE453";
  Glyphs["accidentalArrowDown"] = "\uE27B";
  Glyphs["accidentalArrowUp"] = "\uE27A";
  Glyphs["accidentalBakiyeFlat"] = "\uE442";
  Glyphs["accidentalBakiyeSharp"] = "\uE445";
  Glyphs["accidentalBracketLeft"] = "\uE26C";
  Glyphs["accidentalBracketRight"] = "\uE26D";
  Glyphs["accidentalBuyukMucennebFlat"] = "\uE440";
  Glyphs["accidentalBuyukMucennebSharp"] = "\uE447";
  Glyphs["accidentalCombiningCloseCurlyBrace"] = "\uE2EF";
  Glyphs["accidentalCombiningLower17Schisma"] = "\uE2E6";
  Glyphs["accidentalCombiningLower19Schisma"] = "\uE2E8";
  Glyphs["accidentalCombiningLower23Limit29LimitComma"] = "\uE2EA";
  Glyphs["accidentalCombiningLower29LimitComma"] = "\uEE50";
  Glyphs["accidentalCombiningLower31Schisma"] = "\uE2EC";
  Glyphs["accidentalCombiningLower37Quartertone"] = "\uEE52";
  Glyphs["accidentalCombiningLower41Comma"] = "\uEE54";
  Glyphs["accidentalCombiningLower43Comma"] = "\uEE56";
  Glyphs["accidentalCombiningLower47Quartertone"] = "\uEE58";
  Glyphs["accidentalCombiningLower53LimitComma"] = "\uE2F7";
  Glyphs["accidentalCombiningOpenCurlyBrace"] = "\uE2EE";
  Glyphs["accidentalCombiningRaise17Schisma"] = "\uE2E7";
  Glyphs["accidentalCombiningRaise19Schisma"] = "\uE2E9";
  Glyphs["accidentalCombiningRaise23Limit29LimitComma"] = "\uE2EB";
  Glyphs["accidentalCombiningRaise29LimitComma"] = "\uEE51";
  Glyphs["accidentalCombiningRaise31Schisma"] = "\uE2ED";
  Glyphs["accidentalCombiningRaise37Quartertone"] = "\uEE53";
  Glyphs["accidentalCombiningRaise41Comma"] = "\uEE55";
  Glyphs["accidentalCombiningRaise43Comma"] = "\uEE57";
  Glyphs["accidentalCombiningRaise47Quartertone"] = "\uEE59";
  Glyphs["accidentalCombiningRaise53LimitComma"] = "\uE2F8";
  Glyphs["accidentalCommaSlashDown"] = "\uE47A";
  Glyphs["accidentalCommaSlashUp"] = "\uE479";
  Glyphs["accidentalDoubleFlat"] = "\uE264";
  Glyphs["accidentalDoubleFlatArabic"] = "\uED30";
  Glyphs["accidentalDoubleFlatEqualTempered"] = "\uE2F0";
  Glyphs["accidentalDoubleFlatOneArrowDown"] = "\uE2C0";
  Glyphs["accidentalDoubleFlatOneArrowUp"] = "\uE2C5";
  Glyphs["accidentalDoubleFlatReversed"] = "\uE483";
  Glyphs["accidentalDoubleFlatThreeArrowsDown"] = "\uE2D4";
  Glyphs["accidentalDoubleFlatThreeArrowsUp"] = "\uE2D9";
  Glyphs["accidentalDoubleFlatTurned"] = "\uE485";
  Glyphs["accidentalDoubleFlatTwoArrowsDown"] = "\uE2CA";
  Glyphs["accidentalDoubleFlatTwoArrowsUp"] = "\uE2CF";
  Glyphs["accidentalDoubleSharp"] = "\uE263";
  Glyphs["accidentalDoubleSharpArabic"] = "\uED38";
  Glyphs["accidentalDoubleSharpEqualTempered"] = "\uE2F4";
  Glyphs["accidentalDoubleSharpOneArrowDown"] = "\uE2C4";
  Glyphs["accidentalDoubleSharpOneArrowUp"] = "\uE2C9";
  Glyphs["accidentalDoubleSharpThreeArrowsDown"] = "\uE2D8";
  Glyphs["accidentalDoubleSharpThreeArrowsUp"] = "\uE2DD";
  Glyphs["accidentalDoubleSharpTwoArrowsDown"] = "\uE2CE";
  Glyphs["accidentalDoubleSharpTwoArrowsUp"] = "\uE2D3";
  Glyphs["accidentalEnharmonicAlmostEqualTo"] = "\uE2FA";
  Glyphs["accidentalEnharmonicEquals"] = "\uE2FB";
  Glyphs["accidentalEnharmonicTilde"] = "\uE2F9";
  Glyphs["accidentalFilledReversedFlatAndFlat"] = "\uE296";
  Glyphs["accidentalFilledReversedFlatAndFlatArrowDown"] = "\uE298";
  Glyphs["accidentalFilledReversedFlatAndFlatArrowUp"] = "\uE297";
  Glyphs["accidentalFilledReversedFlatArrowDown"] = "\uE293";
  Glyphs["accidentalFilledReversedFlatArrowUp"] = "\uE292";
  Glyphs["accidentalFiveQuarterTonesFlatArrowDown"] = "\uE279";
  Glyphs["accidentalFiveQuarterTonesSharpArrowUp"] = "\uE276";
  Glyphs["accidentalFlat"] = "\uE260";
  Glyphs["accidentalFlatArabic"] = "\uED32";
  Glyphs["accidentalFlatEqualTempered"] = "\uE2F1";
  Glyphs["accidentalFlatLoweredStockhausen"] = "\uED53";
  Glyphs["accidentalFlatOneArrowDown"] = "\uE2C1";
  Glyphs["accidentalFlatOneArrowUp"] = "\uE2C6";
  Glyphs["accidentalFlatRaisedStockhausen"] = "\uED52";
  Glyphs["accidentalFlatRepeatedLineStockhausen"] = "\uED5C";
  Glyphs["accidentalFlatRepeatedSpaceStockhausen"] = "\uED5B";
  Glyphs["accidentalFlatThreeArrowsDown"] = "\uE2D5";
  Glyphs["accidentalFlatThreeArrowsUp"] = "\uE2DA";
  Glyphs["accidentalFlatTurned"] = "\uE484";
  Glyphs["accidentalFlatTwoArrowsDown"] = "\uE2CB";
  Glyphs["accidentalFlatTwoArrowsUp"] = "\uE2D0";
  Glyphs["accidentalHabaFlatQuarterToneHigher"] = "\uEE65";
  Glyphs["accidentalHabaFlatThreeQuarterTonesLower"] = "\uEE69";
  Glyphs["accidentalHabaQuarterToneHigher"] = "\uEE64";
  Glyphs["accidentalHabaQuarterToneLower"] = "\uEE67";
  Glyphs["accidentalHabaSharpQuarterToneLower"] = "\uEE68";
  Glyphs["accidentalHabaSharpThreeQuarterTonesHigher"] = "\uEE66";
  Glyphs["accidentalHalfSharpArrowDown"] = "\uE29A";
  Glyphs["accidentalHalfSharpArrowUp"] = "\uE299";
  Glyphs["accidentalJohnston13"] = "\uE2B6";
  Glyphs["accidentalJohnston31"] = "\uE2B7";
  Glyphs["accidentalJohnstonDown"] = "\uE2B5";
  Glyphs["accidentalJohnstonEl"] = "\uE2B2";
  Glyphs["accidentalJohnstonMinus"] = "\uE2B1";
  Glyphs["accidentalJohnstonPlus"] = "\uE2B0";
  Glyphs["accidentalJohnstonSeven"] = "\uE2B3";
  Glyphs["accidentalJohnstonUp"] = "\uE2B4";
  Glyphs["accidentalKomaFlat"] = "\uE443";
  Glyphs["accidentalKomaSharp"] = "\uE444";
  Glyphs["accidentalKoron"] = "\uE460";
  Glyphs["accidentalKucukMucennebFlat"] = "\uE441";
  Glyphs["accidentalKucukMucennebSharp"] = "\uE446";
  Glyphs["accidentalLargeDoubleSharp"] = "\uE47D";
  Glyphs["accidentalLowerOneSeptimalComma"] = "\uE2DE";
  Glyphs["accidentalLowerOneTridecimalQuartertone"] = "\uE2E4";
  Glyphs["accidentalLowerOneUndecimalQuartertone"] = "\uE2E2";
  Glyphs["accidentalLowerTwoSeptimalCommas"] = "\uE2E0";
  Glyphs["accidentalLoweredStockhausen"] = "\uED51";
  Glyphs["accidentalNarrowReversedFlat"] = "\uE284";
  Glyphs["accidentalNarrowReversedFlatAndFlat"] = "\uE285";
  Glyphs["accidentalNatural"] = "\uE261";
  Glyphs["accidentalNaturalArabic"] = "\uED34";
  Glyphs["accidentalNaturalEqualTempered"] = "\uE2F2";
  Glyphs["accidentalNaturalFlat"] = "\uE267";
  Glyphs["accidentalNaturalLoweredStockhausen"] = "\uED55";
  Glyphs["accidentalNaturalOneArrowDown"] = "\uE2C2";
  Glyphs["accidentalNaturalOneArrowUp"] = "\uE2C7";
  Glyphs["accidentalNaturalRaisedStockhausen"] = "\uED54";
  Glyphs["accidentalNaturalReversed"] = "\uE482";
  Glyphs["accidentalNaturalSharp"] = "\uE268";
  Glyphs["accidentalNaturalThreeArrowsDown"] = "\uE2D6";
  Glyphs["accidentalNaturalThreeArrowsUp"] = "\uE2DB";
  Glyphs["accidentalNaturalTwoArrowsDown"] = "\uE2CC";
  Glyphs["accidentalNaturalTwoArrowsUp"] = "\uE2D1";
  Glyphs["accidentalOneAndAHalfSharpsArrowDown"] = "\uE29C";
  Glyphs["accidentalOneAndAHalfSharpsArrowUp"] = "\uE29B";
  Glyphs["accidentalOneQuarterToneFlatFerneyhough"] = "\uE48F";
  Glyphs["accidentalOneQuarterToneFlatStockhausen"] = "\uED59";
  Glyphs["accidentalOneQuarterToneSharpFerneyhough"] = "\uE48E";
  Glyphs["accidentalOneQuarterToneSharpStockhausen"] = "\uED58";
  Glyphs["accidentalOneThirdToneFlatFerneyhough"] = "\uE48B";
  Glyphs["accidentalOneThirdToneSharpFerneyhough"] = "\uE48A";
  Glyphs["accidentalParensLeft"] = "\uE26A";
  Glyphs["accidentalParensRight"] = "\uE26B";
  Glyphs["accidentalQuarterFlatEqualTempered"] = "\uE2F5";
  Glyphs["accidentalQuarterSharpEqualTempered"] = "\uE2F6";
  Glyphs["accidentalQuarterToneFlat4"] = "\uE47F";
  Glyphs["accidentalQuarterToneFlatArabic"] = "\uED33";
  Glyphs["accidentalQuarterToneFlatArrowUp"] = "\uE270";
  Glyphs["accidentalQuarterToneFlatFilledReversed"] = "\uE480";
  Glyphs["accidentalQuarterToneFlatNaturalArrowDown"] = "\uE273";
  Glyphs["accidentalQuarterToneFlatPenderecki"] = "\uE478";
  Glyphs["accidentalQuarterToneFlatStein"] = "\uE280";
  Glyphs["accidentalQuarterToneFlatVanBlankenburg"] = "\uE488";
  Glyphs["accidentalQuarterToneSharp4"] = "\uE47E";
  Glyphs["accidentalQuarterToneSharpArabic"] = "\uED35";
  Glyphs["accidentalQuarterToneSharpArrowDown"] = "\uE275";
  Glyphs["accidentalQuarterToneSharpBusotti"] = "\uE472";
  Glyphs["accidentalQuarterToneSharpNaturalArrowUp"] = "\uE272";
  Glyphs["accidentalQuarterToneSharpStein"] = "\uE282";
  Glyphs["accidentalQuarterToneSharpWiggle"] = "\uE475";
  Glyphs["accidentalRaiseOneSeptimalComma"] = "\uE2DF";
  Glyphs["accidentalRaiseOneTridecimalQuartertone"] = "\uE2E5";
  Glyphs["accidentalRaiseOneUndecimalQuartertone"] = "\uE2E3";
  Glyphs["accidentalRaiseTwoSeptimalCommas"] = "\uE2E1";
  Glyphs["accidentalRaisedStockhausen"] = "\uED50";
  Glyphs["accidentalReversedFlatAndFlatArrowDown"] = "\uE295";
  Glyphs["accidentalReversedFlatAndFlatArrowUp"] = "\uE294";
  Glyphs["accidentalReversedFlatArrowDown"] = "\uE291";
  Glyphs["accidentalReversedFlatArrowUp"] = "\uE290";
  Glyphs["accidentalSharp"] = "\uE262";
  Glyphs["accidentalSharpArabic"] = "\uED36";
  Glyphs["accidentalSharpEqualTempered"] = "\uE2F3";
  Glyphs["accidentalSharpLoweredStockhausen"] = "\uED57";
  Glyphs["accidentalSharpOneArrowDown"] = "\uE2C3";
  Glyphs["accidentalSharpOneArrowUp"] = "\uE2C8";
  Glyphs["accidentalSharpOneHorizontalStroke"] = "\uE473";
  Glyphs["accidentalSharpRaisedStockhausen"] = "\uED56";
  Glyphs["accidentalSharpRepeatedLineStockhausen"] = "\uED5E";
  Glyphs["accidentalSharpRepeatedSpaceStockhausen"] = "\uED5D";
  Glyphs["accidentalSharpReversed"] = "\uE481";
  Glyphs["accidentalSharpSharp"] = "\uE269";
  Glyphs["accidentalSharpThreeArrowsDown"] = "\uE2D7";
  Glyphs["accidentalSharpThreeArrowsUp"] = "\uE2DC";
  Glyphs["accidentalSharpTwoArrowsDown"] = "\uE2CD";
  Glyphs["accidentalSharpTwoArrowsUp"] = "\uE2D2";
  Glyphs["accidentalSims12Down"] = "\uE2A0";
  Glyphs["accidentalSims12Up"] = "\uE2A3";
  Glyphs["accidentalSims4Down"] = "\uE2A2";
  Glyphs["accidentalSims4Up"] = "\uE2A5";
  Glyphs["accidentalSims6Down"] = "\uE2A1";
  Glyphs["accidentalSims6Up"] = "\uE2A4";
  Glyphs["accidentalSori"] = "\uE461";
  Glyphs["accidentalTavenerFlat"] = "\uE477";
  Glyphs["accidentalTavenerSharp"] = "\uE476";
  Glyphs["accidentalThreeQuarterTonesFlatArabic"] = "\uED31";
  Glyphs["accidentalThreeQuarterTonesFlatArrowDown"] = "\uE271";
  Glyphs["accidentalThreeQuarterTonesFlatArrowUp"] = "\uE278";
  Glyphs["accidentalThreeQuarterTonesFlatCouper"] = "\uE489";
  Glyphs["accidentalThreeQuarterTonesFlatGrisey"] = "\uE486";
  Glyphs["accidentalThreeQuarterTonesFlatTartini"] = "\uE487";
  Glyphs["accidentalThreeQuarterTonesFlatZimmermann"] = "\uE281";
  Glyphs["accidentalThreeQuarterTonesSharpArabic"] = "\uED37";
  Glyphs["accidentalThreeQuarterTonesSharpArrowDown"] = "\uE277";
  Glyphs["accidentalThreeQuarterTonesSharpArrowUp"] = "\uE274";
  Glyphs["accidentalThreeQuarterTonesSharpBusotti"] = "\uE474";
  Glyphs["accidentalThreeQuarterTonesSharpStein"] = "\uE283";
  Glyphs["accidentalThreeQuarterTonesSharpStockhausen"] = "\uED5A";
  Glyphs["accidentalTripleFlat"] = "\uE266";
  Glyphs["accidentalTripleSharp"] = "\uE265";
  Glyphs["accidentalTwoThirdTonesFlatFerneyhough"] = "\uE48D";
  Glyphs["accidentalTwoThirdTonesSharpFerneyhough"] = "\uE48C";
  Glyphs["accidentalUpsAndDownsDown"] = "\uEE61";
  Glyphs["accidentalUpsAndDownsLess"] = "\uEE63";
  Glyphs["accidentalUpsAndDownsMore"] = "\uEE62";
  Glyphs["accidentalUpsAndDownsUp"] = "\uEE60";
  Glyphs["accidentalWilsonMinus"] = "\uE47C";
  Glyphs["accidentalWilsonPlus"] = "\uE47B";
  Glyphs["accidentalWyschnegradsky10TwelfthsFlat"] = "\uE434";
  Glyphs["accidentalWyschnegradsky10TwelfthsSharp"] = "\uE429";
  Glyphs["accidentalWyschnegradsky11TwelfthsFlat"] = "\uE435";
  Glyphs["accidentalWyschnegradsky11TwelfthsSharp"] = "\uE42A";
  Glyphs["accidentalWyschnegradsky1TwelfthsFlat"] = "\uE42B";
  Glyphs["accidentalWyschnegradsky1TwelfthsSharp"] = "\uE420";
  Glyphs["accidentalWyschnegradsky2TwelfthsFlat"] = "\uE42C";
  Glyphs["accidentalWyschnegradsky2TwelfthsSharp"] = "\uE421";
  Glyphs["accidentalWyschnegradsky3TwelfthsFlat"] = "\uE42D";
  Glyphs["accidentalWyschnegradsky3TwelfthsSharp"] = "\uE422";
  Glyphs["accidentalWyschnegradsky4TwelfthsFlat"] = "\uE42E";
  Glyphs["accidentalWyschnegradsky4TwelfthsSharp"] = "\uE423";
  Glyphs["accidentalWyschnegradsky5TwelfthsFlat"] = "\uE42F";
  Glyphs["accidentalWyschnegradsky5TwelfthsSharp"] = "\uE424";
  Glyphs["accidentalWyschnegradsky6TwelfthsFlat"] = "\uE430";
  Glyphs["accidentalWyschnegradsky6TwelfthsSharp"] = "\uE425";
  Glyphs["accidentalWyschnegradsky7TwelfthsFlat"] = "\uE431";
  Glyphs["accidentalWyschnegradsky7TwelfthsSharp"] = "\uE426";
  Glyphs["accidentalWyschnegradsky8TwelfthsFlat"] = "\uE432";
  Glyphs["accidentalWyschnegradsky8TwelfthsSharp"] = "\uE427";
  Glyphs["accidentalWyschnegradsky9TwelfthsFlat"] = "\uE433";
  Glyphs["accidentalWyschnegradsky9TwelfthsSharp"] = "\uE428";
  Glyphs["accidentalXenakisOneThirdToneSharp"] = "\uE470";
  Glyphs["accidentalXenakisTwoThirdTonesSharp"] = "\uE471";
  Glyphs["analyticsChoralmelodie"] = "\uE86A";
  Glyphs["analyticsEndStimme"] = "\uE863";
  Glyphs["analyticsHauptrhythmus"] = "\uE86B";
  Glyphs["analyticsHauptstimme"] = "\uE860";
  Glyphs["analyticsInversion1"] = "\uE869";
  Glyphs["analyticsNebenstimme"] = "\uE861";
  Glyphs["analyticsStartStimme"] = "\uE862";
  Glyphs["analyticsTheme"] = "\uE864";
  Glyphs["analyticsTheme1"] = "\uE868";
  Glyphs["analyticsThemeInversion"] = "\uE867";
  Glyphs["analyticsThemeRetrograde"] = "\uE865";
  Glyphs["analyticsThemeRetrogradeInversion"] = "\uE866";
  Glyphs["arpeggiato"] = "\uE63C";
  Glyphs["arpeggiatoDown"] = "\uE635";
  Glyphs["arpeggiatoUp"] = "\uE634";
  Glyphs["arrowBlackDown"] = "\uEB64";
  Glyphs["arrowBlackDownLeft"] = "\uEB65";
  Glyphs["arrowBlackDownRight"] = "\uEB63";
  Glyphs["arrowBlackLeft"] = "\uEB66";
  Glyphs["arrowBlackRight"] = "\uEB62";
  Glyphs["arrowBlackUp"] = "\uEB60";
  Glyphs["arrowBlackUpLeft"] = "\uEB67";
  Glyphs["arrowBlackUpRight"] = "\uEB61";
  Glyphs["arrowOpenDown"] = "\uEB74";
  Glyphs["arrowOpenDownLeft"] = "\uEB75";
  Glyphs["arrowOpenDownRight"] = "\uEB73";
  Glyphs["arrowOpenLeft"] = "\uEB76";
  Glyphs["arrowOpenRight"] = "\uEB72";
  Glyphs["arrowOpenUp"] = "\uEB70";
  Glyphs["arrowOpenUpLeft"] = "\uEB77";
  Glyphs["arrowOpenUpRight"] = "\uEB71";
  Glyphs["arrowWhiteDown"] = "\uEB6C";
  Glyphs["arrowWhiteDownLeft"] = "\uEB6D";
  Glyphs["arrowWhiteDownRight"] = "\uEB6B";
  Glyphs["arrowWhiteLeft"] = "\uEB6E";
  Glyphs["arrowWhiteRight"] = "\uEB6A";
  Glyphs["arrowWhiteUp"] = "\uEB68";
  Glyphs["arrowWhiteUpLeft"] = "\uEB6F";
  Glyphs["arrowWhiteUpRight"] = "\uEB69";
  Glyphs["arrowheadBlackDown"] = "\uEB7C";
  Glyphs["arrowheadBlackDownLeft"] = "\uEB7D";
  Glyphs["arrowheadBlackDownRight"] = "\uEB7B";
  Glyphs["arrowheadBlackLeft"] = "\uEB7E";
  Glyphs["arrowheadBlackRight"] = "\uEB7A";
  Glyphs["arrowheadBlackUp"] = "\uEB78";
  Glyphs["arrowheadBlackUpLeft"] = "\uEB7F";
  Glyphs["arrowheadBlackUpRight"] = "\uEB79";
  Glyphs["arrowheadOpenDown"] = "\uEB8C";
  Glyphs["arrowheadOpenDownLeft"] = "\uEB8D";
  Glyphs["arrowheadOpenDownRight"] = "\uEB8B";
  Glyphs["arrowheadOpenLeft"] = "\uEB8E";
  Glyphs["arrowheadOpenRight"] = "\uEB8A";
  Glyphs["arrowheadOpenUp"] = "\uEB88";
  Glyphs["arrowheadOpenUpLeft"] = "\uEB8F";
  Glyphs["arrowheadOpenUpRight"] = "\uEB89";
  Glyphs["arrowheadWhiteDown"] = "\uEB84";
  Glyphs["arrowheadWhiteDownLeft"] = "\uEB85";
  Glyphs["arrowheadWhiteDownRight"] = "\uEB83";
  Glyphs["arrowheadWhiteLeft"] = "\uEB86";
  Glyphs["arrowheadWhiteRight"] = "\uEB82";
  Glyphs["arrowheadWhiteUp"] = "\uEB80";
  Glyphs["arrowheadWhiteUpLeft"] = "\uEB87";
  Glyphs["arrowheadWhiteUpRight"] = "\uEB81";
  Glyphs["articAccentAbove"] = "\uE4A0";
  Glyphs["articAccentBelow"] = "\uE4A1";
  Glyphs["articAccentStaccatoAbove"] = "\uE4B0";
  Glyphs["articAccentStaccatoBelow"] = "\uE4B1";
  Glyphs["articLaissezVibrerAbove"] = "\uE4BA";
  Glyphs["articLaissezVibrerBelow"] = "\uE4BB";
  Glyphs["articMarcatoAbove"] = "\uE4AC";
  Glyphs["articMarcatoBelow"] = "\uE4AD";
  Glyphs["articMarcatoStaccatoAbove"] = "\uE4AE";
  Glyphs["articMarcatoStaccatoBelow"] = "\uE4AF";
  Glyphs["articMarcatoTenutoAbove"] = "\uE4BC";
  Glyphs["articMarcatoTenutoBelow"] = "\uE4BD";
  Glyphs["articSoftAccentAbove"] = "\uED40";
  Glyphs["articSoftAccentBelow"] = "\uED41";
  Glyphs["articSoftAccentStaccatoAbove"] = "\uED42";
  Glyphs["articSoftAccentStaccatoBelow"] = "\uED43";
  Glyphs["articSoftAccentTenutoAbove"] = "\uED44";
  Glyphs["articSoftAccentTenutoBelow"] = "\uED45";
  Glyphs["articSoftAccentTenutoStaccatoAbove"] = "\uED46";
  Glyphs["articSoftAccentTenutoStaccatoBelow"] = "\uED47";
  Glyphs["articStaccatissimoAbove"] = "\uE4A6";
  Glyphs["articStaccatissimoBelow"] = "\uE4A7";
  Glyphs["articStaccatissimoStrokeAbove"] = "\uE4AA";
  Glyphs["articStaccatissimoStrokeBelow"] = "\uE4AB";
  Glyphs["articStaccatissimoWedgeAbove"] = "\uE4A8";
  Glyphs["articStaccatissimoWedgeBelow"] = "\uE4A9";
  Glyphs["articStaccatoAbove"] = "\uE4A2";
  Glyphs["articStaccatoBelow"] = "\uE4A3";
  Glyphs["articStressAbove"] = "\uE4B6";
  Glyphs["articStressBelow"] = "\uE4B7";
  Glyphs["articTenutoAbove"] = "\uE4A4";
  Glyphs["articTenutoAccentAbove"] = "\uE4B4";
  Glyphs["articTenutoAccentBelow"] = "\uE4B5";
  Glyphs["articTenutoBelow"] = "\uE4A5";
  Glyphs["articTenutoStaccatoAbove"] = "\uE4B2";
  Glyphs["articTenutoStaccatoBelow"] = "\uE4B3";
  Glyphs["articUnstressAbove"] = "\uE4B8";
  Glyphs["articUnstressBelow"] = "\uE4B9";
  Glyphs["augmentationDot"] = "\uE1E7";
  Glyphs["barlineDashed"] = "\uE036";
  Glyphs["barlineDotted"] = "\uE037";
  Glyphs["barlineDouble"] = "\uE031";
  Glyphs["barlineFinal"] = "\uE032";
  Glyphs["barlineHeavy"] = "\uE034";
  Glyphs["barlineHeavyHeavy"] = "\uE035";
  Glyphs["barlineReverseFinal"] = "\uE033";
  Glyphs["barlineShort"] = "\uE038";
  Glyphs["barlineSingle"] = "\uE030";
  Glyphs["barlineTick"] = "\uE039";
  Glyphs["beamAccelRit1"] = "\uEAF4";
  Glyphs["beamAccelRit10"] = "\uEAFD";
  Glyphs["beamAccelRit11"] = "\uEAFE";
  Glyphs["beamAccelRit12"] = "\uEAFF";
  Glyphs["beamAccelRit13"] = "\uEB00";
  Glyphs["beamAccelRit14"] = "\uEB01";
  Glyphs["beamAccelRit15"] = "\uEB02";
  Glyphs["beamAccelRit2"] = "\uEAF5";
  Glyphs["beamAccelRit3"] = "\uEAF6";
  Glyphs["beamAccelRit4"] = "\uEAF7";
  Glyphs["beamAccelRit5"] = "\uEAF8";
  Glyphs["beamAccelRit6"] = "\uEAF9";
  Glyphs["beamAccelRit7"] = "\uEAFA";
  Glyphs["beamAccelRit8"] = "\uEAFB";
  Glyphs["beamAccelRit9"] = "\uEAFC";
  Glyphs["beamAccelRitFinal"] = "\uEB03";
  Glyphs["brace"] = "\uE000";
  Glyphs["bracket"] = "\uE002";
  Glyphs["bracketBottom"] = "\uE004";
  Glyphs["bracketTop"] = "\uE003";
  Glyphs["brassBend"] = "\uE5E3";
  Glyphs["brassDoitLong"] = "\uE5D6";
  Glyphs["brassDoitMedium"] = "\uE5D5";
  Glyphs["brassDoitShort"] = "\uE5D4";
  Glyphs["brassFallLipLong"] = "\uE5D9";
  Glyphs["brassFallLipMedium"] = "\uE5D8";
  Glyphs["brassFallLipShort"] = "\uE5D7";
  Glyphs["brassFallRoughLong"] = "\uE5DF";
  Glyphs["brassFallRoughMedium"] = "\uE5DE";
  Glyphs["brassFallRoughShort"] = "\uE5DD";
  Glyphs["brassFallSmoothLong"] = "\uE5DC";
  Glyphs["brassFallSmoothMedium"] = "\uE5DB";
  Glyphs["brassFallSmoothShort"] = "\uE5DA";
  Glyphs["brassFlip"] = "\uE5E1";
  Glyphs["brassHarmonMuteClosed"] = "\uE5E8";
  Glyphs["brassHarmonMuteStemHalfLeft"] = "\uE5E9";
  Glyphs["brassHarmonMuteStemHalfRight"] = "\uE5EA";
  Glyphs["brassHarmonMuteStemOpen"] = "\uE5EB";
  Glyphs["brassJazzTurn"] = "\uE5E4";
  Glyphs["brassLiftLong"] = "\uE5D3";
  Glyphs["brassLiftMedium"] = "\uE5D2";
  Glyphs["brassLiftShort"] = "\uE5D1";
  Glyphs["brassLiftSmoothLong"] = "\uE5EE";
  Glyphs["brassLiftSmoothMedium"] = "\uE5ED";
  Glyphs["brassLiftSmoothShort"] = "\uE5EC";
  Glyphs["brassMuteClosed"] = "\uE5E5";
  Glyphs["brassMuteHalfClosed"] = "\uE5E6";
  Glyphs["brassMuteOpen"] = "\uE5E7";
  Glyphs["brassPlop"] = "\uE5E0";
  Glyphs["brassScoop"] = "\uE5D0";
  Glyphs["brassSmear"] = "\uE5E2";
  Glyphs["brassValveTrill"] = "\uE5EF";
  Glyphs["breathMarkComma"] = "\uE4CE";
  Glyphs["breathMarkSalzedo"] = "\uE4D5";
  Glyphs["breathMarkTick"] = "\uE4CF";
  Glyphs["breathMarkUpbow"] = "\uE4D0";
  Glyphs["bridgeClef"] = "\uE078";
  Glyphs["buzzRoll"] = "\uE22A";
  Glyphs["cClef"] = "\uE05C";
  Glyphs["cClef8vb"] = "\uE05D";
  Glyphs["cClefArrowDown"] = "\uE05F";
  Glyphs["cClefArrowUp"] = "\uE05E";
  Glyphs["cClefChange"] = "\uE07B";
  Glyphs["cClefCombining"] = "\uE061";
  Glyphs["cClefReversed"] = "\uE075";
  Glyphs["cClefSquare"] = "\uE060";
  Glyphs["caesura"] = "\uE4D1";
  Glyphs["caesuraCurved"] = "\uE4D4";
  Glyphs["caesuraShort"] = "\uE4D3";
  Glyphs["caesuraSingleStroke"] = "\uE4D7";
  Glyphs["caesuraThick"] = "\uE4D2";
  Glyphs["chantAccentusAbove"] = "\uE9D6";
  Glyphs["chantAccentusBelow"] = "\uE9D7";
  Glyphs["chantAuctumAsc"] = "\uE994";
  Glyphs["chantAuctumDesc"] = "\uE995";
  Glyphs["chantAugmentum"] = "\uE9D9";
  Glyphs["chantCaesura"] = "\uE8F8";
  Glyphs["chantCclef"] = "\uE906";
  Glyphs["chantCirculusAbove"] = "\uE9D2";
  Glyphs["chantCirculusBelow"] = "\uE9D3";
  Glyphs["chantConnectingLineAsc2nd"] = "\uE9BD";
  Glyphs["chantConnectingLineAsc3rd"] = "\uE9BE";
  Glyphs["chantConnectingLineAsc4th"] = "\uE9BF";
  Glyphs["chantConnectingLineAsc5th"] = "\uE9C0";
  Glyphs["chantConnectingLineAsc6th"] = "\uE9C1";
  Glyphs["chantCustosStemDownPosHigh"] = "\uEA08";
  Glyphs["chantCustosStemDownPosHighest"] = "\uEA09";
  Glyphs["chantCustosStemDownPosMiddle"] = "\uEA07";
  Glyphs["chantCustosStemUpPosLow"] = "\uEA05";
  Glyphs["chantCustosStemUpPosLowest"] = "\uEA04";
  Glyphs["chantCustosStemUpPosMiddle"] = "\uEA06";
  Glyphs["chantDeminutumLower"] = "\uE9B3";
  Glyphs["chantDeminutumUpper"] = "\uE9B2";
  Glyphs["chantDivisioFinalis"] = "\uE8F6";
  Glyphs["chantDivisioMaior"] = "\uE8F4";
  Glyphs["chantDivisioMaxima"] = "\uE8F5";
  Glyphs["chantDivisioMinima"] = "\uE8F3";
  Glyphs["chantEntryLineAsc2nd"] = "\uE9B4";
  Glyphs["chantEntryLineAsc3rd"] = "\uE9B5";
  Glyphs["chantEntryLineAsc4th"] = "\uE9B6";
  Glyphs["chantEntryLineAsc5th"] = "\uE9B7";
  Glyphs["chantEntryLineAsc6th"] = "\uE9B8";
  Glyphs["chantEpisema"] = "\uE9D8";
  Glyphs["chantFclef"] = "\uE902";
  Glyphs["chantIctusAbove"] = "\uE9D0";
  Glyphs["chantIctusBelow"] = "\uE9D1";
  Glyphs["chantLigaturaDesc2nd"] = "\uE9B9";
  Glyphs["chantLigaturaDesc3rd"] = "\uE9BA";
  Glyphs["chantLigaturaDesc4th"] = "\uE9BB";
  Glyphs["chantLigaturaDesc5th"] = "\uE9BC";
  Glyphs["chantOriscusAscending"] = "\uE99C";
  Glyphs["chantOriscusDescending"] = "\uE99D";
  Glyphs["chantOriscusLiquescens"] = "\uE99E";
  Glyphs["chantPodatusLower"] = "\uE9B0";
  Glyphs["chantPodatusUpper"] = "\uE9B1";
  Glyphs["chantPunctum"] = "\uE990";
  Glyphs["chantPunctumCavum"] = "\uE998";
  Glyphs["chantPunctumDeminutum"] = "\uE9A1";
  Glyphs["chantPunctumInclinatum"] = "\uE991";
  Glyphs["chantPunctumInclinatumAuctum"] = "\uE992";
  Glyphs["chantPunctumInclinatumDeminutum"] = "\uE993";
  Glyphs["chantPunctumLinea"] = "\uE999";
  Glyphs["chantPunctumLineaCavum"] = "\uE99A";
  Glyphs["chantPunctumVirga"] = "\uE996";
  Glyphs["chantPunctumVirgaReversed"] = "\uE997";
  Glyphs["chantQuilisma"] = "\uE99B";
  Glyphs["chantSemicirculusAbove"] = "\uE9D4";
  Glyphs["chantSemicirculusBelow"] = "\uE9D5";
  Glyphs["chantStaff"] = "\uE8F0";
  Glyphs["chantStaffNarrow"] = "\uE8F2";
  Glyphs["chantStaffWide"] = "\uE8F1";
  Glyphs["chantStrophicus"] = "\uE99F";
  Glyphs["chantStrophicusAuctus"] = "\uE9A0";
  Glyphs["chantStrophicusLiquescens2nd"] = "\uE9C2";
  Glyphs["chantStrophicusLiquescens3rd"] = "\uE9C3";
  Glyphs["chantStrophicusLiquescens4th"] = "\uE9C4";
  Glyphs["chantStrophicusLiquescens5th"] = "\uE9C5";
  Glyphs["chantVirgula"] = "\uE8F7";
  Glyphs["clef15"] = "\uE07E";
  Glyphs["clef8"] = "\uE07D";
  Glyphs["clefChangeCombining"] = "\uE07F";
  Glyphs["coda"] = "\uE048";
  Glyphs["codaSquare"] = "\uE049";
  Glyphs["conductorBeat2Compound"] = "\uE897";
  Glyphs["conductorBeat2Simple"] = "\uE894";
  Glyphs["conductorBeat3Compound"] = "\uE898";
  Glyphs["conductorBeat3Simple"] = "\uE895";
  Glyphs["conductorBeat4Compound"] = "\uE899";
  Glyphs["conductorBeat4Simple"] = "\uE896";
  Glyphs["conductorLeftBeat"] = "\uE891";
  Glyphs["conductorRightBeat"] = "\uE892";
  Glyphs["conductorStrongBeat"] = "\uE890";
  Glyphs["conductorUnconducted"] = "\uE89A";
  Glyphs["conductorWeakBeat"] = "\uE893";
  Glyphs["controlBeginBeam"] = "\uE8E0";
  Glyphs["controlBeginPhrase"] = "\uE8E6";
  Glyphs["controlBeginSlur"] = "\uE8E4";
  Glyphs["controlBeginTie"] = "\uE8E2";
  Glyphs["controlEndBeam"] = "\uE8E1";
  Glyphs["controlEndPhrase"] = "\uE8E7";
  Glyphs["controlEndSlur"] = "\uE8E5";
  Glyphs["controlEndTie"] = "\uE8E3";
  Glyphs["csymAccidentalDoubleFlat"] = "\uED64";
  Glyphs["csymAccidentalDoubleSharp"] = "\uED63";
  Glyphs["csymAccidentalFlat"] = "\uED60";
  Glyphs["csymAccidentalNatural"] = "\uED61";
  Glyphs["csymAccidentalSharp"] = "\uED62";
  Glyphs["csymAccidentalTripleFlat"] = "\uED66";
  Glyphs["csymAccidentalTripleSharp"] = "\uED65";
  Glyphs["csymAlteredBassSlash"] = "\uE87B";
  Glyphs["csymAugmented"] = "\uE872";
  Glyphs["csymBracketLeftTall"] = "\uE877";
  Glyphs["csymBracketRightTall"] = "\uE878";
  Glyphs["csymDiagonalArrangementSlash"] = "\uE87C";
  Glyphs["csymDiminished"] = "\uE870";
  Glyphs["csymHalfDiminished"] = "\uE871";
  Glyphs["csymMajorSeventh"] = "\uE873";
  Glyphs["csymMinor"] = "\uE874";
  Glyphs["csymParensLeftTall"] = "\uE875";
  Glyphs["csymParensLeftVeryTall"] = "\uE879";
  Glyphs["csymParensRightTall"] = "\uE876";
  Glyphs["csymParensRightVeryTall"] = "\uE87A";
  Glyphs["curlewSign"] = "\uE4D6";
  Glyphs["daCapo"] = "\uE046";
  Glyphs["dalSegno"] = "\uE045";
  Glyphs["daseianExcellentes1"] = "\uEA3C";
  Glyphs["daseianExcellentes2"] = "\uEA3D";
  Glyphs["daseianExcellentes3"] = "\uEA3E";
  Glyphs["daseianExcellentes4"] = "\uEA3F";
  Glyphs["daseianFinales1"] = "\uEA34";
  Glyphs["daseianFinales2"] = "\uEA35";
  Glyphs["daseianFinales3"] = "\uEA36";
  Glyphs["daseianFinales4"] = "\uEA37";
  Glyphs["daseianGraves1"] = "\uEA30";
  Glyphs["daseianGraves2"] = "\uEA31";
  Glyphs["daseianGraves3"] = "\uEA32";
  Glyphs["daseianGraves4"] = "\uEA33";
  Glyphs["daseianResidua1"] = "\uEA40";
  Glyphs["daseianResidua2"] = "\uEA41";
  Glyphs["daseianSuperiores1"] = "\uEA38";
  Glyphs["daseianSuperiores2"] = "\uEA39";
  Glyphs["daseianSuperiores3"] = "\uEA3A";
  Glyphs["daseianSuperiores4"] = "\uEA3B";
  Glyphs["doubleLateralRollStevens"] = "\uE234";
  Glyphs["doubleTongueAbove"] = "\uE5F0";
  Glyphs["doubleTongueBelow"] = "\uE5F1";
  Glyphs["dynamicCombinedSeparatorColon"] = "\uE546";
  Glyphs["dynamicCombinedSeparatorHyphen"] = "\uE547";
  Glyphs["dynamicCombinedSeparatorSlash"] = "\uE549";
  Glyphs["dynamicCombinedSeparatorSpace"] = "\uE548";
  Glyphs["dynamicCrescendoHairpin"] = "\uE53E";
  Glyphs["dynamicDiminuendoHairpin"] = "\uE53F";
  Glyphs["dynamicFF"] = "\uE52F";
  Glyphs["dynamicFFF"] = "\uE530";
  Glyphs["dynamicFFFF"] = "\uE531";
  Glyphs["dynamicFFFFF"] = "\uE532";
  Glyphs["dynamicFFFFFF"] = "\uE533";
  Glyphs["dynamicForte"] = "\uE522";
  Glyphs["dynamicFortePiano"] = "\uE534";
  Glyphs["dynamicForzando"] = "\uE535";
  Glyphs["dynamicHairpinBracketLeft"] = "\uE544";
  Glyphs["dynamicHairpinBracketRight"] = "\uE545";
  Glyphs["dynamicHairpinParenthesisLeft"] = "\uE542";
  Glyphs["dynamicHairpinParenthesisRight"] = "\uE543";
  Glyphs["dynamicMF"] = "\uE52D";
  Glyphs["dynamicMP"] = "\uE52C";
  Glyphs["dynamicMessaDiVoce"] = "\uE540";
  Glyphs["dynamicMezzo"] = "\uE521";
  Glyphs["dynamicNiente"] = "\uE526";
  Glyphs["dynamicNienteForHairpin"] = "\uE541";
  Glyphs["dynamicPF"] = "\uE52E";
  Glyphs["dynamicPP"] = "\uE52B";
  Glyphs["dynamicPPP"] = "\uE52A";
  Glyphs["dynamicPPPP"] = "\uE529";
  Glyphs["dynamicPPPPP"] = "\uE528";
  Glyphs["dynamicPPPPPP"] = "\uE527";
  Glyphs["dynamicPiano"] = "\uE520";
  Glyphs["dynamicRinforzando"] = "\uE523";
  Glyphs["dynamicRinforzando1"] = "\uE53C";
  Glyphs["dynamicRinforzando2"] = "\uE53D";
  Glyphs["dynamicSforzando"] = "\uE524";
  Glyphs["dynamicSforzando1"] = "\uE536";
  Glyphs["dynamicSforzandoPianissimo"] = "\uE538";
  Glyphs["dynamicSforzandoPiano"] = "\uE537";
  Glyphs["dynamicSforzato"] = "\uE539";
  Glyphs["dynamicSforzatoFF"] = "\uE53B";
  Glyphs["dynamicSforzatoPiano"] = "\uE53A";
  Glyphs["dynamicZ"] = "\uE525";
  Glyphs["elecAudioChannelsEight"] = "\uEB46";
  Glyphs["elecAudioChannelsFive"] = "\uEB43";
  Glyphs["elecAudioChannelsFour"] = "\uEB42";
  Glyphs["elecAudioChannelsOne"] = "\uEB3E";
  Glyphs["elecAudioChannelsSeven"] = "\uEB45";
  Glyphs["elecAudioChannelsSix"] = "\uEB44";
  Glyphs["elecAudioChannelsThreeFrontal"] = "\uEB40";
  Glyphs["elecAudioChannelsThreeSurround"] = "\uEB41";
  Glyphs["elecAudioChannelsTwo"] = "\uEB3F";
  Glyphs["elecAudioIn"] = "\uEB49";
  Glyphs["elecAudioMono"] = "\uEB3C";
  Glyphs["elecAudioOut"] = "\uEB4A";
  Glyphs["elecAudioStereo"] = "\uEB3D";
  Glyphs["elecCamera"] = "\uEB1B";
  Glyphs["elecDataIn"] = "\uEB4D";
  Glyphs["elecDataOut"] = "\uEB4E";
  Glyphs["elecDisc"] = "\uEB13";
  Glyphs["elecDownload"] = "\uEB4F";
  Glyphs["elecEject"] = "\uEB2B";
  Glyphs["elecFastForward"] = "\uEB1F";
  Glyphs["elecHeadphones"] = "\uEB11";
  Glyphs["elecHeadset"] = "\uEB12";
  Glyphs["elecLineIn"] = "\uEB47";
  Glyphs["elecLineOut"] = "\uEB48";
  Glyphs["elecLoop"] = "\uEB23";
  Glyphs["elecLoudspeaker"] = "\uEB1A";
  Glyphs["elecMIDIController0"] = "\uEB36";
  Glyphs["elecMIDIController100"] = "\uEB3B";
  Glyphs["elecMIDIController20"] = "\uEB37";
  Glyphs["elecMIDIController40"] = "\uEB38";
  Glyphs["elecMIDIController60"] = "\uEB39";
  Glyphs["elecMIDIController80"] = "\uEB3A";
  Glyphs["elecMIDIIn"] = "\uEB34";
  Glyphs["elecMIDIOut"] = "\uEB35";
  Glyphs["elecMicrophone"] = "\uEB10";
  Glyphs["elecMicrophoneMute"] = "\uEB28";
  Glyphs["elecMicrophoneUnmute"] = "\uEB29";
  Glyphs["elecMixingConsole"] = "\uEB15";
  Glyphs["elecMonitor"] = "\uEB18";
  Glyphs["elecMute"] = "\uEB26";
  Glyphs["elecPause"] = "\uEB1E";
  Glyphs["elecPlay"] = "\uEB1C";
  Glyphs["elecPowerOnOff"] = "\uEB2A";
  Glyphs["elecProjector"] = "\uEB19";
  Glyphs["elecReplay"] = "\uEB24";
  Glyphs["elecRewind"] = "\uEB20";
  Glyphs["elecShuffle"] = "\uEB25";
  Glyphs["elecSkipBackwards"] = "\uEB22";
  Glyphs["elecSkipForwards"] = "\uEB21";
  Glyphs["elecStop"] = "\uEB1D";
  Glyphs["elecTape"] = "\uEB14";
  Glyphs["elecUSB"] = "\uEB16";
  Glyphs["elecUnmute"] = "\uEB27";
  Glyphs["elecUpload"] = "\uEB50";
  Glyphs["elecVideoCamera"] = "\uEB17";
  Glyphs["elecVideoIn"] = "\uEB4B";
  Glyphs["elecVideoOut"] = "\uEB4C";
  Glyphs["elecVolumeFader"] = "\uEB2C";
  Glyphs["elecVolumeFaderThumb"] = "\uEB2D";
  Glyphs["elecVolumeLevel0"] = "\uEB2E";
  Glyphs["elecVolumeLevel100"] = "\uEB33";
  Glyphs["elecVolumeLevel20"] = "\uEB2F";
  Glyphs["elecVolumeLevel40"] = "\uEB30";
  Glyphs["elecVolumeLevel60"] = "\uEB31";
  Glyphs["elecVolumeLevel80"] = "\uEB32";
  Glyphs["fClef"] = "\uE062";
  Glyphs["fClef15ma"] = "\uE066";
  Glyphs["fClef15mb"] = "\uE063";
  Glyphs["fClef8va"] = "\uE065";
  Glyphs["fClef8vb"] = "\uE064";
  Glyphs["fClefArrowDown"] = "\uE068";
  Glyphs["fClefArrowUp"] = "\uE067";
  Glyphs["fClefChange"] = "\uE07C";
  Glyphs["fClefReversed"] = "\uE076";
  Glyphs["fClefTurned"] = "\uE077";
  Glyphs["fermataAbove"] = "\uE4C0";
  Glyphs["fermataBelow"] = "\uE4C1";
  Glyphs["fermataLongAbove"] = "\uE4C6";
  Glyphs["fermataLongBelow"] = "\uE4C7";
  Glyphs["fermataLongHenzeAbove"] = "\uE4CA";
  Glyphs["fermataLongHenzeBelow"] = "\uE4CB";
  Glyphs["fermataShortAbove"] = "\uE4C4";
  Glyphs["fermataShortBelow"] = "\uE4C5";
  Glyphs["fermataShortHenzeAbove"] = "\uE4CC";
  Glyphs["fermataShortHenzeBelow"] = "\uE4CD";
  Glyphs["fermataVeryLongAbove"] = "\uE4C8";
  Glyphs["fermataVeryLongBelow"] = "\uE4C9";
  Glyphs["fermataVeryShortAbove"] = "\uE4C2";
  Glyphs["fermataVeryShortBelow"] = "\uE4C3";
  Glyphs["figbass0"] = "\uEA50";
  Glyphs["figbass1"] = "\uEA51";
  Glyphs["figbass2"] = "\uEA52";
  Glyphs["figbass2Raised"] = "\uEA53";
  Glyphs["figbass3"] = "\uEA54";
  Glyphs["figbass4"] = "\uEA55";
  Glyphs["figbass4Raised"] = "\uEA56";
  Glyphs["figbass5"] = "\uEA57";
  Glyphs["figbass5Raised1"] = "\uEA58";
  Glyphs["figbass5Raised2"] = "\uEA59";
  Glyphs["figbass5Raised3"] = "\uEA5A";
  Glyphs["figbass6"] = "\uEA5B";
  Glyphs["figbass6Raised"] = "\uEA5C";
  Glyphs["figbass6Raised2"] = "\uEA6F";
  Glyphs["figbass7"] = "\uEA5D";
  Glyphs["figbass7Diminished"] = "\uECC0";
  Glyphs["figbass7Raised1"] = "\uEA5E";
  Glyphs["figbass7Raised2"] = "\uEA5F";
  Glyphs["figbass8"] = "\uEA60";
  Glyphs["figbass9"] = "\uEA61";
  Glyphs["figbass9Raised"] = "\uEA62";
  Glyphs["figbassBracketLeft"] = "\uEA68";
  Glyphs["figbassBracketRight"] = "\uEA69";
  Glyphs["figbassCombiningLowering"] = "\uEA6E";
  Glyphs["figbassCombiningRaising"] = "\uEA6D";
  Glyphs["figbassDoubleFlat"] = "\uEA63";
  Glyphs["figbassDoubleSharp"] = "\uEA67";
  Glyphs["figbassFlat"] = "\uEA64";
  Glyphs["figbassNatural"] = "\uEA65";
  Glyphs["figbassParensLeft"] = "\uEA6A";
  Glyphs["figbassParensRight"] = "\uEA6B";
  Glyphs["figbassPlus"] = "\uEA6C";
  Glyphs["figbassSharp"] = "\uEA66";
  Glyphs["figbassTripleFlat"] = "\uECC1";
  Glyphs["figbassTripleSharp"] = "\uECC2";
  Glyphs["fingering0"] = "\uED10";
  Glyphs["fingering0Italic"] = "\uED80";
  Glyphs["fingering1"] = "\uED11";
  Glyphs["fingering1Italic"] = "\uED81";
  Glyphs["fingering2"] = "\uED12";
  Glyphs["fingering2Italic"] = "\uED82";
  Glyphs["fingering3"] = "\uED13";
  Glyphs["fingering3Italic"] = "\uED83";
  Glyphs["fingering4"] = "\uED14";
  Glyphs["fingering4Italic"] = "\uED84";
  Glyphs["fingering5"] = "\uED15";
  Glyphs["fingering5Italic"] = "\uED85";
  Glyphs["fingering6"] = "\uED24";
  Glyphs["fingering6Italic"] = "\uED86";
  Glyphs["fingering7"] = "\uED25";
  Glyphs["fingering7Italic"] = "\uED87";
  Glyphs["fingering8"] = "\uED26";
  Glyphs["fingering8Italic"] = "\uED88";
  Glyphs["fingering9"] = "\uED27";
  Glyphs["fingering9Italic"] = "\uED89";
  Glyphs["fingeringALower"] = "\uED1B";
  Glyphs["fingeringCLower"] = "\uED1C";
  Glyphs["fingeringELower"] = "\uED1E";
  Glyphs["fingeringILower"] = "\uED19";
  Glyphs["fingeringLeftBracket"] = "\uED2A";
  Glyphs["fingeringLeftBracketItalic"] = "\uED8C";
  Glyphs["fingeringLeftParenthesis"] = "\uED28";
  Glyphs["fingeringLeftParenthesisItalic"] = "\uED8A";
  Glyphs["fingeringMLower"] = "\uED1A";
  Glyphs["fingeringMultipleNotes"] = "\uED23";
  Glyphs["fingeringOLower"] = "\uED1F";
  Glyphs["fingeringPLower"] = "\uED17";
  Glyphs["fingeringQLower"] = "\uED8E";
  Glyphs["fingeringRightBracket"] = "\uED2B";
  Glyphs["fingeringRightBracketItalic"] = "\uED8D";
  Glyphs["fingeringRightParenthesis"] = "\uED29";
  Glyphs["fingeringRightParenthesisItalic"] = "\uED8B";
  Glyphs["fingeringSLower"] = "\uED8F";
  Glyphs["fingeringSeparatorMiddleDot"] = "\uED2C";
  Glyphs["fingeringSeparatorMiddleDotWhite"] = "\uED2D";
  Glyphs["fingeringSeparatorSlash"] = "\uED2E";
  Glyphs["fingeringSubstitutionAbove"] = "\uED20";
  Glyphs["fingeringSubstitutionBelow"] = "\uED21";
  Glyphs["fingeringSubstitutionDash"] = "\uED22";
  Glyphs["fingeringTLower"] = "\uED18";
  Glyphs["fingeringTUpper"] = "\uED16";
  Glyphs["fingeringXLower"] = "\uED1D";
  Glyphs["flag1024thDown"] = "\uE24F";
  Glyphs["flag1024thUp"] = "\uE24E";
  Glyphs["flag128thDown"] = "\uE249";
  Glyphs["flag128thUp"] = "\uE248";
  Glyphs["flag16thDown"] = "\uE243";
  Glyphs["flag16thUp"] = "\uE242";
  Glyphs["flag256thDown"] = "\uE24B";
  Glyphs["flag256thUp"] = "\uE24A";
  Glyphs["flag32ndDown"] = "\uE245";
  Glyphs["flag32ndUp"] = "\uE244";
  Glyphs["flag512thDown"] = "\uE24D";
  Glyphs["flag512thUp"] = "\uE24C";
  Glyphs["flag64thDown"] = "\uE247";
  Glyphs["flag64thUp"] = "\uE246";
  Glyphs["flag8thDown"] = "\uE241";
  Glyphs["flag8thUp"] = "\uE240";
  Glyphs["flagInternalDown"] = "\uE251";
  Glyphs["flagInternalUp"] = "\uE250";
  Glyphs["fretboard3String"] = "\uE850";
  Glyphs["fretboard3StringNut"] = "\uE851";
  Glyphs["fretboard4String"] = "\uE852";
  Glyphs["fretboard4StringNut"] = "\uE853";
  Glyphs["fretboard5String"] = "\uE854";
  Glyphs["fretboard5StringNut"] = "\uE855";
  Glyphs["fretboard6String"] = "\uE856";
  Glyphs["fretboard6StringNut"] = "\uE857";
  Glyphs["fretboardFilledCircle"] = "\uE858";
  Glyphs["fretboardO"] = "\uE85A";
  Glyphs["fretboardX"] = "\uE859";
  Glyphs["functionAngleLeft"] = "\uEA93";
  Glyphs["functionAngleRight"] = "\uEA94";
  Glyphs["functionBracketLeft"] = "\uEA8F";
  Glyphs["functionBracketRight"] = "\uEA90";
  Glyphs["functionDD"] = "\uEA81";
  Glyphs["functionDLower"] = "\uEA80";
  Glyphs["functionDUpper"] = "\uEA7F";
  Glyphs["functionEight"] = "\uEA78";
  Glyphs["functionFUpper"] = "\uEA99";
  Glyphs["functionFive"] = "\uEA75";
  Glyphs["functionFour"] = "\uEA74";
  Glyphs["functionGLower"] = "\uEA84";
  Glyphs["functionGUpper"] = "\uEA83";
  Glyphs["functionGreaterThan"] = "\uEA7C";
  Glyphs["functionILower"] = "\uEA9B";
  Glyphs["functionIUpper"] = "\uEA9A";
  Glyphs["functionKLower"] = "\uEA9D";
  Glyphs["functionKUpper"] = "\uEA9C";
  Glyphs["functionLLower"] = "\uEA9F";
  Glyphs["functionLUpper"] = "\uEA9E";
  Glyphs["functionLessThan"] = "\uEA7A";
  Glyphs["functionMLower"] = "\uED01";
  Glyphs["functionMUpper"] = "\uED00";
  Glyphs["functionMinus"] = "\uEA7B";
  Glyphs["functionNLower"] = "\uEA86";
  Glyphs["functionNUpper"] = "\uEA85";
  Glyphs["functionNUpperSuperscript"] = "\uED02";
  Glyphs["functionNine"] = "\uEA79";
  Glyphs["functionOne"] = "\uEA71";
  Glyphs["functionPLower"] = "\uEA88";
  Glyphs["functionPUpper"] = "\uEA87";
  Glyphs["functionParensLeft"] = "\uEA91";
  Glyphs["functionParensRight"] = "\uEA92";
  Glyphs["functionPlus"] = "\uEA98";
  Glyphs["functionRLower"] = "\uED03";
  Glyphs["functionRepetition1"] = "\uEA95";
  Glyphs["functionRepetition2"] = "\uEA96";
  Glyphs["functionRing"] = "\uEA97";
  Glyphs["functionSLower"] = "\uEA8A";
  Glyphs["functionSSLower"] = "\uEA7E";
  Glyphs["functionSSUpper"] = "\uEA7D";
  Glyphs["functionSUpper"] = "\uEA89";
  Glyphs["functionSeven"] = "\uEA77";
  Glyphs["functionSix"] = "\uEA76";
  Glyphs["functionSlashedDD"] = "\uEA82";
  Glyphs["functionTLower"] = "\uEA8C";
  Glyphs["functionTUpper"] = "\uEA8B";
  Glyphs["functionThree"] = "\uEA73";
  Glyphs["functionTwo"] = "\uEA72";
  Glyphs["functionVLower"] = "\uEA8E";
  Glyphs["functionVUpper"] = "\uEA8D";
  Glyphs["functionZero"] = "\uEA70";
  Glyphs["gClef"] = "\uE050";
  Glyphs["gClef15ma"] = "\uE054";
  Glyphs["gClef15mb"] = "\uE051";
  Glyphs["gClef8va"] = "\uE053";
  Glyphs["gClef8vb"] = "\uE052";
  Glyphs["gClef8vbCClef"] = "\uE056";
  Glyphs["gClef8vbOld"] = "\uE055";
  Glyphs["gClef8vbParens"] = "\uE057";
  Glyphs["gClefArrowDown"] = "\uE05B";
  Glyphs["gClefArrowUp"] = "\uE05A";
  Glyphs["gClefChange"] = "\uE07A";
  Glyphs["gClefLigatedNumberAbove"] = "\uE059";
  Glyphs["gClefLigatedNumberBelow"] = "\uE058";
  Glyphs["gClefReversed"] = "\uE073";
  Glyphs["gClefTurned"] = "\uE074";
  Glyphs["glissandoDown"] = "\uE586";
  Glyphs["glissandoUp"] = "\uE585";
  Glyphs["graceNoteAcciaccaturaStemDown"] = "\uE561";
  Glyphs["graceNoteAcciaccaturaStemUp"] = "\uE560";
  Glyphs["graceNoteAppoggiaturaStemDown"] = "\uE563";
  Glyphs["graceNoteAppoggiaturaStemUp"] = "\uE562";
  Glyphs["graceNoteSlashStemDown"] = "\uE565";
  Glyphs["graceNoteSlashStemUp"] = "\uE564";
  Glyphs["guitarBarreFull"] = "\uE848";
  Glyphs["guitarBarreHalf"] = "\uE849";
  Glyphs["guitarClosePedal"] = "\uE83F";
  Glyphs["guitarFadeIn"] = "\uE843";
  Glyphs["guitarFadeOut"] = "\uE844";
  Glyphs["guitarGolpe"] = "\uE842";
  Glyphs["guitarHalfOpenPedal"] = "\uE83E";
  Glyphs["guitarLeftHandTapping"] = "\uE840";
  Glyphs["guitarOpenPedal"] = "\uE83D";
  Glyphs["guitarRightHandTapping"] = "\uE841";
  Glyphs["guitarShake"] = "\uE832";
  Glyphs["guitarString0"] = "\uE833";
  Glyphs["guitarString1"] = "\uE834";
  Glyphs["guitarString10"] = "\uE84A";
  Glyphs["guitarString11"] = "\uE84B";
  Glyphs["guitarString12"] = "\uE84C";
  Glyphs["guitarString13"] = "\uE84D";
  Glyphs["guitarString2"] = "\uE835";
  Glyphs["guitarString3"] = "\uE836";
  Glyphs["guitarString4"] = "\uE837";
  Glyphs["guitarString5"] = "\uE838";
  Glyphs["guitarString6"] = "\uE839";
  Glyphs["guitarString7"] = "\uE83A";
  Glyphs["guitarString8"] = "\uE83B";
  Glyphs["guitarString9"] = "\uE83C";
  Glyphs["guitarStrumDown"] = "\uE847";
  Glyphs["guitarStrumUp"] = "\uE846";
  Glyphs["guitarVibratoBarDip"] = "\uE831";
  Glyphs["guitarVibratoBarScoop"] = "\uE830";
  Glyphs["guitarVibratoStroke"] = "\uEAB2";
  Glyphs["guitarVolumeSwell"] = "\uE845";
  Glyphs["guitarWideVibratoStroke"] = "\uEAB3";
  Glyphs["handbellsBelltree"] = "\uE81F";
  Glyphs["handbellsDamp3"] = "\uE81E";
  Glyphs["handbellsEcho1"] = "\uE81B";
  Glyphs["handbellsEcho2"] = "\uE81C";
  Glyphs["handbellsGyro"] = "\uE81D";
  Glyphs["handbellsHandMartellato"] = "\uE812";
  Glyphs["handbellsMalletBellOnTable"] = "\uE815";
  Glyphs["handbellsMalletBellSuspended"] = "\uE814";
  Glyphs["handbellsMalletLft"] = "\uE816";
  Glyphs["handbellsMartellato"] = "\uE810";
  Glyphs["handbellsMartellatoLift"] = "\uE811";
  Glyphs["handbellsMutedMartellato"] = "\uE813";
  Glyphs["handbellsPluckLift"] = "\uE817";
  Glyphs["handbellsSwing"] = "\uE81A";
  Glyphs["handbellsSwingDown"] = "\uE819";
  Glyphs["handbellsSwingUp"] = "\uE818";
  Glyphs["handbellsTablePairBells"] = "\uE821";
  Glyphs["handbellsTableSingleBell"] = "\uE820";
  Glyphs["harpMetalRod"] = "\uE68F";
  Glyphs["harpPedalCentered"] = "\uE681";
  Glyphs["harpPedalDivider"] = "\uE683";
  Glyphs["harpPedalLowered"] = "\uE682";
  Glyphs["harpPedalRaised"] = "\uE680";
  Glyphs["harpSalzedoAeolianAscending"] = "\uE695";
  Glyphs["harpSalzedoAeolianDescending"] = "\uE696";
  Glyphs["harpSalzedoDampAbove"] = "\uE69A";
  Glyphs["harpSalzedoDampBelow"] = "\uE699";
  Glyphs["harpSalzedoDampBothHands"] = "\uE698";
  Glyphs["harpSalzedoDampLowStrings"] = "\uE697";
  Glyphs["harpSalzedoFluidicSoundsLeft"] = "\uE68D";
  Glyphs["harpSalzedoFluidicSoundsRight"] = "\uE68E";
  Glyphs["harpSalzedoIsolatedSounds"] = "\uE69C";
  Glyphs["harpSalzedoMetallicSounds"] = "\uE688";
  Glyphs["harpSalzedoMetallicSoundsOneString"] = "\uE69B";
  Glyphs["harpSalzedoMuffleTotally"] = "\uE68C";
  Glyphs["harpSalzedoOboicFlux"] = "\uE685";
  Glyphs["harpSalzedoPlayUpperEnd"] = "\uE68A";
  Glyphs["harpSalzedoSlideWithSuppleness"] = "\uE684";
  Glyphs["harpSalzedoSnareDrum"] = "\uE69D";
  Glyphs["harpSalzedoTamTamSounds"] = "\uE689";
  Glyphs["harpSalzedoThunderEffect"] = "\uE686";
  Glyphs["harpSalzedoTimpanicSounds"] = "\uE68B";
  Glyphs["harpSalzedoWhistlingSounds"] = "\uE687";
  Glyphs["harpStringNoiseStem"] = "\uE694";
  Glyphs["harpTuningKey"] = "\uE690";
  Glyphs["harpTuningKeyGlissando"] = "\uE693";
  Glyphs["harpTuningKeyHandle"] = "\uE691";
  Glyphs["harpTuningKeyShank"] = "\uE692";
  Glyphs["indianDrumClef"] = "\uED70";
  Glyphs["kahnBackChug"] = "\uEDE2";
  Glyphs["kahnBackFlap"] = "\uEDD8";
  Glyphs["kahnBackRiff"] = "\uEDE1";
  Glyphs["kahnBackRip"] = "\uEDDA";
  Glyphs["kahnBallChange"] = "\uEDC6";
  Glyphs["kahnBallDig"] = "\uEDCD";
  Glyphs["kahnBrushBackward"] = "\uEDA7";
  Glyphs["kahnBrushForward"] = "\uEDA6";
  Glyphs["kahnChug"] = "\uEDDD";
  Glyphs["kahnClap"] = "\uEDB8";
  Glyphs["kahnDoubleSnap"] = "\uEDBA";
  Glyphs["kahnDoubleWing"] = "\uEDEB";
  Glyphs["kahnDrawStep"] = "\uEDB2";
  Glyphs["kahnDrawTap"] = "\uEDB3";
  Glyphs["kahnFlam"] = "\uEDCF";
  Glyphs["kahnFlap"] = "\uEDD5";
  Glyphs["kahnFlapStep"] = "\uEDD7";
  Glyphs["kahnFlat"] = "\uEDA9";
  Glyphs["kahnFleaHop"] = "\uEDB0";
  Glyphs["kahnFleaTap"] = "\uEDB1";
  Glyphs["kahnGraceTap"] = "\uEDA8";
  Glyphs["kahnGraceTapChange"] = "\uEDD1";
  Glyphs["kahnGraceTapHop"] = "\uEDD0";
  Glyphs["kahnGraceTapStamp"] = "\uEDD3";
  Glyphs["kahnHeel"] = "\uEDAA";
  Glyphs["kahnHeelChange"] = "\uEDC9";
  Glyphs["kahnHeelClick"] = "\uEDBB";
  Glyphs["kahnHeelDrop"] = "\uEDB6";
  Glyphs["kahnHeelStep"] = "\uEDC4";
  Glyphs["kahnHeelTap"] = "\uEDCB";
  Glyphs["kahnHop"] = "\uEDA2";
  Glyphs["kahnJumpApart"] = "\uEDA5";
  Glyphs["kahnJumpTogether"] = "\uEDA4";
  Glyphs["kahnKneeInward"] = "\uEDAD";
  Glyphs["kahnKneeOutward"] = "\uEDAC";
  Glyphs["kahnLeap"] = "\uEDA3";
  Glyphs["kahnLeapFlatFoot"] = "\uEDD2";
  Glyphs["kahnLeapHeelClick"] = "\uEDD4";
  Glyphs["kahnLeftCatch"] = "\uEDBF";
  Glyphs["kahnLeftCross"] = "\uEDBD";
  Glyphs["kahnLeftFoot"] = "\uEDEE";
  Glyphs["kahnLeftToeStrike"] = "\uEDC1";
  Glyphs["kahnLeftTurn"] = "\uEDF0";
  Glyphs["kahnOverTheTop"] = "\uEDEC";
  Glyphs["kahnOverTheTopTap"] = "\uEDED";
  Glyphs["kahnPull"] = "\uEDE3";
  Glyphs["kahnPush"] = "\uEDDE";
  Glyphs["kahnRiff"] = "\uEDE0";
  Glyphs["kahnRiffle"] = "\uEDE7";
  Glyphs["kahnRightCatch"] = "\uEDC0";
  Glyphs["kahnRightCross"] = "\uEDBE";
  Glyphs["kahnRightFoot"] = "\uEDEF";
  Glyphs["kahnRightToeStrike"] = "\uEDC2";
  Glyphs["kahnRightTurn"] = "\uEDF1";
  Glyphs["kahnRip"] = "\uEDD6";
  Glyphs["kahnRipple"] = "\uEDE8";
  Glyphs["kahnScrape"] = "\uEDAE";
  Glyphs["kahnScuff"] = "\uEDDC";
  Glyphs["kahnScuffle"] = "\uEDE6";
  Glyphs["kahnShuffle"] = "\uEDE5";
  Glyphs["kahnSlam"] = "\uEDCE";
  Glyphs["kahnSlap"] = "\uEDD9";
  Glyphs["kahnSlideStep"] = "\uEDB4";
  Glyphs["kahnSlideTap"] = "\uEDB5";
  Glyphs["kahnSnap"] = "\uEDB9";
  Glyphs["kahnStamp"] = "\uEDC3";
  Glyphs["kahnStampStamp"] = "\uEDC8";
  Glyphs["kahnStep"] = "\uEDA0";
  Glyphs["kahnStepStamp"] = "\uEDC7";
  Glyphs["kahnStomp"] = "\uEDCA";
  Glyphs["kahnStompBrush"] = "\uEDDB";
  Glyphs["kahnTap"] = "\uEDA1";
  Glyphs["kahnToe"] = "\uEDAB";
  Glyphs["kahnToeClick"] = "\uEDBC";
  Glyphs["kahnToeDrop"] = "\uEDB7";
  Glyphs["kahnToeStep"] = "\uEDC5";
  Glyphs["kahnToeTap"] = "\uEDCC";
  Glyphs["kahnTrench"] = "\uEDAF";
  Glyphs["kahnWing"] = "\uEDE9";
  Glyphs["kahnWingChange"] = "\uEDEA";
  Glyphs["kahnZank"] = "\uEDE4";
  Glyphs["kahnZink"] = "\uEDDF";
  Glyphs["keyboardBebung2DotsAbove"] = "\uE668";
  Glyphs["keyboardBebung2DotsBelow"] = "\uE669";
  Glyphs["keyboardBebung3DotsAbove"] = "\uE66A";
  Glyphs["keyboardBebung3DotsBelow"] = "\uE66B";
  Glyphs["keyboardBebung4DotsAbove"] = "\uE66C";
  Glyphs["keyboardBebung4DotsBelow"] = "\uE66D";
  Glyphs["keyboardLeftPedalPictogram"] = "\uE65E";
  Glyphs["keyboardMiddlePedalPictogram"] = "\uE65F";
  Glyphs["keyboardPedalD"] = "\uE653";
  Glyphs["keyboardPedalDot"] = "\uE654";
  Glyphs["keyboardPedalE"] = "\uE652";
  Glyphs["keyboardPedalHalf"] = "\uE656";
  Glyphs["keyboardPedalHalf2"] = "\uE65B";
  Glyphs["keyboardPedalHalf3"] = "\uE65C";
  Glyphs["keyboardPedalHeel1"] = "\uE661";
  Glyphs["keyboardPedalHeel2"] = "\uE662";
  Glyphs["keyboardPedalHeel3"] = "\uE663";
  Glyphs["keyboardPedalHeelToToe"] = "\uE674";
  Glyphs["keyboardPedalHeelToe"] = "\uE666";
  Glyphs["keyboardPedalHookEnd"] = "\uE673";
  Glyphs["keyboardPedalHookStart"] = "\uE672";
  Glyphs["keyboardPedalHyphen"] = "\uE658";
  Glyphs["keyboardPedalP"] = "\uE651";
  Glyphs["keyboardPedalParensLeft"] = "\uE676";
  Glyphs["keyboardPedalParensRight"] = "\uE677";
  Glyphs["keyboardPedalPed"] = "\uE650";
  Glyphs["keyboardPedalS"] = "\uE65A";
  Glyphs["keyboardPedalSost"] = "\uE659";
  Glyphs["keyboardPedalToe1"] = "\uE664";
  Glyphs["keyboardPedalToe2"] = "\uE665";
  Glyphs["keyboardPedalToeToHeel"] = "\uE675";
  Glyphs["keyboardPedalUp"] = "\uE655";
  Glyphs["keyboardPedalUpNotch"] = "\uE657";
  Glyphs["keyboardPedalUpSpecial"] = "\uE65D";
  Glyphs["keyboardPlayWithLH"] = "\uE670";
  Glyphs["keyboardPlayWithLHEnd"] = "\uE671";
  Glyphs["keyboardPlayWithRH"] = "\uE66E";
  Glyphs["keyboardPlayWithRHEnd"] = "\uE66F";
  Glyphs["keyboardPluckInside"] = "\uE667";
  Glyphs["keyboardRightPedalPictogram"] = "\uE660";
  Glyphs["kievanAccidentalFlat"] = "\uEC3E";
  Glyphs["kievanAccidentalSharp"] = "\uEC3D";
  Glyphs["kievanAugmentationDot"] = "\uEC3C";
  Glyphs["kievanCClef"] = "\uEC30";
  Glyphs["kievanEndingSymbol"] = "\uEC31";
  Glyphs["kievanNote8thStemDown"] = "\uEC3A";
  Glyphs["kievanNote8thStemUp"] = "\uEC39";
  Glyphs["kievanNoteBeam"] = "\uEC3B";
  Glyphs["kievanNoteHalfStaffLine"] = "\uEC35";
  Glyphs["kievanNoteHalfStaffSpace"] = "\uEC36";
  Glyphs["kievanNoteQuarterStemDown"] = "\uEC38";
  Glyphs["kievanNoteQuarterStemUp"] = "\uEC37";
  Glyphs["kievanNoteReciting"] = "\uEC32";
  Glyphs["kievanNoteWhole"] = "\uEC33";
  Glyphs["kievanNoteWholeFinal"] = "\uEC34";
  Glyphs["kodalyHandDo"] = "\uEC40";
  Glyphs["kodalyHandFa"] = "\uEC43";
  Glyphs["kodalyHandLa"] = "\uEC45";
  Glyphs["kodalyHandMi"] = "\uEC42";
  Glyphs["kodalyHandRe"] = "\uEC41";
  Glyphs["kodalyHandSo"] = "\uEC44";
  Glyphs["kodalyHandTi"] = "\uEC46";
  Glyphs["leftRepeatSmall"] = "\uE04C";
  Glyphs["legerLine"] = "\uE022";
  Glyphs["legerLineNarrow"] = "\uE024";
  Glyphs["legerLineWide"] = "\uE023";
  Glyphs["luteBarlineEndRepeat"] = "\uEBA4";
  Glyphs["luteBarlineFinal"] = "\uEBA5";
  Glyphs["luteBarlineStartRepeat"] = "\uEBA3";
  Glyphs["luteDuration16th"] = "\uEBAB";
  Glyphs["luteDuration32nd"] = "\uEBAC";
  Glyphs["luteDuration8th"] = "\uEBAA";
  Glyphs["luteDurationDoubleWhole"] = "\uEBA6";
  Glyphs["luteDurationHalf"] = "\uEBA8";
  Glyphs["luteDurationQuarter"] = "\uEBA9";
  Glyphs["luteDurationWhole"] = "\uEBA7";
  Glyphs["luteFingeringRHFirst"] = "\uEBAE";
  Glyphs["luteFingeringRHSecond"] = "\uEBAF";
  Glyphs["luteFingeringRHThird"] = "\uEBB0";
  Glyphs["luteFingeringRHThumb"] = "\uEBAD";
  Glyphs["luteFrench10thCourse"] = "\uEBD0";
  Glyphs["luteFrench7thCourse"] = "\uEBCD";
  Glyphs["luteFrench8thCourse"] = "\uEBCE";
  Glyphs["luteFrench9thCourse"] = "\uEBCF";
  Glyphs["luteFrenchAppoggiaturaAbove"] = "\uEBD5";
  Glyphs["luteFrenchAppoggiaturaBelow"] = "\uEBD4";
  Glyphs["luteFrenchFretA"] = "\uEBC0";
  Glyphs["luteFrenchFretB"] = "\uEBC1";
  Glyphs["luteFrenchFretC"] = "\uEBC2";
  Glyphs["luteFrenchFretD"] = "\uEBC3";
  Glyphs["luteFrenchFretE"] = "\uEBC4";
  Glyphs["luteFrenchFretF"] = "\uEBC5";
  Glyphs["luteFrenchFretG"] = "\uEBC6";
  Glyphs["luteFrenchFretH"] = "\uEBC7";
  Glyphs["luteFrenchFretI"] = "\uEBC8";
  Glyphs["luteFrenchFretK"] = "\uEBC9";
  Glyphs["luteFrenchFretL"] = "\uEBCA";
  Glyphs["luteFrenchFretM"] = "\uEBCB";
  Glyphs["luteFrenchFretN"] = "\uEBCC";
  Glyphs["luteFrenchMordentInverted"] = "\uEBD3";
  Glyphs["luteFrenchMordentLower"] = "\uEBD2";
  Glyphs["luteFrenchMordentUpper"] = "\uEBD1";
  Glyphs["luteGermanALower"] = "\uEC00";
  Glyphs["luteGermanAUpper"] = "\uEC17";
  Glyphs["luteGermanBLower"] = "\uEC01";
  Glyphs["luteGermanBUpper"] = "\uEC18";
  Glyphs["luteGermanCLower"] = "\uEC02";
  Glyphs["luteGermanCUpper"] = "\uEC19";
  Glyphs["luteGermanDLower"] = "\uEC03";
  Glyphs["luteGermanDUpper"] = "\uEC1A";
  Glyphs["luteGermanELower"] = "\uEC04";
  Glyphs["luteGermanEUpper"] = "\uEC1B";
  Glyphs["luteGermanFLower"] = "\uEC05";
  Glyphs["luteGermanFUpper"] = "\uEC1C";
  Glyphs["luteGermanGLower"] = "\uEC06";
  Glyphs["luteGermanGUpper"] = "\uEC1D";
  Glyphs["luteGermanHLower"] = "\uEC07";
  Glyphs["luteGermanHUpper"] = "\uEC1E";
  Glyphs["luteGermanILower"] = "\uEC08";
  Glyphs["luteGermanIUpper"] = "\uEC1F";
  Glyphs["luteGermanKLower"] = "\uEC09";
  Glyphs["luteGermanKUpper"] = "\uEC20";
  Glyphs["luteGermanLLower"] = "\uEC0A";
  Glyphs["luteGermanLUpper"] = "\uEC21";
  Glyphs["luteGermanMLower"] = "\uEC0B";
  Glyphs["luteGermanMUpper"] = "\uEC22";
  Glyphs["luteGermanNLower"] = "\uEC0C";
  Glyphs["luteGermanNUpper"] = "\uEC23";
  Glyphs["luteGermanOLower"] = "\uEC0D";
  Glyphs["luteGermanPLower"] = "\uEC0E";
  Glyphs["luteGermanQLower"] = "\uEC0F";
  Glyphs["luteGermanRLower"] = "\uEC10";
  Glyphs["luteGermanSLower"] = "\uEC11";
  Glyphs["luteGermanTLower"] = "\uEC12";
  Glyphs["luteGermanVLower"] = "\uEC13";
  Glyphs["luteGermanXLower"] = "\uEC14";
  Glyphs["luteGermanYLower"] = "\uEC15";
  Glyphs["luteGermanZLower"] = "\uEC16";
  Glyphs["luteItalianClefCSolFaUt"] = "\uEBF1";
  Glyphs["luteItalianClefFFaUt"] = "\uEBF0";
  Glyphs["luteItalianFret0"] = "\uEBE0";
  Glyphs["luteItalianFret1"] = "\uEBE1";
  Glyphs["luteItalianFret2"] = "\uEBE2";
  Glyphs["luteItalianFret3"] = "\uEBE3";
  Glyphs["luteItalianFret4"] = "\uEBE4";
  Glyphs["luteItalianFret5"] = "\uEBE5";
  Glyphs["luteItalianFret6"] = "\uEBE6";
  Glyphs["luteItalianFret7"] = "\uEBE7";
  Glyphs["luteItalianFret8"] = "\uEBE8";
  Glyphs["luteItalianFret9"] = "\uEBE9";
  Glyphs["luteItalianHoldFinger"] = "\uEBF4";
  Glyphs["luteItalianHoldNote"] = "\uEBF3";
  Glyphs["luteItalianReleaseFinger"] = "\uEBF5";
  Glyphs["luteItalianTempoFast"] = "\uEBEA";
  Glyphs["luteItalianTempoNeitherFastNorSlow"] = "\uEBEC";
  Glyphs["luteItalianTempoSlow"] = "\uEBED";
  Glyphs["luteItalianTempoSomewhatFast"] = "\uEBEB";
  Glyphs["luteItalianTempoVerySlow"] = "\uEBEE";
  Glyphs["luteItalianTimeTriple"] = "\uEBEF";
  Glyphs["luteItalianTremolo"] = "\uEBF2";
  Glyphs["luteItalianVibrato"] = "\uEBF6";
  Glyphs["luteStaff6Lines"] = "\uEBA0";
  Glyphs["luteStaff6LinesNarrow"] = "\uEBA2";
  Glyphs["luteStaff6LinesWide"] = "\uEBA1";
  Glyphs["lyricsElision"] = "\uE551";
  Glyphs["lyricsElisionNarrow"] = "\uE550";
  Glyphs["lyricsElisionWide"] = "\uE552";
  Glyphs["lyricsHyphenBaseline"] = "\uE553";
  Glyphs["lyricsHyphenBaselineNonBreaking"] = "\uE554";
  Glyphs["lyricsTextRepeat"] = "\uE555";
  Glyphs["medRenFlatHardB"] = "\uE9E1";
  Glyphs["medRenFlatSoftB"] = "\uE9E0";
  Glyphs["medRenFlatWithDot"] = "\uE9E4";
  Glyphs["medRenGClefCMN"] = "\uEA24";
  Glyphs["medRenLiquescenceCMN"] = "\uEA22";
  Glyphs["medRenLiquescentAscCMN"] = "\uEA26";
  Glyphs["medRenLiquescentDescCMN"] = "\uEA27";
  Glyphs["medRenNatural"] = "\uE9E2";
  Glyphs["medRenNaturalWithCross"] = "\uE9E5";
  Glyphs["medRenOriscusCMN"] = "\uEA2A";
  Glyphs["medRenPlicaCMN"] = "\uEA23";
  Glyphs["medRenPunctumCMN"] = "\uEA25";
  Glyphs["medRenQuilismaCMN"] = "\uEA28";
  Glyphs["medRenSharpCroix"] = "\uE9E3";
  Glyphs["medRenStrophicusCMN"] = "\uEA29";
  Glyphs["mensuralAlterationSign"] = "\uEA10";
  Glyphs["mensuralBlackBrevis"] = "\uE952";
  Glyphs["mensuralBlackBrevisVoid"] = "\uE956";
  Glyphs["mensuralBlackDragma"] = "\uE95A";
  Glyphs["mensuralBlackLonga"] = "\uE951";
  Glyphs["mensuralBlackMaxima"] = "\uE950";
  Glyphs["mensuralBlackMinima"] = "\uE954";
  Glyphs["mensuralBlackMinimaVoid"] = "\uE958";
  Glyphs["mensuralBlackSemibrevis"] = "\uE953";
  Glyphs["mensuralBlackSemibrevisCaudata"] = "\uE959";
  Glyphs["mensuralBlackSemibrevisOblique"] = "\uE95B";
  Glyphs["mensuralBlackSemibrevisVoid"] = "\uE957";
  Glyphs["mensuralBlackSemiminima"] = "\uE955";
  Glyphs["mensuralCclef"] = "\uE905";
  Glyphs["mensuralCclefPetrucciPosHigh"] = "\uE90A";
  Glyphs["mensuralCclefPetrucciPosHighest"] = "\uE90B";
  Glyphs["mensuralCclefPetrucciPosLow"] = "\uE908";
  Glyphs["mensuralCclefPetrucciPosLowest"] = "\uE907";
  Glyphs["mensuralCclefPetrucciPosMiddle"] = "\uE909";
  Glyphs["mensuralColorationEndRound"] = "\uEA0F";
  Glyphs["mensuralColorationEndSquare"] = "\uEA0D";
  Glyphs["mensuralColorationStartRound"] = "\uEA0E";
  Glyphs["mensuralColorationStartSquare"] = "\uEA0C";
  Glyphs["mensuralCombStemDiagonal"] = "\uE940";
  Glyphs["mensuralCombStemDown"] = "\uE93F";
  Glyphs["mensuralCombStemDownFlagExtended"] = "\uE948";
  Glyphs["mensuralCombStemDownFlagFlared"] = "\uE946";
  Glyphs["mensuralCombStemDownFlagFusa"] = "\uE94C";
  Glyphs["mensuralCombStemDownFlagLeft"] = "\uE944";
  Glyphs["mensuralCombStemDownFlagRight"] = "\uE942";
  Glyphs["mensuralCombStemDownFlagSemiminima"] = "\uE94A";
  Glyphs["mensuralCombStemUp"] = "\uE93E";
  Glyphs["mensuralCombStemUpFlagExtended"] = "\uE947";
  Glyphs["mensuralCombStemUpFlagFlared"] = "\uE945";
  Glyphs["mensuralCombStemUpFlagFusa"] = "\uE94B";
  Glyphs["mensuralCombStemUpFlagLeft"] = "\uE943";
  Glyphs["mensuralCombStemUpFlagRight"] = "\uE941";
  Glyphs["mensuralCombStemUpFlagSemiminima"] = "\uE949";
  Glyphs["mensuralCustosCheckmark"] = "\uEA0A";
  Glyphs["mensuralCustosDown"] = "\uEA03";
  Glyphs["mensuralCustosTurn"] = "\uEA0B";
  Glyphs["mensuralCustosUp"] = "\uEA02";
  Glyphs["mensuralFclef"] = "\uE903";
  Glyphs["mensuralFclefPetrucci"] = "\uE904";
  Glyphs["mensuralGclef"] = "\uE900";
  Glyphs["mensuralGclefPetrucci"] = "\uE901";
  Glyphs["mensuralModusImperfectumVert"] = "\uE92D";
  Glyphs["mensuralModusPerfectumVert"] = "\uE92C";
  Glyphs["mensuralNoteheadLongaBlack"] = "\uE934";
  Glyphs["mensuralNoteheadLongaBlackVoid"] = "\uE936";
  Glyphs["mensuralNoteheadLongaVoid"] = "\uE935";
  Glyphs["mensuralNoteheadLongaWhite"] = "\uE937";
  Glyphs["mensuralNoteheadMaximaBlack"] = "\uE930";
  Glyphs["mensuralNoteheadMaximaBlackVoid"] = "\uE932";
  Glyphs["mensuralNoteheadMaximaVoid"] = "\uE931";
  Glyphs["mensuralNoteheadMaximaWhite"] = "\uE933";
  Glyphs["mensuralNoteheadMinimaWhite"] = "\uE93C";
  Glyphs["mensuralNoteheadSemibrevisBlack"] = "\uE938";
  Glyphs["mensuralNoteheadSemibrevisBlackVoid"] = "\uE93A";
  Glyphs["mensuralNoteheadSemibrevisBlackVoidTurned"] = "\uE93B";
  Glyphs["mensuralNoteheadSemibrevisVoid"] = "\uE939";
  Glyphs["mensuralNoteheadSemiminimaWhite"] = "\uE93D";
  Glyphs["mensuralObliqueAsc2ndBlack"] = "\uE970";
  Glyphs["mensuralObliqueAsc2ndBlackVoid"] = "\uE972";
  Glyphs["mensuralObliqueAsc2ndVoid"] = "\uE971";
  Glyphs["mensuralObliqueAsc2ndWhite"] = "\uE973";
  Glyphs["mensuralObliqueAsc3rdBlack"] = "\uE974";
  Glyphs["mensuralObliqueAsc3rdBlackVoid"] = "\uE976";
  Glyphs["mensuralObliqueAsc3rdVoid"] = "\uE975";
  Glyphs["mensuralObliqueAsc3rdWhite"] = "\uE977";
  Glyphs["mensuralObliqueAsc4thBlack"] = "\uE978";
  Glyphs["mensuralObliqueAsc4thBlackVoid"] = "\uE97A";
  Glyphs["mensuralObliqueAsc4thVoid"] = "\uE979";
  Glyphs["mensuralObliqueAsc4thWhite"] = "\uE97B";
  Glyphs["mensuralObliqueAsc5thBlack"] = "\uE97C";
  Glyphs["mensuralObliqueAsc5thBlackVoid"] = "\uE97E";
  Glyphs["mensuralObliqueAsc5thVoid"] = "\uE97D";
  Glyphs["mensuralObliqueAsc5thWhite"] = "\uE97F";
  Glyphs["mensuralObliqueDesc2ndBlack"] = "\uE980";
  Glyphs["mensuralObliqueDesc2ndBlackVoid"] = "\uE982";
  Glyphs["mensuralObliqueDesc2ndVoid"] = "\uE981";
  Glyphs["mensuralObliqueDesc2ndWhite"] = "\uE983";
  Glyphs["mensuralObliqueDesc3rdBlack"] = "\uE984";
  Glyphs["mensuralObliqueDesc3rdBlackVoid"] = "\uE986";
  Glyphs["mensuralObliqueDesc3rdVoid"] = "\uE985";
  Glyphs["mensuralObliqueDesc3rdWhite"] = "\uE987";
  Glyphs["mensuralObliqueDesc4thBlack"] = "\uE988";
  Glyphs["mensuralObliqueDesc4thBlackVoid"] = "\uE98A";
  Glyphs["mensuralObliqueDesc4thVoid"] = "\uE989";
  Glyphs["mensuralObliqueDesc4thWhite"] = "\uE98B";
  Glyphs["mensuralObliqueDesc5thBlack"] = "\uE98C";
  Glyphs["mensuralObliqueDesc5thBlackVoid"] = "\uE98E";
  Glyphs["mensuralObliqueDesc5thVoid"] = "\uE98D";
  Glyphs["mensuralObliqueDesc5thWhite"] = "\uE98F";
  Glyphs["mensuralProlation1"] = "\uE910";
  Glyphs["mensuralProlation10"] = "\uE919";
  Glyphs["mensuralProlation11"] = "\uE91A";
  Glyphs["mensuralProlation2"] = "\uE911";
  Glyphs["mensuralProlation3"] = "\uE912";
  Glyphs["mensuralProlation4"] = "\uE913";
  Glyphs["mensuralProlation5"] = "\uE914";
  Glyphs["mensuralProlation6"] = "\uE915";
  Glyphs["mensuralProlation7"] = "\uE916";
  Glyphs["mensuralProlation8"] = "\uE917";
  Glyphs["mensuralProlation9"] = "\uE918";
  Glyphs["mensuralProlationCombiningDot"] = "\uE920";
  Glyphs["mensuralProlationCombiningDotVoid"] = "\uE924";
  Glyphs["mensuralProlationCombiningStroke"] = "\uE925";
  Glyphs["mensuralProlationCombiningThreeDots"] = "\uE922";
  Glyphs["mensuralProlationCombiningThreeDotsTri"] = "\uE923";
  Glyphs["mensuralProlationCombiningTwoDots"] = "\uE921";
  Glyphs["mensuralProportion1"] = "\uE926";
  Glyphs["mensuralProportion2"] = "\uE927";
  Glyphs["mensuralProportion3"] = "\uE928";
  Glyphs["mensuralProportion4"] = "\uE929";
  Glyphs["mensuralProportion5"] = "\uEE90";
  Glyphs["mensuralProportion6"] = "\uEE91";
  Glyphs["mensuralProportion7"] = "\uEE92";
  Glyphs["mensuralProportion8"] = "\uEE93";
  Glyphs["mensuralProportion9"] = "\uEE94";
  Glyphs["mensuralProportionMajor"] = "\uE92B";
  Glyphs["mensuralProportionMinor"] = "\uE92A";
  Glyphs["mensuralProportionProportioDupla1"] = "\uE91C";
  Glyphs["mensuralProportionProportioDupla2"] = "\uE91D";
  Glyphs["mensuralProportionProportioQuadrupla"] = "\uE91F";
  Glyphs["mensuralProportionProportioTripla"] = "\uE91E";
  Glyphs["mensuralProportionTempusPerfectum"] = "\uE91B";
  Glyphs["mensuralRestBrevis"] = "\uE9F3";
  Glyphs["mensuralRestFusa"] = "\uE9F7";
  Glyphs["mensuralRestLongaImperfecta"] = "\uE9F2";
  Glyphs["mensuralRestLongaPerfecta"] = "\uE9F1";
  Glyphs["mensuralRestMaxima"] = "\uE9F0";
  Glyphs["mensuralRestMinima"] = "\uE9F5";
  Glyphs["mensuralRestSemibrevis"] = "\uE9F4";
  Glyphs["mensuralRestSemifusa"] = "\uE9F8";
  Glyphs["mensuralRestSemiminima"] = "\uE9F6";
  Glyphs["mensuralSignumDown"] = "\uEA01";
  Glyphs["mensuralSignumUp"] = "\uEA00";
  Glyphs["mensuralTempusImperfectumHoriz"] = "\uE92F";
  Glyphs["mensuralTempusPerfectumHoriz"] = "\uE92E";
  Glyphs["mensuralWhiteBrevis"] = "\uE95E";
  Glyphs["mensuralWhiteFusa"] = "\uE961";
  Glyphs["mensuralWhiteLonga"] = "\uE95D";
  Glyphs["mensuralWhiteMaxima"] = "\uE95C";
  Glyphs["mensuralWhiteMinima"] = "\uE95F";
  Glyphs["mensuralWhiteSemibrevis"] = "\uE962";
  Glyphs["mensuralWhiteSemiminima"] = "\uE960";
  Glyphs["metAugmentationDot"] = "\uECB7";
  Glyphs["metNote1024thDown"] = "\uECB6";
  Glyphs["metNote1024thUp"] = "\uECB5";
  Glyphs["metNote128thDown"] = "\uECB0";
  Glyphs["metNote128thUp"] = "\uECAF";
  Glyphs["metNote16thDown"] = "\uECAA";
  Glyphs["metNote16thUp"] = "\uECA9";
  Glyphs["metNote256thDown"] = "\uECB2";
  Glyphs["metNote256thUp"] = "\uECB1";
  Glyphs["metNote32ndDown"] = "\uECAC";
  Glyphs["metNote32ndUp"] = "\uECAB";
  Glyphs["metNote512thDown"] = "\uECB4";
  Glyphs["metNote512thUp"] = "\uECB3";
  Glyphs["metNote64thDown"] = "\uECAE";
  Glyphs["metNote64thUp"] = "\uECAD";
  Glyphs["metNote8thDown"] = "\uECA8";
  Glyphs["metNote8thUp"] = "\uECA7";
  Glyphs["metNoteDoubleWhole"] = "\uECA0";
  Glyphs["metNoteDoubleWholeSquare"] = "\uECA1";
  Glyphs["metNoteHalfDown"] = "\uECA4";
  Glyphs["metNoteHalfUp"] = "\uECA3";
  Glyphs["metNoteQuarterDown"] = "\uECA6";
  Glyphs["metNoteQuarterUp"] = "\uECA5";
  Glyphs["metNoteWhole"] = "\uECA2";
  Glyphs["metricModulationArrowLeft"] = "\uEC63";
  Glyphs["metricModulationArrowRight"] = "\uEC64";
  Glyphs["miscDoNotCopy"] = "\uEC61";
  Glyphs["miscDoNotPhotocopy"] = "\uEC60";
  Glyphs["miscEyeglasses"] = "\uEC62";
  Glyphs["note1024thDown"] = "\uE1E6";
  Glyphs["note1024thUp"] = "\uE1E5";
  Glyphs["note128thDown"] = "\uE1E0";
  Glyphs["note128thUp"] = "\uE1DF";
  Glyphs["note16thDown"] = "\uE1DA";
  Glyphs["note16thUp"] = "\uE1D9";
  Glyphs["note256thDown"] = "\uE1E2";
  Glyphs["note256thUp"] = "\uE1E1";
  Glyphs["note32ndDown"] = "\uE1DC";
  Glyphs["note32ndUp"] = "\uE1DB";
  Glyphs["note512thDown"] = "\uE1E4";
  Glyphs["note512thUp"] = "\uE1E3";
  Glyphs["note64thDown"] = "\uE1DE";
  Glyphs["note64thUp"] = "\uE1DD";
  Glyphs["note8thDown"] = "\uE1D8";
  Glyphs["note8thUp"] = "\uE1D7";
  Glyphs["noteABlack"] = "\uE197";
  Glyphs["noteAFlatBlack"] = "\uE196";
  Glyphs["noteAFlatHalf"] = "\uE17F";
  Glyphs["noteAFlatWhole"] = "\uE168";
  Glyphs["noteAHalf"] = "\uE180";
  Glyphs["noteASharpBlack"] = "\uE198";
  Glyphs["noteASharpHalf"] = "\uE181";
  Glyphs["noteASharpWhole"] = "\uE16A";
  Glyphs["noteAWhole"] = "\uE169";
  Glyphs["noteBBlack"] = "\uE19A";
  Glyphs["noteBFlatBlack"] = "\uE199";
  Glyphs["noteBFlatHalf"] = "\uE182";
  Glyphs["noteBFlatWhole"] = "\uE16B";
  Glyphs["noteBHalf"] = "\uE183";
  Glyphs["noteBSharpBlack"] = "\uE19B";
  Glyphs["noteBSharpHalf"] = "\uE184";
  Glyphs["noteBSharpWhole"] = "\uE16D";
  Glyphs["noteBWhole"] = "\uE16C";
  Glyphs["noteCBlack"] = "\uE19D";
  Glyphs["noteCFlatBlack"] = "\uE19C";
  Glyphs["noteCFlatHalf"] = "\uE185";
  Glyphs["noteCFlatWhole"] = "\uE16E";
  Glyphs["noteCHalf"] = "\uE186";
  Glyphs["noteCSharpBlack"] = "\uE19E";
  Glyphs["noteCSharpHalf"] = "\uE187";
  Glyphs["noteCSharpWhole"] = "\uE170";
  Glyphs["noteCWhole"] = "\uE16F";
  Glyphs["noteDBlack"] = "\uE1A0";
  Glyphs["noteDFlatBlack"] = "\uE19F";
  Glyphs["noteDFlatHalf"] = "\uE188";
  Glyphs["noteDFlatWhole"] = "\uE171";
  Glyphs["noteDHalf"] = "\uE189";
  Glyphs["noteDSharpBlack"] = "\uE1A1";
  Glyphs["noteDSharpHalf"] = "\uE18A";
  Glyphs["noteDSharpWhole"] = "\uE173";
  Glyphs["noteDWhole"] = "\uE172";
  Glyphs["noteDiBlack"] = "\uEEF2";
  Glyphs["noteDiHalf"] = "\uEEE9";
  Glyphs["noteDiWhole"] = "\uEEE0";
  Glyphs["noteDoBlack"] = "\uE160";
  Glyphs["noteDoHalf"] = "\uE158";
  Glyphs["noteDoWhole"] = "\uE150";
  Glyphs["noteDoubleWhole"] = "\uE1D0";
  Glyphs["noteDoubleWholeSquare"] = "\uE1D1";
  Glyphs["noteEBlack"] = "\uE1A3";
  Glyphs["noteEFlatBlack"] = "\uE1A2";
  Glyphs["noteEFlatHalf"] = "\uE18B";
  Glyphs["noteEFlatWhole"] = "\uE174";
  Glyphs["noteEHalf"] = "\uE18C";
  Glyphs["noteESharpBlack"] = "\uE1A4";
  Glyphs["noteESharpHalf"] = "\uE18D";
  Glyphs["noteESharpWhole"] = "\uE176";
  Glyphs["noteEWhole"] = "\uE175";
  Glyphs["noteEmptyBlack"] = "\uE1AF";
  Glyphs["noteEmptyHalf"] = "\uE1AE";
  Glyphs["noteEmptyWhole"] = "\uE1AD";
  Glyphs["noteFBlack"] = "\uE1A6";
  Glyphs["noteFFlatBlack"] = "\uE1A5";
  Glyphs["noteFFlatHalf"] = "\uE18E";
  Glyphs["noteFFlatWhole"] = "\uE177";
  Glyphs["noteFHalf"] = "\uE18F";
  Glyphs["noteFSharpBlack"] = "\uE1A7";
  Glyphs["noteFSharpHalf"] = "\uE190";
  Glyphs["noteFSharpWhole"] = "\uE179";
  Glyphs["noteFWhole"] = "\uE178";
  Glyphs["noteFaBlack"] = "\uE163";
  Glyphs["noteFaHalf"] = "\uE15B";
  Glyphs["noteFaWhole"] = "\uE153";
  Glyphs["noteFiBlack"] = "\uEEF6";
  Glyphs["noteFiHalf"] = "\uEEED";
  Glyphs["noteFiWhole"] = "\uEEE4";
  Glyphs["noteGBlack"] = "\uE1A9";
  Glyphs["noteGFlatBlack"] = "\uE1A8";
  Glyphs["noteGFlatHalf"] = "\uE191";
  Glyphs["noteGFlatWhole"] = "\uE17A";
  Glyphs["noteGHalf"] = "\uE192";
  Glyphs["noteGSharpBlack"] = "\uE1AA";
  Glyphs["noteGSharpHalf"] = "\uE193";
  Glyphs["noteGSharpWhole"] = "\uE17C";
  Glyphs["noteGWhole"] = "\uE17B";
  Glyphs["noteHBlack"] = "\uE1AB";
  Glyphs["noteHHalf"] = "\uE194";
  Glyphs["noteHSharpBlack"] = "\uE1AC";
  Glyphs["noteHSharpHalf"] = "\uE195";
  Glyphs["noteHSharpWhole"] = "\uE17E";
  Glyphs["noteHWhole"] = "\uE17D";
  Glyphs["noteHalfDown"] = "\uE1D4";
  Glyphs["noteHalfUp"] = "\uE1D3";
  Glyphs["noteLaBlack"] = "\uE165";
  Glyphs["noteLaHalf"] = "\uE15D";
  Glyphs["noteLaWhole"] = "\uE155";
  Glyphs["noteLeBlack"] = "\uEEF9";
  Glyphs["noteLeHalf"] = "\uEEF0";
  Glyphs["noteLeWhole"] = "\uEEE7";
  Glyphs["noteLiBlack"] = "\uEEF8";
  Glyphs["noteLiHalf"] = "\uEEEF";
  Glyphs["noteLiWhole"] = "\uEEE6";
  Glyphs["noteMeBlack"] = "\uEEF5";
  Glyphs["noteMeHalf"] = "\uEEEC";
  Glyphs["noteMeWhole"] = "\uEEE3";
  Glyphs["noteMiBlack"] = "\uE162";
  Glyphs["noteMiHalf"] = "\uE15A";
  Glyphs["noteMiWhole"] = "\uE152";
  Glyphs["noteQuarterDown"] = "\uE1D6";
  Glyphs["noteQuarterUp"] = "\uE1D5";
  Glyphs["noteRaBlack"] = "\uEEF4";
  Glyphs["noteRaHalf"] = "\uEEEB";
  Glyphs["noteRaWhole"] = "\uEEE2";
  Glyphs["noteReBlack"] = "\uE161";
  Glyphs["noteReHalf"] = "\uE159";
  Glyphs["noteReWhole"] = "\uE151";
  Glyphs["noteRiBlack"] = "\uEEF3";
  Glyphs["noteRiHalf"] = "\uEEEA";
  Glyphs["noteRiWhole"] = "\uEEE1";
  Glyphs["noteSeBlack"] = "\uEEF7";
  Glyphs["noteSeHalf"] = "\uEEEE";
  Glyphs["noteSeWhole"] = "\uEEE5";
  Glyphs["noteShapeArrowheadLeftBlack"] = "\uE1C9";
  Glyphs["noteShapeArrowheadLeftDoubleWhole"] = "\uECDC";
  Glyphs["noteShapeArrowheadLeftWhite"] = "\uE1C8";
  Glyphs["noteShapeDiamondBlack"] = "\uE1B9";
  Glyphs["noteShapeDiamondDoubleWhole"] = "\uECD4";
  Glyphs["noteShapeDiamondWhite"] = "\uE1B8";
  Glyphs["noteShapeIsoscelesTriangleBlack"] = "\uE1C5";
  Glyphs["noteShapeIsoscelesTriangleDoubleWhole"] = "\uECDA";
  Glyphs["noteShapeIsoscelesTriangleWhite"] = "\uE1C4";
  Glyphs["noteShapeKeystoneBlack"] = "\uE1C1";
  Glyphs["noteShapeKeystoneDoubleWhole"] = "\uECD8";
  Glyphs["noteShapeKeystoneWhite"] = "\uE1C0";
  Glyphs["noteShapeMoonBlack"] = "\uE1BD";
  Glyphs["noteShapeMoonDoubleWhole"] = "\uECD6";
  Glyphs["noteShapeMoonLeftBlack"] = "\uE1C7";
  Glyphs["noteShapeMoonLeftDoubleWhole"] = "\uECDB";
  Glyphs["noteShapeMoonLeftWhite"] = "\uE1C6";
  Glyphs["noteShapeMoonWhite"] = "\uE1BC";
  Glyphs["noteShapeQuarterMoonBlack"] = "\uE1C3";
  Glyphs["noteShapeQuarterMoonDoubleWhole"] = "\uECD9";
  Glyphs["noteShapeQuarterMoonWhite"] = "\uE1C2";
  Glyphs["noteShapeRoundBlack"] = "\uE1B1";
  Glyphs["noteShapeRoundDoubleWhole"] = "\uECD0";
  Glyphs["noteShapeRoundWhite"] = "\uE1B0";
  Glyphs["noteShapeSquareBlack"] = "\uE1B3";
  Glyphs["noteShapeSquareDoubleWhole"] = "\uECD1";
  Glyphs["noteShapeSquareWhite"] = "\uE1B2";
  Glyphs["noteShapeTriangleLeftBlack"] = "\uE1B7";
  Glyphs["noteShapeTriangleLeftDoubleWhole"] = "\uECD3";
  Glyphs["noteShapeTriangleLeftWhite"] = "\uE1B6";
  Glyphs["noteShapeTriangleRightBlack"] = "\uE1B5";
  Glyphs["noteShapeTriangleRightDoubleWhole"] = "\uECD2";
  Glyphs["noteShapeTriangleRightWhite"] = "\uE1B4";
  Glyphs["noteShapeTriangleRoundBlack"] = "\uE1BF";
  Glyphs["noteShapeTriangleRoundDoubleWhole"] = "\uECD7";
  Glyphs["noteShapeTriangleRoundLeftBlack"] = "\uE1CB";
  Glyphs["noteShapeTriangleRoundLeftDoubleWhole"] = "\uECDD";
  Glyphs["noteShapeTriangleRoundLeftWhite"] = "\uE1CA";
  Glyphs["noteShapeTriangleRoundWhite"] = "\uE1BE";
  Glyphs["noteShapeTriangleUpBlack"] = "\uE1BB";
  Glyphs["noteShapeTriangleUpDoubleWhole"] = "\uECD5";
  Glyphs["noteShapeTriangleUpWhite"] = "\uE1BA";
  Glyphs["noteSiBlack"] = "\uE167";
  Glyphs["noteSiHalf"] = "\uE15F";
  Glyphs["noteSiWhole"] = "\uE157";
  Glyphs["noteSoBlack"] = "\uE164";
  Glyphs["noteSoHalf"] = "\uE15C";
  Glyphs["noteSoWhole"] = "\uE154";
  Glyphs["noteTeBlack"] = "\uEEFA";
  Glyphs["noteTeHalf"] = "\uEEF1";
  Glyphs["noteTeWhole"] = "\uEEE8";
  Glyphs["noteTiBlack"] = "\uE166";
  Glyphs["noteTiHalf"] = "\uE15E";
  Glyphs["noteTiWhole"] = "\uE156";
  Glyphs["noteWhole"] = "\uE1D2";
  Glyphs["noteheadBlack"] = "\uE0A4";
  Glyphs["noteheadCircleSlash"] = "\uE0F7";
  Glyphs["noteheadCircleX"] = "\uE0B3";
  Glyphs["noteheadCircleXDoubleWhole"] = "\uE0B0";
  Glyphs["noteheadCircleXHalf"] = "\uE0B2";
  Glyphs["noteheadCircleXWhole"] = "\uE0B1";
  Glyphs["noteheadCircledBlack"] = "\uE0E4";
  Glyphs["noteheadCircledBlackLarge"] = "\uE0E8";
  Glyphs["noteheadCircledDoubleWhole"] = "\uE0E7";
  Glyphs["noteheadCircledDoubleWholeLarge"] = "\uE0EB";
  Glyphs["noteheadCircledHalf"] = "\uE0E5";
  Glyphs["noteheadCircledHalfLarge"] = "\uE0E9";
  Glyphs["noteheadCircledWhole"] = "\uE0E6";
  Glyphs["noteheadCircledWholeLarge"] = "\uE0EA";
  Glyphs["noteheadCircledXLarge"] = "\uE0EC";
  Glyphs["noteheadClusterDoubleWhole2nd"] = "\uE124";
  Glyphs["noteheadClusterDoubleWhole3rd"] = "\uE128";
  Glyphs["noteheadClusterDoubleWholeBottom"] = "\uE12E";
  Glyphs["noteheadClusterDoubleWholeMiddle"] = "\uE12D";
  Glyphs["noteheadClusterDoubleWholeTop"] = "\uE12C";
  Glyphs["noteheadClusterHalf2nd"] = "\uE126";
  Glyphs["noteheadClusterHalf3rd"] = "\uE12A";
  Glyphs["noteheadClusterHalfBottom"] = "\uE134";
  Glyphs["noteheadClusterHalfMiddle"] = "\uE133";
  Glyphs["noteheadClusterHalfTop"] = "\uE132";
  Glyphs["noteheadClusterQuarter2nd"] = "\uE127";
  Glyphs["noteheadClusterQuarter3rd"] = "\uE12B";
  Glyphs["noteheadClusterQuarterBottom"] = "\uE137";
  Glyphs["noteheadClusterQuarterMiddle"] = "\uE136";
  Glyphs["noteheadClusterQuarterTop"] = "\uE135";
  Glyphs["noteheadClusterRoundBlack"] = "\uE123";
  Glyphs["noteheadClusterRoundWhite"] = "\uE122";
  Glyphs["noteheadClusterSquareBlack"] = "\uE121";
  Glyphs["noteheadClusterSquareWhite"] = "\uE120";
  Glyphs["noteheadClusterWhole2nd"] = "\uE125";
  Glyphs["noteheadClusterWhole3rd"] = "\uE129";
  Glyphs["noteheadClusterWholeBottom"] = "\uE131";
  Glyphs["noteheadClusterWholeMiddle"] = "\uE130";
  Glyphs["noteheadClusterWholeTop"] = "\uE12F";
  Glyphs["noteheadCowellEleventhNoteSeriesHalf"] = "\uEEAE";
  Glyphs["noteheadCowellEleventhNoteSeriesWhole"] = "\uEEAD";
  Glyphs["noteheadCowellEleventhSeriesBlack"] = "\uEEAF";
  Glyphs["noteheadCowellFifteenthNoteSeriesBlack"] = "\uEEB5";
  Glyphs["noteheadCowellFifteenthNoteSeriesHalf"] = "\uEEB4";
  Glyphs["noteheadCowellFifteenthNoteSeriesWhole"] = "\uEEB3";
  Glyphs["noteheadCowellFifthNoteSeriesBlack"] = "\uEEA6";
  Glyphs["noteheadCowellFifthNoteSeriesHalf"] = "\uEEA5";
  Glyphs["noteheadCowellFifthNoteSeriesWhole"] = "\uEEA4";
  Glyphs["noteheadCowellNinthNoteSeriesBlack"] = "\uEEAC";
  Glyphs["noteheadCowellNinthNoteSeriesHalf"] = "\uEEAB";
  Glyphs["noteheadCowellNinthNoteSeriesWhole"] = "\uEEAA";
  Glyphs["noteheadCowellSeventhNoteSeriesBlack"] = "\uEEA9";
  Glyphs["noteheadCowellSeventhNoteSeriesHalf"] = "\uEEA8";
  Glyphs["noteheadCowellSeventhNoteSeriesWhole"] = "\uEEA7";
  Glyphs["noteheadCowellThirdNoteSeriesBlack"] = "\uEEA3";
  Glyphs["noteheadCowellThirdNoteSeriesHalf"] = "\uEEA2";
  Glyphs["noteheadCowellThirdNoteSeriesWhole"] = "\uEEA1";
  Glyphs["noteheadCowellThirteenthNoteSeriesBlack"] = "\uEEB2";
  Glyphs["noteheadCowellThirteenthNoteSeriesHalf"] = "\uEEB1";
  Glyphs["noteheadCowellThirteenthNoteSeriesWhole"] = "\uEEB0";
  Glyphs["noteheadDiamondBlack"] = "\uE0DB";
  Glyphs["noteheadDiamondBlackOld"] = "\uE0E2";
  Glyphs["noteheadDiamondBlackWide"] = "\uE0DC";
  Glyphs["noteheadDiamondClusterBlack2nd"] = "\uE139";
  Glyphs["noteheadDiamondClusterBlack3rd"] = "\uE13B";
  Glyphs["noteheadDiamondClusterBlackBottom"] = "\uE141";
  Glyphs["noteheadDiamondClusterBlackMiddle"] = "\uE140";
  Glyphs["noteheadDiamondClusterBlackTop"] = "\uE13F";
  Glyphs["noteheadDiamondClusterWhite2nd"] = "\uE138";
  Glyphs["noteheadDiamondClusterWhite3rd"] = "\uE13A";
  Glyphs["noteheadDiamondClusterWhiteBottom"] = "\uE13E";
  Glyphs["noteheadDiamondClusterWhiteMiddle"] = "\uE13D";
  Glyphs["noteheadDiamondClusterWhiteTop"] = "\uE13C";
  Glyphs["noteheadDiamondDoubleWhole"] = "\uE0D7";
  Glyphs["noteheadDiamondDoubleWholeOld"] = "\uE0DF";
  Glyphs["noteheadDiamondHalf"] = "\uE0D9";
  Glyphs["noteheadDiamondHalfFilled"] = "\uE0E3";
  Glyphs["noteheadDiamondHalfOld"] = "\uE0E1";
  Glyphs["noteheadDiamondHalfWide"] = "\uE0DA";
  Glyphs["noteheadDiamondOpen"] = "\uE0FC";
  Glyphs["noteheadDiamondWhite"] = "\uE0DD";
  Glyphs["noteheadDiamondWhiteWide"] = "\uE0DE";
  Glyphs["noteheadDiamondWhole"] = "\uE0D8";
  Glyphs["noteheadDiamondWholeOld"] = "\uE0E0";
  Glyphs["noteheadDoubleWhole"] = "\uE0A0";
  Glyphs["noteheadDoubleWholeSquare"] = "\uE0A1";
  Glyphs["noteheadDoubleWholeWithX"] = "\uE0B4";
  Glyphs["noteheadHalf"] = "\uE0A3";
  Glyphs["noteheadHalfFilled"] = "\uE0FB";
  Glyphs["noteheadHalfWithX"] = "\uE0B6";
  Glyphs["noteheadHeavyX"] = "\uE0F8";
  Glyphs["noteheadHeavyXHat"] = "\uE0F9";
  Glyphs["noteheadLargeArrowDownBlack"] = "\uE0F4";
  Glyphs["noteheadLargeArrowDownDoubleWhole"] = "\uE0F1";
  Glyphs["noteheadLargeArrowDownHalf"] = "\uE0F3";
  Glyphs["noteheadLargeArrowDownWhole"] = "\uE0F2";
  Glyphs["noteheadLargeArrowUpBlack"] = "\uE0F0";
  Glyphs["noteheadLargeArrowUpDoubleWhole"] = "\uE0ED";
  Glyphs["noteheadLargeArrowUpHalf"] = "\uE0EF";
  Glyphs["noteheadLargeArrowUpWhole"] = "\uE0EE";
  Glyphs["noteheadMoonBlack"] = "\uE0CB";
  Glyphs["noteheadMoonWhite"] = "\uE0CA";
  Glyphs["noteheadNancarrowSine"] = "\uEEA0";
  Glyphs["noteheadNull"] = "\uE0A5";
  Glyphs["noteheadParenthesis"] = "\uE0CE";
  Glyphs["noteheadParenthesisLeft"] = "\uE0F5";
  Glyphs["noteheadParenthesisRight"] = "\uE0F6";
  Glyphs["noteheadPlusBlack"] = "\uE0AF";
  Glyphs["noteheadPlusDoubleWhole"] = "\uE0AC";
  Glyphs["noteheadPlusHalf"] = "\uE0AE";
  Glyphs["noteheadPlusWhole"] = "\uE0AD";
  Glyphs["noteheadRectangularClusterBlackBottom"] = "\uE144";
  Glyphs["noteheadRectangularClusterBlackMiddle"] = "\uE143";
  Glyphs["noteheadRectangularClusterBlackTop"] = "\uE142";
  Glyphs["noteheadRectangularClusterWhiteBottom"] = "\uE147";
  Glyphs["noteheadRectangularClusterWhiteMiddle"] = "\uE146";
  Glyphs["noteheadRectangularClusterWhiteTop"] = "\uE145";
  Glyphs["noteheadRoundBlack"] = "\uE113";
  Glyphs["noteheadRoundBlackDoubleSlashed"] = "\uE11C";
  Glyphs["noteheadRoundBlackLarge"] = "\uE110";
  Glyphs["noteheadRoundBlackSlashed"] = "\uE118";
  Glyphs["noteheadRoundBlackSlashedLarge"] = "\uE116";
  Glyphs["noteheadRoundWhite"] = "\uE114";
  Glyphs["noteheadRoundWhiteDoubleSlashed"] = "\uE11D";
  Glyphs["noteheadRoundWhiteLarge"] = "\uE111";
  Glyphs["noteheadRoundWhiteSlashed"] = "\uE119";
  Glyphs["noteheadRoundWhiteSlashedLarge"] = "\uE117";
  Glyphs["noteheadRoundWhiteWithDot"] = "\uE115";
  Glyphs["noteheadRoundWhiteWithDotLarge"] = "\uE112";
  Glyphs["noteheadSlashDiamondWhite"] = "\uE104";
  Glyphs["noteheadSlashHorizontalEnds"] = "\uE101";
  Glyphs["noteheadSlashHorizontalEndsMuted"] = "\uE108";
  Glyphs["noteheadSlashVerticalEnds"] = "\uE100";
  Glyphs["noteheadSlashVerticalEndsMuted"] = "\uE107";
  Glyphs["noteheadSlashVerticalEndsSmall"] = "\uE105";
  Glyphs["noteheadSlashWhiteDoubleWhole"] = "\uE10A";
  Glyphs["noteheadSlashWhiteHalf"] = "\uE103";
  Glyphs["noteheadSlashWhiteMuted"] = "\uE109";
  Glyphs["noteheadSlashWhiteWhole"] = "\uE102";
  Glyphs["noteheadSlashX"] = "\uE106";
  Glyphs["noteheadSlashedBlack1"] = "\uE0CF";
  Glyphs["noteheadSlashedBlack2"] = "\uE0D0";
  Glyphs["noteheadSlashedDoubleWhole1"] = "\uE0D5";
  Glyphs["noteheadSlashedDoubleWhole2"] = "\uE0D6";
  Glyphs["noteheadSlashedHalf1"] = "\uE0D1";
  Glyphs["noteheadSlashedHalf2"] = "\uE0D2";
  Glyphs["noteheadSlashedWhole1"] = "\uE0D3";
  Glyphs["noteheadSlashedWhole2"] = "\uE0D4";
  Glyphs["noteheadSquareBlack"] = "\uE0B9";
  Glyphs["noteheadSquareBlackLarge"] = "\uE11A";
  Glyphs["noteheadSquareBlackWhite"] = "\uE11B";
  Glyphs["noteheadSquareWhite"] = "\uE0B8";
  Glyphs["noteheadTriangleDownBlack"] = "\uE0C7";
  Glyphs["noteheadTriangleDownDoubleWhole"] = "\uE0C3";
  Glyphs["noteheadTriangleDownHalf"] = "\uE0C5";
  Glyphs["noteheadTriangleDownWhite"] = "\uE0C6";
  Glyphs["noteheadTriangleDownWhole"] = "\uE0C4";
  Glyphs["noteheadTriangleLeftBlack"] = "\uE0C0";
  Glyphs["noteheadTriangleLeftWhite"] = "\uE0BF";
  Glyphs["noteheadTriangleRightBlack"] = "\uE0C2";
  Glyphs["noteheadTriangleRightWhite"] = "\uE0C1";
  Glyphs["noteheadTriangleRoundDownBlack"] = "\uE0CD";
  Glyphs["noteheadTriangleRoundDownWhite"] = "\uE0CC";
  Glyphs["noteheadTriangleUpBlack"] = "\uE0BE";
  Glyphs["noteheadTriangleUpDoubleWhole"] = "\uE0BA";
  Glyphs["noteheadTriangleUpHalf"] = "\uE0BC";
  Glyphs["noteheadTriangleUpRightBlack"] = "\uE0C9";
  Glyphs["noteheadTriangleUpRightWhite"] = "\uE0C8";
  Glyphs["noteheadTriangleUpWhite"] = "\uE0BD";
  Glyphs["noteheadTriangleUpWhole"] = "\uE0BB";
  Glyphs["noteheadVoidWithX"] = "\uE0B7";
  Glyphs["noteheadWhole"] = "\uE0A2";
  Glyphs["noteheadWholeFilled"] = "\uE0FA";
  Glyphs["noteheadWholeWithX"] = "\uE0B5";
  Glyphs["noteheadXBlack"] = "\uE0A9";
  Glyphs["noteheadXDoubleWhole"] = "\uE0A6";
  Glyphs["noteheadXHalf"] = "\uE0A8";
  Glyphs["noteheadXOrnate"] = "\uE0AA";
  Glyphs["noteheadXOrnateEllipse"] = "\uE0AB";
  Glyphs["noteheadXWhole"] = "\uE0A7";
  Glyphs["octaveBaselineA"] = "\uEC91";
  Glyphs["octaveBaselineB"] = "\uEC93";
  Glyphs["octaveBaselineM"] = "\uEC95";
  Glyphs["octaveBaselineV"] = "\uEC97";
  Glyphs["octaveBassa"] = "\uE51F";
  Glyphs["octaveLoco"] = "\uEC90";
  Glyphs["octaveParensLeft"] = "\uE51A";
  Glyphs["octaveParensRight"] = "\uE51B";
  Glyphs["octaveSuperscriptA"] = "\uEC92";
  Glyphs["octaveSuperscriptB"] = "\uEC94";
  Glyphs["octaveSuperscriptM"] = "\uEC96";
  Glyphs["octaveSuperscriptV"] = "\uEC98";
  Glyphs["oneHandedRollStevens"] = "\uE233";
  Glyphs["organGerman2Fusae"] = "\uEE2E";
  Glyphs["organGerman2Minimae"] = "\uEE2C";
  Glyphs["organGerman2OctaveUp"] = "\uEE19";
  Glyphs["organGerman2Semifusae"] = "\uEE2F";
  Glyphs["organGerman2Semiminimae"] = "\uEE2D";
  Glyphs["organGerman3Fusae"] = "\uEE32";
  Glyphs["organGerman3Minimae"] = "\uEE30";
  Glyphs["organGerman3Semifusae"] = "\uEE33";
  Glyphs["organGerman3Semiminimae"] = "\uEE31";
  Glyphs["organGerman4Fusae"] = "\uEE36";
  Glyphs["organGerman4Minimae"] = "\uEE34";
  Glyphs["organGerman4Semifusae"] = "\uEE37";
  Glyphs["organGerman4Semiminimae"] = "\uEE35";
  Glyphs["organGerman5Fusae"] = "\uEE3A";
  Glyphs["organGerman5Minimae"] = "\uEE38";
  Glyphs["organGerman5Semifusae"] = "\uEE3B";
  Glyphs["organGerman5Semiminimae"] = "\uEE39";
  Glyphs["organGerman6Fusae"] = "\uEE3E";
  Glyphs["organGerman6Minimae"] = "\uEE3C";
  Glyphs["organGerman6Semifusae"] = "\uEE3F";
  Glyphs["organGerman6Semiminimae"] = "\uEE3D";
  Glyphs["organGermanALower"] = "\uEE15";
  Glyphs["organGermanAUpper"] = "\uEE09";
  Glyphs["organGermanAugmentationDot"] = "\uEE1C";
  Glyphs["organGermanBLower"] = "\uEE16";
  Glyphs["organGermanBUpper"] = "\uEE0A";
  Glyphs["organGermanBuxheimerBrevis2"] = "\uEE25";
  Glyphs["organGermanBuxheimerBrevis3"] = "\uEE24";
  Glyphs["organGermanBuxheimerMinimaRest"] = "\uEE1E";
  Glyphs["organGermanBuxheimerSemibrevis"] = "\uEE26";
  Glyphs["organGermanBuxheimerSemibrevisRest"] = "\uEE1D";
  Glyphs["organGermanCLower"] = "\uEE0C";
  Glyphs["organGermanCUpper"] = "\uEE00";
  Glyphs["organGermanCisLower"] = "\uEE0D";
  Glyphs["organGermanCisUpper"] = "\uEE01";
  Glyphs["organGermanDLower"] = "\uEE0E";
  Glyphs["organGermanDUpper"] = "\uEE02";
  Glyphs["organGermanDisLower"] = "\uEE0F";
  Glyphs["organGermanDisUpper"] = "\uEE03";
  Glyphs["organGermanELower"] = "\uEE10";
  Glyphs["organGermanEUpper"] = "\uEE04";
  Glyphs["organGermanFLower"] = "\uEE11";
  Glyphs["organGermanFUpper"] = "\uEE05";
  Glyphs["organGermanFisLower"] = "\uEE12";
  Glyphs["organGermanFisUpper"] = "\uEE06";
  Glyphs["organGermanFusa"] = "\uEE2A";
  Glyphs["organGermanFusaRest"] = "\uEE22";
  Glyphs["organGermanGLower"] = "\uEE13";
  Glyphs["organGermanGUpper"] = "\uEE07";
  Glyphs["organGermanGisLower"] = "\uEE14";
  Glyphs["organGermanGisUpper"] = "\uEE08";
  Glyphs["organGermanHLower"] = "\uEE17";
  Glyphs["organGermanHUpper"] = "\uEE0B";
  Glyphs["organGermanMinima"] = "\uEE28";
  Glyphs["organGermanMinimaRest"] = "\uEE20";
  Glyphs["organGermanOctaveDown"] = "\uEE1A";
  Glyphs["organGermanOctaveUp"] = "\uEE18";
  Glyphs["organGermanSemibrevis"] = "\uEE27";
  Glyphs["organGermanSemibrevisRest"] = "\uEE1F";
  Glyphs["organGermanSemifusa"] = "\uEE2B";
  Glyphs["organGermanSemifusaRest"] = "\uEE23";
  Glyphs["organGermanSemiminima"] = "\uEE29";
  Glyphs["organGermanSemiminimaRest"] = "\uEE21";
  Glyphs["organGermanTie"] = "\uEE1B";
  Glyphs["ornamentBottomLeftConcaveStroke"] = "\uE59A";
  Glyphs["ornamentBottomLeftConcaveStrokeLarge"] = "\uE59B";
  Glyphs["ornamentBottomLeftConvexStroke"] = "\uE59C";
  Glyphs["ornamentBottomRightConcaveStroke"] = "\uE5A7";
  Glyphs["ornamentBottomRightConvexStroke"] = "\uE5A8";
  Glyphs["ornamentComma"] = "\uE581";
  Glyphs["ornamentDoubleObliqueLinesAfterNote"] = "\uE57E";
  Glyphs["ornamentDoubleObliqueLinesBeforeNote"] = "\uE57D";
  Glyphs["ornamentDownCurve"] = "\uE578";
  Glyphs["ornamentHaydn"] = "\uE56F";
  Glyphs["ornamentHighLeftConcaveStroke"] = "\uE592";
  Glyphs["ornamentHighLeftConvexStroke"] = "\uE593";
  Glyphs["ornamentHighRightConcaveStroke"] = "\uE5A2";
  Glyphs["ornamentHighRightConvexStroke"] = "\uE5A3";
  Glyphs["ornamentHookAfterNote"] = "\uE576";
  Glyphs["ornamentHookBeforeNote"] = "\uE575";
  Glyphs["ornamentLeftFacingHalfCircle"] = "\uE572";
  Glyphs["ornamentLeftFacingHook"] = "\uE574";
  Glyphs["ornamentLeftPlus"] = "\uE597";
  Glyphs["ornamentLeftShakeT"] = "\uE596";
  Glyphs["ornamentLeftVerticalStroke"] = "\uE594";
  Glyphs["ornamentLeftVerticalStrokeWithCross"] = "\uE595";
  Glyphs["ornamentLowLeftConcaveStroke"] = "\uE598";
  Glyphs["ornamentLowLeftConvexStroke"] = "\uE599";
  Glyphs["ornamentLowRightConcaveStroke"] = "\uE5A5";
  Glyphs["ornamentLowRightConvexStroke"] = "\uE5A6";
  Glyphs["ornamentMiddleVerticalStroke"] = "\uE59F";
  Glyphs["ornamentMordent"] = "\uE56D";
  Glyphs["ornamentObliqueLineAfterNote"] = "\uE57C";
  Glyphs["ornamentObliqueLineBeforeNote"] = "\uE57B";
  Glyphs["ornamentObliqueLineHorizAfterNote"] = "\uE580";
  Glyphs["ornamentObliqueLineHorizBeforeNote"] = "\uE57F";
  Glyphs["ornamentOriscus"] = "\uEA21";
  Glyphs["ornamentPinceCouperin"] = "\uE588";
  Glyphs["ornamentPortDeVoixV"] = "\uE570";
  Glyphs["ornamentPrecompAppoggTrill"] = "\uE5B2";
  Glyphs["ornamentPrecompAppoggTrillSuffix"] = "\uE5B3";
  Glyphs["ornamentPrecompCadence"] = "\uE5BE";
  Glyphs["ornamentPrecompCadenceUpperPrefix"] = "\uE5C1";
  Glyphs["ornamentPrecompCadenceUpperPrefixTurn"] = "\uE5C2";
  Glyphs["ornamentPrecompCadenceWithTurn"] = "\uE5BF";
  Glyphs["ornamentPrecompDescendingSlide"] = "\uE5B1";
  Glyphs["ornamentPrecompDoubleCadenceLowerPrefix"] = "\uE5C0";
  Glyphs["ornamentPrecompDoubleCadenceUpperPrefix"] = "\uE5C3";
  Glyphs["ornamentPrecompDoubleCadenceUpperPrefixTurn"] = "\uE5C4";
  Glyphs["ornamentPrecompInvertedMordentUpperPrefix"] = "\uE5C7";
  Glyphs["ornamentPrecompMordentRelease"] = "\uE5C5";
  Glyphs["ornamentPrecompMordentUpperPrefix"] = "\uE5C6";
  Glyphs["ornamentPrecompPortDeVoixMordent"] = "\uE5BC";
  Glyphs["ornamentPrecompSlide"] = "\uE5B0";
  Glyphs["ornamentPrecompSlideTrillBach"] = "\uE5B8";
  Glyphs["ornamentPrecompSlideTrillDAnglebert"] = "\uE5B5";
  Glyphs["ornamentPrecompSlideTrillMarpurg"] = "\uE5B6";
  Glyphs["ornamentPrecompSlideTrillMuffat"] = "\uE5B9";
  Glyphs["ornamentPrecompSlideTrillSuffixMuffat"] = "\uE5BA";
  Glyphs["ornamentPrecompTrillLowerSuffix"] = "\uE5C8";
  Glyphs["ornamentPrecompTrillSuffixDandrieu"] = "\uE5BB";
  Glyphs["ornamentPrecompTrillWithMordent"] = "\uE5BD";
  Glyphs["ornamentPrecompTurnTrillBach"] = "\uE5B7";
  Glyphs["ornamentPrecompTurnTrillDAnglebert"] = "\uE5B4";
  Glyphs["ornamentQuilisma"] = "\uEA20";
  Glyphs["ornamentRightFacingHalfCircle"] = "\uE571";
  Glyphs["ornamentRightFacingHook"] = "\uE573";
  Glyphs["ornamentRightVerticalStroke"] = "\uE5A4";
  Glyphs["ornamentSchleifer"] = "\uE587";
  Glyphs["ornamentShake3"] = "\uE582";
  Glyphs["ornamentShakeMuffat1"] = "\uE584";
  Glyphs["ornamentShortObliqueLineAfterNote"] = "\uE57A";
  Glyphs["ornamentShortObliqueLineBeforeNote"] = "\uE579";
  Glyphs["ornamentShortTrill"] = "\uE56C";
  Glyphs["ornamentTopLeftConcaveStroke"] = "\uE590";
  Glyphs["ornamentTopLeftConvexStroke"] = "\uE591";
  Glyphs["ornamentTopRightConcaveStroke"] = "\uE5A0";
  Glyphs["ornamentTopRightConvexStroke"] = "\uE5A1";
  Glyphs["ornamentTremblement"] = "\uE56E";
  Glyphs["ornamentTremblementCouperin"] = "\uE589";
  Glyphs["ornamentTrill"] = "\uE566";
  Glyphs["ornamentTurn"] = "\uE567";
  Glyphs["ornamentTurnInverted"] = "\uE568";
  Glyphs["ornamentTurnSlash"] = "\uE569";
  Glyphs["ornamentTurnUp"] = "\uE56A";
  Glyphs["ornamentTurnUpS"] = "\uE56B";
  Glyphs["ornamentUpCurve"] = "\uE577";
  Glyphs["ornamentVerticalLine"] = "\uE583";
  Glyphs["ornamentZigZagLineNoRightEnd"] = "\uE59D";
  Glyphs["ornamentZigZagLineWithRightEnd"] = "\uE59E";
  Glyphs["ottava"] = "\uE510";
  Glyphs["ottavaAlta"] = "\uE511";
  Glyphs["ottavaBassa"] = "\uE512";
  Glyphs["ottavaBassaBa"] = "\uE513";
  Glyphs["ottavaBassaVb"] = "\uE51C";
  Glyphs["pendereckiTremolo"] = "\uE22B";
  Glyphs["pictAgogo"] = "\uE717";
  Glyphs["pictAlmglocken"] = "\uE712";
  Glyphs["pictAnvil"] = "\uE701";
  Glyphs["pictBambooChimes"] = "\uE6C3";
  Glyphs["pictBambooScraper"] = "\uE6FB";
  Glyphs["pictBassDrum"] = "\uE6D4";
  Glyphs["pictBassDrumOnSide"] = "\uE6D5";
  Glyphs["pictBeaterBow"] = "\uE7DE";
  Glyphs["pictBeaterBox"] = "\uE7EB";
  Glyphs["pictBeaterBrassMalletsDown"] = "\uE7DA";
  Glyphs["pictBeaterBrassMalletsLeft"] = "\uE7EE";
  Glyphs["pictBeaterBrassMalletsRight"] = "\uE7ED";
  Glyphs["pictBeaterBrassMalletsUp"] = "\uE7D9";
  Glyphs["pictBeaterCombiningDashedCircle"] = "\uE7EA";
  Glyphs["pictBeaterCombiningParentheses"] = "\uE7E9";
  Glyphs["pictBeaterDoubleBassDrumDown"] = "\uE7A1";
  Glyphs["pictBeaterDoubleBassDrumUp"] = "\uE7A0";
  Glyphs["pictBeaterFinger"] = "\uE7E4";
  Glyphs["pictBeaterFingernails"] = "\uE7E6";
  Glyphs["pictBeaterFist"] = "\uE7E5";
  Glyphs["pictBeaterGuiroScraper"] = "\uE7DD";
  Glyphs["pictBeaterHammer"] = "\uE7E1";
  Glyphs["pictBeaterHammerMetalDown"] = "\uE7D0";
  Glyphs["pictBeaterHammerMetalUp"] = "\uE7CF";
  Glyphs["pictBeaterHammerPlasticDown"] = "\uE7CE";
  Glyphs["pictBeaterHammerPlasticUp"] = "\uE7CD";
  Glyphs["pictBeaterHammerWoodDown"] = "\uE7CC";
  Glyphs["pictBeaterHammerWoodUp"] = "\uE7CB";
  Glyphs["pictBeaterHand"] = "\uE7E3";
  Glyphs["pictBeaterHardBassDrumDown"] = "\uE79D";
  Glyphs["pictBeaterHardBassDrumUp"] = "\uE79C";
  Glyphs["pictBeaterHardGlockenspielDown"] = "\uE785";
  Glyphs["pictBeaterHardGlockenspielLeft"] = "\uE787";
  Glyphs["pictBeaterHardGlockenspielRight"] = "\uE786";
  Glyphs["pictBeaterHardGlockenspielUp"] = "\uE784";
  Glyphs["pictBeaterHardTimpaniDown"] = "\uE791";
  Glyphs["pictBeaterHardTimpaniLeft"] = "\uE793";
  Glyphs["pictBeaterHardTimpaniRight"] = "\uE792";
  Glyphs["pictBeaterHardTimpaniUp"] = "\uE790";
  Glyphs["pictBeaterHardXylophoneDown"] = "\uE779";
  Glyphs["pictBeaterHardXylophoneLeft"] = "\uE77B";
  Glyphs["pictBeaterHardXylophoneRight"] = "\uE77A";
  Glyphs["pictBeaterHardXylophoneUp"] = "\uE778";
  Glyphs["pictBeaterHardYarnDown"] = "\uE7AB";
  Glyphs["pictBeaterHardYarnLeft"] = "\uE7AD";
  Glyphs["pictBeaterHardYarnRight"] = "\uE7AC";
  Glyphs["pictBeaterHardYarnUp"] = "\uE7AA";
  Glyphs["pictBeaterJazzSticksDown"] = "\uE7D4";
  Glyphs["pictBeaterJazzSticksUp"] = "\uE7D3";
  Glyphs["pictBeaterKnittingNeedle"] = "\uE7E2";
  Glyphs["pictBeaterMallet"] = "\uE7DF";
  Glyphs["pictBeaterMalletDown"] = "\uE7EC";
  Glyphs["pictBeaterMediumBassDrumDown"] = "\uE79B";
  Glyphs["pictBeaterMediumBassDrumUp"] = "\uE79A";
  Glyphs["pictBeaterMediumTimpaniDown"] = "\uE78D";
  Glyphs["pictBeaterMediumTimpaniLeft"] = "\uE78F";
  Glyphs["pictBeaterMediumTimpaniRight"] = "\uE78E";
  Glyphs["pictBeaterMediumTimpaniUp"] = "\uE78C";
  Glyphs["pictBeaterMediumXylophoneDown"] = "\uE775";
  Glyphs["pictBeaterMediumXylophoneLeft"] = "\uE777";
  Glyphs["pictBeaterMediumXylophoneRight"] = "\uE776";
  Glyphs["pictBeaterMediumXylophoneUp"] = "\uE774";
  Glyphs["pictBeaterMediumYarnDown"] = "\uE7A7";
  Glyphs["pictBeaterMediumYarnLeft"] = "\uE7A9";
  Glyphs["pictBeaterMediumYarnRight"] = "\uE7A8";
  Glyphs["pictBeaterMediumYarnUp"] = "\uE7A6";
  Glyphs["pictBeaterMetalBassDrumDown"] = "\uE79F";
  Glyphs["pictBeaterMetalBassDrumUp"] = "\uE79E";
  Glyphs["pictBeaterMetalDown"] = "\uE7C8";
  Glyphs["pictBeaterMetalHammer"] = "\uE7E0";
  Glyphs["pictBeaterMetalLeft"] = "\uE7CA";
  Glyphs["pictBeaterMetalRight"] = "\uE7C9";
  Glyphs["pictBeaterMetalUp"] = "\uE7C7";
  Glyphs["pictBeaterSnareSticksDown"] = "\uE7D2";
  Glyphs["pictBeaterSnareSticksUp"] = "\uE7D1";
  Glyphs["pictBeaterSoftBassDrumDown"] = "\uE799";
  Glyphs["pictBeaterSoftBassDrumUp"] = "\uE798";
  Glyphs["pictBeaterSoftGlockenspielDown"] = "\uE781";
  Glyphs["pictBeaterSoftGlockenspielLeft"] = "\uE783";
  Glyphs["pictBeaterSoftGlockenspielRight"] = "\uE782";
  Glyphs["pictBeaterSoftGlockenspielUp"] = "\uE780";
  Glyphs["pictBeaterSoftTimpaniDown"] = "\uE789";
  Glyphs["pictBeaterSoftTimpaniLeft"] = "\uE78B";
  Glyphs["pictBeaterSoftTimpaniRight"] = "\uE78A";
  Glyphs["pictBeaterSoftTimpaniUp"] = "\uE788";
  Glyphs["pictBeaterSoftXylophone"] = "\uE7DB";
  Glyphs["pictBeaterSoftXylophoneDown"] = "\uE771";
  Glyphs["pictBeaterSoftXylophoneLeft"] = "\uE773";
  Glyphs["pictBeaterSoftXylophoneRight"] = "\uE772";
  Glyphs["pictBeaterSoftXylophoneUp"] = "\uE770";
  Glyphs["pictBeaterSoftYarnDown"] = "\uE7A3";
  Glyphs["pictBeaterSoftYarnLeft"] = "\uE7A5";
  Glyphs["pictBeaterSoftYarnRight"] = "\uE7A4";
  Glyphs["pictBeaterSoftYarnUp"] = "\uE7A2";
  Glyphs["pictBeaterSpoonWoodenMallet"] = "\uE7DC";
  Glyphs["pictBeaterSuperballDown"] = "\uE7AF";
  Glyphs["pictBeaterSuperballLeft"] = "\uE7B1";
  Glyphs["pictBeaterSuperballRight"] = "\uE7B0";
  Glyphs["pictBeaterSuperballUp"] = "\uE7AE";
  Glyphs["pictBeaterTriangleDown"] = "\uE7D6";
  Glyphs["pictBeaterTrianglePlain"] = "\uE7EF";
  Glyphs["pictBeaterTriangleUp"] = "\uE7D5";
  Glyphs["pictBeaterWireBrushesDown"] = "\uE7D8";
  Glyphs["pictBeaterWireBrushesUp"] = "\uE7D7";
  Glyphs["pictBeaterWoodTimpaniDown"] = "\uE795";
  Glyphs["pictBeaterWoodTimpaniLeft"] = "\uE797";
  Glyphs["pictBeaterWoodTimpaniRight"] = "\uE796";
  Glyphs["pictBeaterWoodTimpaniUp"] = "\uE794";
  Glyphs["pictBeaterWoodXylophoneDown"] = "\uE77D";
  Glyphs["pictBeaterWoodXylophoneLeft"] = "\uE77F";
  Glyphs["pictBeaterWoodXylophoneRight"] = "\uE77E";
  Glyphs["pictBeaterWoodXylophoneUp"] = "\uE77C";
  Glyphs["pictBell"] = "\uE714";
  Glyphs["pictBellOfCymbal"] = "\uE72A";
  Glyphs["pictBellPlate"] = "\uE713";
  Glyphs["pictBellTree"] = "\uE71A";
  Glyphs["pictBirdWhistle"] = "\uE751";
  Glyphs["pictBoardClapper"] = "\uE6F7";
  Glyphs["pictBongos"] = "\uE6DD";
  Glyphs["pictBrakeDrum"] = "\uE6E1";
  Glyphs["pictCabasa"] = "\uE743";
  Glyphs["pictCannon"] = "\uE761";
  Glyphs["pictCarHorn"] = "\uE755";
  Glyphs["pictCastanets"] = "\uE6F8";
  Glyphs["pictCastanetsWithHandle"] = "\uE6F9";
  Glyphs["pictCelesta"] = "\uE6B0";
  Glyphs["pictCencerro"] = "\uE716";
  Glyphs["pictCenter1"] = "\uE7FE";
  Glyphs["pictCenter2"] = "\uE7FF";
  Glyphs["pictCenter3"] = "\uE800";
  Glyphs["pictChainRattle"] = "\uE748";
  Glyphs["pictChimes"] = "\uE6C2";
  Glyphs["pictChineseCymbal"] = "\uE726";
  Glyphs["pictChokeCymbal"] = "\uE805";
  Glyphs["pictClaves"] = "\uE6F2";
  Glyphs["pictCoins"] = "\uE7E7";
  Glyphs["pictConga"] = "\uE6DE";
  Glyphs["pictCowBell"] = "\uE711";
  Glyphs["pictCrashCymbals"] = "\uE720";
  Glyphs["pictCrotales"] = "\uE6AE";
  Glyphs["pictCrushStem"] = "\uE80C";
  Glyphs["pictCuica"] = "\uE6E4";
  Glyphs["pictCymbalTongs"] = "\uE728";
  Glyphs["pictDamp1"] = "\uE7F9";
  Glyphs["pictDamp2"] = "\uE7FA";
  Glyphs["pictDamp3"] = "\uE7FB";
  Glyphs["pictDamp4"] = "\uE7FC";
  Glyphs["pictDeadNoteStem"] = "\uE80D";
  Glyphs["pictDrumStick"] = "\uE7E8";
  Glyphs["pictDuckCall"] = "\uE757";
  Glyphs["pictEdgeOfCymbal"] = "\uE729";
  Glyphs["pictEmptyTrap"] = "\uE6A9";
  Glyphs["pictFingerCymbals"] = "\uE727";
  Glyphs["pictFlexatone"] = "\uE740";
  Glyphs["pictFootballRatchet"] = "\uE6F5";
  Glyphs["pictGlassHarmonica"] = "\uE765";
  Glyphs["pictGlassHarp"] = "\uE764";
  Glyphs["pictGlassPlateChimes"] = "\uE6C6";
  Glyphs["pictGlassTubeChimes"] = "\uE6C5";
  Glyphs["pictGlsp"] = "\uE6A0";
  Glyphs["pictGlspSmithBrindle"] = "\uE6AA";
  Glyphs["pictGobletDrum"] = "\uE6E2";
  Glyphs["pictGong"] = "\uE732";
  Glyphs["pictGongWithButton"] = "\uE733";
  Glyphs["pictGuiro"] = "\uE6F3";
  Glyphs["pictGumHardDown"] = "\uE7C4";
  Glyphs["pictGumHardLeft"] = "\uE7C6";
  Glyphs["pictGumHardRight"] = "\uE7C5";
  Glyphs["pictGumHardUp"] = "\uE7C3";
  Glyphs["pictGumMediumDown"] = "\uE7C0";
  Glyphs["pictGumMediumLeft"] = "\uE7C2";
  Glyphs["pictGumMediumRight"] = "\uE7C1";
  Glyphs["pictGumMediumUp"] = "\uE7BF";
  Glyphs["pictGumSoftDown"] = "\uE7BC";
  Glyphs["pictGumSoftLeft"] = "\uE7BE";
  Glyphs["pictGumSoftRight"] = "\uE7BD";
  Glyphs["pictGumSoftUp"] = "\uE7BB";
  Glyphs["pictHalfOpen1"] = "\uE7F6";
  Glyphs["pictHalfOpen2"] = "\uE7F7";
  Glyphs["pictHandbell"] = "\uE715";
  Glyphs["pictHiHat"] = "\uE722";
  Glyphs["pictHiHatOnStand"] = "\uE723";
  Glyphs["pictJawHarp"] = "\uE767";
  Glyphs["pictJingleBells"] = "\uE719";
  Glyphs["pictKlaxonHorn"] = "\uE756";
  Glyphs["pictLeftHandCircle"] = "\uE807";
  Glyphs["pictLionsRoar"] = "\uE763";
  Glyphs["pictLithophone"] = "\uE6B1";
  Glyphs["pictLogDrum"] = "\uE6DF";
  Glyphs["pictLotusFlute"] = "\uE75A";
  Glyphs["pictMar"] = "\uE6A6";
  Glyphs["pictMarSmithBrindle"] = "\uE6AC";
  Glyphs["pictMaraca"] = "\uE741";
  Glyphs["pictMaracas"] = "\uE742";
  Glyphs["pictMegaphone"] = "\uE759";
  Glyphs["pictMetalPlateChimes"] = "\uE6C8";
  Glyphs["pictMetalTubeChimes"] = "\uE6C7";
  Glyphs["pictMusicalSaw"] = "\uE766";
  Glyphs["pictNormalPosition"] = "\uE804";
  Glyphs["pictOnRim"] = "\uE7F4";
  Glyphs["pictOpen"] = "\uE7F8";
  Glyphs["pictOpenRimShot"] = "\uE7F5";
  Glyphs["pictPistolShot"] = "\uE760";
  Glyphs["pictPoliceWhistle"] = "\uE752";
  Glyphs["pictQuijada"] = "\uE6FA";
  Glyphs["pictRainstick"] = "\uE747";
  Glyphs["pictRatchet"] = "\uE6F4";
  Glyphs["pictRecoReco"] = "\uE6FC";
  Glyphs["pictRightHandSquare"] = "\uE806";
  Glyphs["pictRim1"] = "\uE801";
  Glyphs["pictRim2"] = "\uE802";
  Glyphs["pictRim3"] = "\uE803";
  Glyphs["pictRimShotOnStem"] = "\uE7FD";
  Glyphs["pictSandpaperBlocks"] = "\uE762";
  Glyphs["pictScrapeAroundRim"] = "\uE7F3";
  Glyphs["pictScrapeAroundRimClockwise"] = "\uE80E";
  Glyphs["pictScrapeCenterToEdge"] = "\uE7F1";
  Glyphs["pictScrapeEdgeToCenter"] = "\uE7F2";
  Glyphs["pictShellBells"] = "\uE718";
  Glyphs["pictShellChimes"] = "\uE6C4";
  Glyphs["pictSiren"] = "\uE753";
  Glyphs["pictSistrum"] = "\uE746";
  Glyphs["pictSizzleCymbal"] = "\uE724";
  Glyphs["pictSleighBell"] = "\uE710";
  Glyphs["pictSlideBrushOnGong"] = "\uE734";
  Glyphs["pictSlideWhistle"] = "\uE750";
  Glyphs["pictSlitDrum"] = "\uE6E0";
  Glyphs["pictSnareDrum"] = "\uE6D1";
  Glyphs["pictSnareDrumMilitary"] = "\uE6D3";
  Glyphs["pictSnareDrumSnaresOff"] = "\uE6D2";
  Glyphs["pictSteelDrums"] = "\uE6AF";
  Glyphs["pictStickShot"] = "\uE7F0";
  Glyphs["pictSuperball"] = "\uE7B2";
  Glyphs["pictSuspendedCymbal"] = "\uE721";
  Glyphs["pictSwishStem"] = "\uE808";
  Glyphs["pictTabla"] = "\uE6E3";
  Glyphs["pictTamTam"] = "\uE730";
  Glyphs["pictTamTamWithBeater"] = "\uE731";
  Glyphs["pictTambourine"] = "\uE6DB";
  Glyphs["pictTempleBlocks"] = "\uE6F1";
  Glyphs["pictTenorDrum"] = "\uE6D6";
  Glyphs["pictThundersheet"] = "\uE744";
  Glyphs["pictTimbales"] = "\uE6DC";
  Glyphs["pictTimpani"] = "\uE6D0";
  Glyphs["pictTomTom"] = "\uE6D7";
  Glyphs["pictTomTomChinese"] = "\uE6D8";
  Glyphs["pictTomTomIndoAmerican"] = "\uE6DA";
  Glyphs["pictTomTomJapanese"] = "\uE6D9";
  Glyphs["pictTriangle"] = "\uE700";
  Glyphs["pictTubaphone"] = "\uE6B2";
  Glyphs["pictTubularBells"] = "\uE6C0";
  Glyphs["pictTurnLeftStem"] = "\uE80A";
  Glyphs["pictTurnRightLeftStem"] = "\uE80B";
  Glyphs["pictTurnRightStem"] = "\uE809";
  Glyphs["pictVib"] = "\uE6A7";
  Glyphs["pictVibMotorOff"] = "\uE6A8";
  Glyphs["pictVibSmithBrindle"] = "\uE6AD";
  Glyphs["pictVibraslap"] = "\uE745";
  Glyphs["pictVietnameseHat"] = "\uE725";
  Glyphs["pictWhip"] = "\uE6F6";
  Glyphs["pictWindChimesGlass"] = "\uE6C1";
  Glyphs["pictWindMachine"] = "\uE754";
  Glyphs["pictWindWhistle"] = "\uE758";
  Glyphs["pictWoodBlock"] = "\uE6F0";
  Glyphs["pictWoundHardDown"] = "\uE7B4";
  Glyphs["pictWoundHardLeft"] = "\uE7B6";
  Glyphs["pictWoundHardRight"] = "\uE7B5";
  Glyphs["pictWoundHardUp"] = "\uE7B3";
  Glyphs["pictWoundSoftDown"] = "\uE7B8";
  Glyphs["pictWoundSoftLeft"] = "\uE7BA";
  Glyphs["pictWoundSoftRight"] = "\uE7B9";
  Glyphs["pictWoundSoftUp"] = "\uE7B7";
  Glyphs["pictXyl"] = "\uE6A1";
  Glyphs["pictXylBass"] = "\uE6A3";
  Glyphs["pictXylSmithBrindle"] = "\uE6AB";
  Glyphs["pictXylTenor"] = "\uE6A2";
  Glyphs["pictXylTenorTrough"] = "\uE6A5";
  Glyphs["pictXylTrough"] = "\uE6A4";
  Glyphs["pluckedBuzzPizzicato"] = "\uE632";
  Glyphs["pluckedDamp"] = "\uE638";
  Glyphs["pluckedDampAll"] = "\uE639";
  Glyphs["pluckedDampOnStem"] = "\uE63B";
  Glyphs["pluckedFingernailFlick"] = "\uE637";
  Glyphs["pluckedLeftHandPizzicato"] = "\uE633";
  Glyphs["pluckedPlectrum"] = "\uE63A";
  Glyphs["pluckedSnapPizzicatoAbove"] = "\uE631";
  Glyphs["pluckedSnapPizzicatoBelow"] = "\uE630";
  Glyphs["pluckedWithFingernails"] = "\uE636";
  Glyphs["quindicesima"] = "\uE514";
  Glyphs["quindicesimaAlta"] = "\uE515";
  Glyphs["quindicesimaBassa"] = "\uE516";
  Glyphs["quindicesimaBassaMb"] = "\uE51D";
  Glyphs["repeat1Bar"] = "\uE500";
  Glyphs["repeat2Bars"] = "\uE501";
  Glyphs["repeat4Bars"] = "\uE502";
  Glyphs["repeatBarLowerDot"] = "\uE505";
  Glyphs["repeatBarSlash"] = "\uE504";
  Glyphs["repeatBarUpperDot"] = "\uE503";
  Glyphs["repeatDot"] = "\uE044";
  Glyphs["repeatDots"] = "\uE043";
  Glyphs["repeatLeft"] = "\uE040";
  Glyphs["repeatRight"] = "\uE041";
  Glyphs["repeatRightLeft"] = "\uE042";
  Glyphs["rest1024th"] = "\uE4ED";
  Glyphs["rest128th"] = "\uE4EA";
  Glyphs["rest16th"] = "\uE4E7";
  Glyphs["rest256th"] = "\uE4EB";
  Glyphs["rest32nd"] = "\uE4E8";
  Glyphs["rest512th"] = "\uE4EC";
  Glyphs["rest64th"] = "\uE4E9";
  Glyphs["rest8th"] = "\uE4E6";
  Glyphs["restDoubleWhole"] = "\uE4E2";
  Glyphs["restDoubleWholeLegerLine"] = "\uE4F3";
  Glyphs["restHBar"] = "\uE4EE";
  Glyphs["restHBarLeft"] = "\uE4EF";
  Glyphs["restHBarMiddle"] = "\uE4F0";
  Glyphs["restHBarRight"] = "\uE4F1";
  Glyphs["restHalf"] = "\uE4E4";
  Glyphs["restHalfLegerLine"] = "\uE4F5";
  Glyphs["restLonga"] = "\uE4E1";
  Glyphs["restMaxima"] = "\uE4E0";
  Glyphs["restQuarter"] = "\uE4E5";
  Glyphs["restQuarterOld"] = "\uE4F2";
  Glyphs["restQuarterZ"] = "\uE4F6";
  Glyphs["restWhole"] = "\uE4E3";
  Glyphs["restWholeLegerLine"] = "\uE4F4";
  Glyphs["reversedBrace"] = "\uE001";
  Glyphs["reversedBracketBottom"] = "\uE006";
  Glyphs["reversedBracketTop"] = "\uE005";
  Glyphs["rightRepeatSmall"] = "\uE04D";
  Glyphs["scaleDegree1"] = "\uEF00";
  Glyphs["scaleDegree2"] = "\uEF01";
  Glyphs["scaleDegree3"] = "\uEF02";
  Glyphs["scaleDegree4"] = "\uEF03";
  Glyphs["scaleDegree5"] = "\uEF04";
  Glyphs["scaleDegree6"] = "\uEF05";
  Glyphs["scaleDegree7"] = "\uEF06";
  Glyphs["scaleDegree8"] = "\uEF07";
  Glyphs["scaleDegree9"] = "\uEF08";
  Glyphs["schaefferClef"] = "\uE06F";
  Glyphs["schaefferFClefToGClef"] = "\uE072";
  Glyphs["schaefferGClefToFClef"] = "\uE071";
  Glyphs["schaefferPreviousClef"] = "\uE070";
  Glyphs["segno"] = "\uE047";
  Glyphs["segnoSerpent1"] = "\uE04A";
  Glyphs["segnoSerpent2"] = "\uE04B";
  Glyphs["semipitchedPercussionClef1"] = "\uE06B";
  Glyphs["semipitchedPercussionClef2"] = "\uE06C";
  Glyphs["smnFlat"] = "\uEC52";
  Glyphs["smnFlatWhite"] = "\uEC53";
  Glyphs["smnHistoryDoubleFlat"] = "\uEC57";
  Glyphs["smnHistoryDoubleSharp"] = "\uEC55";
  Glyphs["smnHistoryFlat"] = "\uEC56";
  Glyphs["smnHistorySharp"] = "\uEC54";
  Glyphs["smnNatural"] = "\uEC58";
  Glyphs["smnSharp"] = "\uEC50";
  Glyphs["smnSharpDown"] = "\uEC59";
  Glyphs["smnSharpWhite"] = "\uEC51";
  Glyphs["smnSharpWhiteDown"] = "\uEC5A";
  Glyphs["splitBarDivider"] = "\uE00A";
  Glyphs["staff1Line"] = "\uE010";
  Glyphs["staff1LineNarrow"] = "\uE01C";
  Glyphs["staff1LineWide"] = "\uE016";
  Glyphs["staff2Lines"] = "\uE011";
  Glyphs["staff2LinesNarrow"] = "\uE01D";
  Glyphs["staff2LinesWide"] = "\uE017";
  Glyphs["staff3Lines"] = "\uE012";
  Glyphs["staff3LinesNarrow"] = "\uE01E";
  Glyphs["staff3LinesWide"] = "\uE018";
  Glyphs["staff4Lines"] = "\uE013";
  Glyphs["staff4LinesNarrow"] = "\uE01F";
  Glyphs["staff4LinesWide"] = "\uE019";
  Glyphs["staff5Lines"] = "\uE014";
  Glyphs["staff5LinesNarrow"] = "\uE020";
  Glyphs["staff5LinesWide"] = "\uE01A";
  Glyphs["staff6Lines"] = "\uE015";
  Glyphs["staff6LinesNarrow"] = "\uE021";
  Glyphs["staff6LinesWide"] = "\uE01B";
  Glyphs["staffDivideArrowDown"] = "\uE00B";
  Glyphs["staffDivideArrowUp"] = "\uE00C";
  Glyphs["staffDivideArrowUpDown"] = "\uE00D";
  Glyphs["staffPosLower1"] = "\uEB98";
  Glyphs["staffPosLower2"] = "\uEB99";
  Glyphs["staffPosLower3"] = "\uEB9A";
  Glyphs["staffPosLower4"] = "\uEB9B";
  Glyphs["staffPosLower5"] = "\uEB9C";
  Glyphs["staffPosLower6"] = "\uEB9D";
  Glyphs["staffPosLower7"] = "\uEB9E";
  Glyphs["staffPosLower8"] = "\uEB9F";
  Glyphs["staffPosRaise1"] = "\uEB90";
  Glyphs["staffPosRaise2"] = "\uEB91";
  Glyphs["staffPosRaise3"] = "\uEB92";
  Glyphs["staffPosRaise4"] = "\uEB93";
  Glyphs["staffPosRaise5"] = "\uEB94";
  Glyphs["staffPosRaise6"] = "\uEB95";
  Glyphs["staffPosRaise7"] = "\uEB96";
  Glyphs["staffPosRaise8"] = "\uEB97";
  Glyphs["stem"] = "\uE210";
  Glyphs["stemBowOnBridge"] = "\uE215";
  Glyphs["stemBowOnTailpiece"] = "\uE216";
  Glyphs["stemBuzzRoll"] = "\uE217";
  Glyphs["stemDamp"] = "\uE218";
  Glyphs["stemHarpStringNoise"] = "\uE21F";
  Glyphs["stemMultiphonicsBlack"] = "\uE21A";
  Glyphs["stemMultiphonicsBlackWhite"] = "\uE21C";
  Glyphs["stemMultiphonicsWhite"] = "\uE21B";
  Glyphs["stemPendereckiTremolo"] = "\uE213";
  Glyphs["stemRimShot"] = "\uE21E";
  Glyphs["stemSprechgesang"] = "\uE211";
  Glyphs["stemSulPonticello"] = "\uE214";
  Glyphs["stemSussurando"] = "\uE21D";
  Glyphs["stemSwished"] = "\uE212";
  Glyphs["stemVibratoPulse"] = "\uE219";
  Glyphs["stockhausenTremolo"] = "\uE232";
  Glyphs["stringsBowBehindBridge"] = "\uE618";
  Glyphs["stringsBowBehindBridgeFourStrings"] = "\uE62A";
  Glyphs["stringsBowBehindBridgeOneString"] = "\uE627";
  Glyphs["stringsBowBehindBridgeThreeStrings"] = "\uE629";
  Glyphs["stringsBowBehindBridgeTwoStrings"] = "\uE628";
  Glyphs["stringsBowOnBridge"] = "\uE619";
  Glyphs["stringsBowOnTailpiece"] = "\uE61A";
  Glyphs["stringsChangeBowDirection"] = "\uE626";
  Glyphs["stringsDownBow"] = "\uE610";
  Glyphs["stringsDownBowAwayFromBody"] = "\uEE82";
  Glyphs["stringsDownBowBeyondBridge"] = "\uEE84";
  Glyphs["stringsDownBowTowardsBody"] = "\uEE80";
  Glyphs["stringsDownBowTurned"] = "\uE611";
  Glyphs["stringsFouette"] = "\uE622";
  Glyphs["stringsHalfHarmonic"] = "\uE615";
  Glyphs["stringsHarmonic"] = "\uE614";
  Glyphs["stringsJeteAbove"] = "\uE620";
  Glyphs["stringsJeteBelow"] = "\uE621";
  Glyphs["stringsMuteOff"] = "\uE617";
  Glyphs["stringsMuteOn"] = "\uE616";
  Glyphs["stringsOverpressureDownBow"] = "\uE61B";
  Glyphs["stringsOverpressureNoDirection"] = "\uE61F";
  Glyphs["stringsOverpressurePossibileDownBow"] = "\uE61D";
  Glyphs["stringsOverpressurePossibileUpBow"] = "\uE61E";
  Glyphs["stringsOverpressureUpBow"] = "\uE61C";
  Glyphs["stringsScrapeCircularClockwise"] = "\uEE88";
  Glyphs["stringsScrapeCircularCounterclockwise"] = "\uEE89";
  Glyphs["stringsScrapeParallelInward"] = "\uEE86";
  Glyphs["stringsScrapeParallelOutward"] = "\uEE87";
  Glyphs["stringsThumbPosition"] = "\uE624";
  Glyphs["stringsThumbPositionTurned"] = "\uE625";
  Glyphs["stringsTripleChopInward"] = "\uEE8A";
  Glyphs["stringsTripleChopOutward"] = "\uEE8B";
  Glyphs["stringsUpBow"] = "\uE612";
  Glyphs["stringsUpBowAwayFromBody"] = "\uEE83";
  Glyphs["stringsUpBowBeyondBridge"] = "\uEE85";
  Glyphs["stringsUpBowTowardsBody"] = "\uEE81";
  Glyphs["stringsUpBowTurned"] = "\uE613";
  Glyphs["stringsVibratoPulse"] = "\uE623";
  Glyphs["swissRudimentsNoteheadBlackDouble"] = "\uEE72";
  Glyphs["swissRudimentsNoteheadBlackFlam"] = "\uEE70";
  Glyphs["swissRudimentsNoteheadHalfDouble"] = "\uEE73";
  Glyphs["swissRudimentsNoteheadHalfFlam"] = "\uEE71";
  Glyphs["systemDivider"] = "\uE007";
  Glyphs["systemDividerExtraLong"] = "\uE009";
  Glyphs["systemDividerLong"] = "\uE008";
  Glyphs["textAugmentationDot"] = "\uE1FC";
  Glyphs["textBlackNoteFrac16thLongStem"] = "\uE1F5";
  Glyphs["textBlackNoteFrac16thShortStem"] = "\uE1F4";
  Glyphs["textBlackNoteFrac32ndLongStem"] = "\uE1F6";
  Glyphs["textBlackNoteFrac8thLongStem"] = "\uE1F3";
  Glyphs["textBlackNoteFrac8thShortStem"] = "\uE1F2";
  Glyphs["textBlackNoteLongStem"] = "\uE1F1";
  Glyphs["textBlackNoteShortStem"] = "\uE1F0";
  Glyphs["textCont16thBeamLongStem"] = "\uE1FA";
  Glyphs["textCont16thBeamShortStem"] = "\uE1F9";
  Glyphs["textCont32ndBeamLongStem"] = "\uE1FB";
  Glyphs["textCont8thBeamLongStem"] = "\uE1F8";
  Glyphs["textCont8thBeamShortStem"] = "\uE1F7";
  Glyphs["textHeadlessBlackNoteFrac16thLongStem"] = "\uE209";
  Glyphs["textHeadlessBlackNoteFrac16thShortStem"] = "\uE208";
  Glyphs["textHeadlessBlackNoteFrac32ndLongStem"] = "\uE20A";
  Glyphs["textHeadlessBlackNoteFrac8thLongStem"] = "\uE207";
  Glyphs["textHeadlessBlackNoteFrac8thShortStem"] = "\uE206";
  Glyphs["textHeadlessBlackNoteLongStem"] = "\uE205";
  Glyphs["textHeadlessBlackNoteShortStem"] = "\uE204";
  Glyphs["textTie"] = "\uE1FD";
  Glyphs["textTuplet3LongStem"] = "\uE202";
  Glyphs["textTuplet3ShortStem"] = "\uE1FF";
  Glyphs["textTupletBracketEndLongStem"] = "\uE203";
  Glyphs["textTupletBracketEndShortStem"] = "\uE200";
  Glyphs["textTupletBracketStartLongStem"] = "\uE201";
  Glyphs["textTupletBracketStartShortStem"] = "\uE1FE";
  Glyphs["timeSig0"] = "\uE080";
  Glyphs["timeSig0Reversed"] = "\uECF0";
  Glyphs["timeSig0Turned"] = "\uECE0";
  Glyphs["timeSig1"] = "\uE081";
  Glyphs["timeSig1Reversed"] = "\uECF1";
  Glyphs["timeSig1Turned"] = "\uECE1";
  Glyphs["timeSig2"] = "\uE082";
  Glyphs["timeSig2Reversed"] = "\uECF2";
  Glyphs["timeSig2Turned"] = "\uECE2";
  Glyphs["timeSig3"] = "\uE083";
  Glyphs["timeSig3Reversed"] = "\uECF3";
  Glyphs["timeSig3Turned"] = "\uECE3";
  Glyphs["timeSig4"] = "\uE084";
  Glyphs["timeSig4Reversed"] = "\uECF4";
  Glyphs["timeSig4Turned"] = "\uECE4";
  Glyphs["timeSig5"] = "\uE085";
  Glyphs["timeSig5Reversed"] = "\uECF5";
  Glyphs["timeSig5Turned"] = "\uECE5";
  Glyphs["timeSig6"] = "\uE086";
  Glyphs["timeSig6Reversed"] = "\uECF6";
  Glyphs["timeSig6Turned"] = "\uECE6";
  Glyphs["timeSig7"] = "\uE087";
  Glyphs["timeSig7Reversed"] = "\uECF7";
  Glyphs["timeSig7Turned"] = "\uECE7";
  Glyphs["timeSig8"] = "\uE088";
  Glyphs["timeSig8Reversed"] = "\uECF8";
  Glyphs["timeSig8Turned"] = "\uECE8";
  Glyphs["timeSig9"] = "\uE089";
  Glyphs["timeSig9Reversed"] = "\uECF9";
  Glyphs["timeSig9Turned"] = "\uECE9";
  Glyphs["timeSigBracketLeft"] = "\uEC80";
  Glyphs["timeSigBracketLeftSmall"] = "\uEC82";
  Glyphs["timeSigBracketRight"] = "\uEC81";
  Glyphs["timeSigBracketRightSmall"] = "\uEC83";
  Glyphs["timeSigCombDenominator"] = "\uE09F";
  Glyphs["timeSigCombNumerator"] = "\uE09E";
  Glyphs["timeSigComma"] = "\uE096";
  Glyphs["timeSigCommon"] = "\uE08A";
  Glyphs["timeSigCommonReversed"] = "\uECFA";
  Glyphs["timeSigCommonTurned"] = "\uECEA";
  Glyphs["timeSigCut2"] = "\uEC85";
  Glyphs["timeSigCut3"] = "\uEC86";
  Glyphs["timeSigCutCommon"] = "\uE08B";
  Glyphs["timeSigCutCommonReversed"] = "\uECFB";
  Glyphs["timeSigCutCommonTurned"] = "\uECEB";
  Glyphs["timeSigEquals"] = "\uE08F";
  Glyphs["timeSigFractionHalf"] = "\uE098";
  Glyphs["timeSigFractionOneThird"] = "\uE09A";
  Glyphs["timeSigFractionQuarter"] = "\uE097";
  Glyphs["timeSigFractionThreeQuarters"] = "\uE099";
  Glyphs["timeSigFractionTwoThirds"] = "\uE09B";
  Glyphs["timeSigFractionalSlash"] = "\uE08E";
  Glyphs["timeSigMinus"] = "\uE090";
  Glyphs["timeSigMultiply"] = "\uE091";
  Glyphs["timeSigOpenPenderecki"] = "\uE09D";
  Glyphs["timeSigParensLeft"] = "\uE094";
  Glyphs["timeSigParensLeftSmall"] = "\uE092";
  Glyphs["timeSigParensRight"] = "\uE095";
  Glyphs["timeSigParensRightSmall"] = "\uE093";
  Glyphs["timeSigPlus"] = "\uE08C";
  Glyphs["timeSigPlusSmall"] = "\uE08D";
  Glyphs["timeSigSlash"] = "\uEC84";
  Glyphs["timeSigX"] = "\uE09C";
  Glyphs["tremolo1"] = "\uE220";
  Glyphs["tremolo2"] = "\uE221";
  Glyphs["tremolo3"] = "\uE222";
  Glyphs["tremolo4"] = "\uE223";
  Glyphs["tremolo5"] = "\uE224";
  Glyphs["tremoloDivisiDots2"] = "\uE22E";
  Glyphs["tremoloDivisiDots3"] = "\uE22F";
  Glyphs["tremoloDivisiDots4"] = "\uE230";
  Glyphs["tremoloDivisiDots6"] = "\uE231";
  Glyphs["tremoloFingered1"] = "\uE225";
  Glyphs["tremoloFingered2"] = "\uE226";
  Glyphs["tremoloFingered3"] = "\uE227";
  Glyphs["tremoloFingered4"] = "\uE228";
  Glyphs["tremoloFingered5"] = "\uE229";
  Glyphs["tripleTongueAbove"] = "\uE5F2";
  Glyphs["tripleTongueBelow"] = "\uE5F3";
  Glyphs["tuplet0"] = "\uE880";
  Glyphs["tuplet1"] = "\uE881";
  Glyphs["tuplet2"] = "\uE882";
  Glyphs["tuplet3"] = "\uE883";
  Glyphs["tuplet4"] = "\uE884";
  Glyphs["tuplet5"] = "\uE885";
  Glyphs["tuplet6"] = "\uE886";
  Glyphs["tuplet7"] = "\uE887";
  Glyphs["tuplet8"] = "\uE888";
  Glyphs["tuplet9"] = "\uE889";
  Glyphs["tupletColon"] = "\uE88A";
  Glyphs["unmeasuredTremolo"] = "\uE22C";
  Glyphs["unmeasuredTremoloSimple"] = "\uE22D";
  Glyphs["unpitchedPercussionClef1"] = "\uE069";
  Glyphs["unpitchedPercussionClef2"] = "\uE06A";
  Glyphs["ventiduesima"] = "\uE517";
  Glyphs["ventiduesimaAlta"] = "\uE518";
  Glyphs["ventiduesimaBassa"] = "\uE519";
  Glyphs["ventiduesimaBassaMb"] = "\uE51E";
  Glyphs["vocalFingerClickStockhausen"] = "\uE649";
  Glyphs["vocalHalbGesungen"] = "\uE64B";
  Glyphs["vocalMouthClosed"] = "\uE640";
  Glyphs["vocalMouthOpen"] = "\uE642";
  Glyphs["vocalMouthPursed"] = "\uE644";
  Glyphs["vocalMouthSlightlyOpen"] = "\uE641";
  Glyphs["vocalMouthWideOpen"] = "\uE643";
  Glyphs["vocalNasalVoice"] = "\uE647";
  Glyphs["vocalSprechgesang"] = "\uE645";
  Glyphs["vocalTongueClickStockhausen"] = "\uE648";
  Glyphs["vocalTongueFingerClickStockhausen"] = "\uE64A";
  Glyphs["vocalsSussurando"] = "\uE646";
  Glyphs["wiggleArpeggiatoDown"] = "\uEAAA";
  Glyphs["wiggleArpeggiatoDownArrow"] = "\uEAAE";
  Glyphs["wiggleArpeggiatoDownSwash"] = "\uEAAC";
  Glyphs["wiggleArpeggiatoUp"] = "\uEAA9";
  Glyphs["wiggleArpeggiatoUpArrow"] = "\uEAAD";
  Glyphs["wiggleArpeggiatoUpSwash"] = "\uEAAB";
  Glyphs["wiggleCircular"] = "\uEAC9";
  Glyphs["wiggleCircularConstant"] = "\uEAC0";
  Glyphs["wiggleCircularConstantFlipped"] = "\uEAC1";
  Glyphs["wiggleCircularConstantFlippedLarge"] = "\uEAC3";
  Glyphs["wiggleCircularConstantLarge"] = "\uEAC2";
  Glyphs["wiggleCircularEnd"] = "\uEACB";
  Glyphs["wiggleCircularLarge"] = "\uEAC8";
  Glyphs["wiggleCircularLarger"] = "\uEAC7";
  Glyphs["wiggleCircularLargerStill"] = "\uEAC6";
  Glyphs["wiggleCircularLargest"] = "\uEAC5";
  Glyphs["wiggleCircularSmall"] = "\uEACA";
  Glyphs["wiggleCircularStart"] = "\uEAC4";
  Glyphs["wiggleGlissando"] = "\uEAAF";
  Glyphs["wiggleGlissandoGroup1"] = "\uEABD";
  Glyphs["wiggleGlissandoGroup2"] = "\uEABE";
  Glyphs["wiggleGlissandoGroup3"] = "\uEABF";
  Glyphs["wiggleRandom1"] = "\uEAF0";
  Glyphs["wiggleRandom2"] = "\uEAF1";
  Glyphs["wiggleRandom3"] = "\uEAF2";
  Glyphs["wiggleRandom4"] = "\uEAF3";
  Glyphs["wiggleSawtooth"] = "\uEABB";
  Glyphs["wiggleSawtoothNarrow"] = "\uEABA";
  Glyphs["wiggleSawtoothWide"] = "\uEABC";
  Glyphs["wiggleSquareWave"] = "\uEAB8";
  Glyphs["wiggleSquareWaveNarrow"] = "\uEAB7";
  Glyphs["wiggleSquareWaveWide"] = "\uEAB9";
  Glyphs["wiggleTrill"] = "\uEAA4";
  Glyphs["wiggleTrillFast"] = "\uEAA3";
  Glyphs["wiggleTrillFaster"] = "\uEAA2";
  Glyphs["wiggleTrillFasterStill"] = "\uEAA1";
  Glyphs["wiggleTrillFastest"] = "\uEAA0";
  Glyphs["wiggleTrillSlow"] = "\uEAA5";
  Glyphs["wiggleTrillSlower"] = "\uEAA6";
  Glyphs["wiggleTrillSlowerStill"] = "\uEAA7";
  Glyphs["wiggleTrillSlowest"] = "\uEAA8";
  Glyphs["wiggleVIbratoLargestSlower"] = "\uEAEE";
  Glyphs["wiggleVIbratoMediumSlower"] = "\uEAE0";
  Glyphs["wiggleVibrato"] = "\uEAB0";
  Glyphs["wiggleVibratoLargeFast"] = "\uEAE5";
  Glyphs["wiggleVibratoLargeFaster"] = "\uEAE4";
  Glyphs["wiggleVibratoLargeFasterStill"] = "\uEAE3";
  Glyphs["wiggleVibratoLargeFastest"] = "\uEAE2";
  Glyphs["wiggleVibratoLargeSlow"] = "\uEAE6";
  Glyphs["wiggleVibratoLargeSlower"] = "\uEAE7";
  Glyphs["wiggleVibratoLargeSlowest"] = "\uEAE8";
  Glyphs["wiggleVibratoLargestFast"] = "\uEAEC";
  Glyphs["wiggleVibratoLargestFaster"] = "\uEAEB";
  Glyphs["wiggleVibratoLargestFasterStill"] = "\uEAEA";
  Glyphs["wiggleVibratoLargestFastest"] = "\uEAE9";
  Glyphs["wiggleVibratoLargestSlow"] = "\uEAED";
  Glyphs["wiggleVibratoLargestSlowest"] = "\uEAEF";
  Glyphs["wiggleVibratoMediumFast"] = "\uEADE";
  Glyphs["wiggleVibratoMediumFaster"] = "\uEADD";
  Glyphs["wiggleVibratoMediumFasterStill"] = "\uEADC";
  Glyphs["wiggleVibratoMediumFastest"] = "\uEADB";
  Glyphs["wiggleVibratoMediumSlow"] = "\uEADF";
  Glyphs["wiggleVibratoMediumSlowest"] = "\uEAE1";
  Glyphs["wiggleVibratoSmallFast"] = "\uEAD7";
  Glyphs["wiggleVibratoSmallFaster"] = "\uEAD6";
  Glyphs["wiggleVibratoSmallFasterStill"] = "\uEAD5";
  Glyphs["wiggleVibratoSmallFastest"] = "\uEAD4";
  Glyphs["wiggleVibratoSmallSlow"] = "\uEAD8";
  Glyphs["wiggleVibratoSmallSlower"] = "\uEAD9";
  Glyphs["wiggleVibratoSmallSlowest"] = "\uEADA";
  Glyphs["wiggleVibratoSmallestFast"] = "\uEAD0";
  Glyphs["wiggleVibratoSmallestFaster"] = "\uEACF";
  Glyphs["wiggleVibratoSmallestFasterStill"] = "\uEACE";
  Glyphs["wiggleVibratoSmallestFastest"] = "\uEACD";
  Glyphs["wiggleVibratoSmallestSlow"] = "\uEAD1";
  Glyphs["wiggleVibratoSmallestSlower"] = "\uEAD2";
  Glyphs["wiggleVibratoSmallestSlowest"] = "\uEAD3";
  Glyphs["wiggleVibratoStart"] = "\uEACC";
  Glyphs["wiggleVibratoWide"] = "\uEAB1";
  Glyphs["wiggleWavy"] = "\uEAB5";
  Glyphs["wiggleWavyNarrow"] = "\uEAB4";
  Glyphs["wiggleWavyWide"] = "\uEAB6";
  Glyphs["windClosedHole"] = "\uE5F4";
  Glyphs["windFlatEmbouchure"] = "\uE5FB";
  Glyphs["windHalfClosedHole1"] = "\uE5F6";
  Glyphs["windHalfClosedHole2"] = "\uE5F7";
  Glyphs["windHalfClosedHole3"] = "\uE5F8";
  Glyphs["windLessRelaxedEmbouchure"] = "\uE5FE";
  Glyphs["windLessTightEmbouchure"] = "\uE600";
  Glyphs["windMouthpiecePop"] = "\uE60A";
  Glyphs["windMultiphonicsBlackStem"] = "\uE607";
  Glyphs["windMultiphonicsBlackWhiteStem"] = "\uE609";
  Glyphs["windMultiphonicsWhiteStem"] = "\uE608";
  Glyphs["windOpenHole"] = "\uE5F9";
  Glyphs["windReedPositionIn"] = "\uE606";
  Glyphs["windReedPositionNormal"] = "\uE604";
  Glyphs["windReedPositionOut"] = "\uE605";
  Glyphs["windRelaxedEmbouchure"] = "\uE5FD";
  Glyphs["windRimOnly"] = "\uE60B";
  Glyphs["windSharpEmbouchure"] = "\uE5FC";
  Glyphs["windStrongAirPressure"] = "\uE603";
  Glyphs["windThreeQuartersClosedHole"] = "\uE5F5";
  Glyphs["windTightEmbouchure"] = "\uE5FF";
  Glyphs["windTrillKey"] = "\uE5FA";
  Glyphs["windVeryTightEmbouchure"] = "\uE601";
  Glyphs["windWeakAirPressure"] = "\uE602";
})(Glyphs || (Glyphs = {}));
